import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

      export type PossibleTypesResultData = {
  "possibleTypes": {
    "GenericMorph": [
      "ActivityLog",
      "AdminConfig",
      "AuthorisationPage",
      "Certificate",
      "CommentLike",
      "ComponentCourseComponentsCourseChapterFile",
      "ComponentCourseComponentsCourseChapterImage",
      "ComponentCourseComponentsCourseChapterImageContent",
      "ComponentCourseComponentsCourseChapterImageContentColumn",
      "ComponentCourseComponentsCourseChapterImageItem",
      "ComponentCourseComponentsCourseChapterPodcast",
      "ComponentCourseComponentsCourseChapterQuiz",
      "ComponentCourseComponentsCourseChapterQuizFillQuestion",
      "ComponentCourseComponentsCourseChapterQuizFillQuestionBlank",
      "ComponentCourseComponentsCourseChapterQuizFillQuestionEntry",
      "ComponentCourseComponentsCourseChapterQuizFillQuestionEntrySegment",
      "ComponentCourseComponentsCourseChapterQuizQuestion",
      "ComponentCourseComponentsCourseChapterQuizQuestionAnswer",
      "ComponentCourseComponentsCourseChapterResult",
      "ComponentCourseComponentsCourseChapterText",
      "ComponentCourseComponentsCourseChapterTextContent",
      "ComponentCourseComponentsCourseChapterVideo",
      "ComponentCourseComponentsCourseKey",
      "ComponentCourseComponentsCourseResult",
      "ComponentPostComponentsPostDescription",
      "ComponentPostComponentsPostThumbnail",
      "ComponentUiTextComponent",
      "ComponentUserComponentsFcmSettings",
      "ComponentUserComponentsUserRole",
      "Country",
      "Course",
      "CourseAuthor",
      "CourseCategory",
      "CourseChapter",
      "CourseStudent",
      "EmailTemplate",
      "Event",
      "I18NLocale",
      "MasterNotificationCustom",
      "Notification",
      "Post",
      "PostCategory",
      "PostComment",
      "PostLike",
      "PrivacyPolicyPage",
      "Program",
      "ProgramCategory",
      "Region",
      "ReviewWorkflowsWorkflow",
      "ReviewWorkflowsWorkflowStage",
      "TermsPage",
      "UploadFile",
      "UserEntry",
      "UsersPermissionsPermission",
      "UsersPermissionsRole",
      "UsersPermissionsUser"
    ]
  }
};
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "GenericMorph": [
      "ActivityLog",
      "AdminConfig",
      "AuthorisationPage",
      "Certificate",
      "CommentLike",
      "ComponentCourseComponentsCourseChapterFile",
      "ComponentCourseComponentsCourseChapterImage",
      "ComponentCourseComponentsCourseChapterImageContent",
      "ComponentCourseComponentsCourseChapterImageContentColumn",
      "ComponentCourseComponentsCourseChapterImageItem",
      "ComponentCourseComponentsCourseChapterPodcast",
      "ComponentCourseComponentsCourseChapterQuiz",
      "ComponentCourseComponentsCourseChapterQuizFillQuestion",
      "ComponentCourseComponentsCourseChapterQuizFillQuestionBlank",
      "ComponentCourseComponentsCourseChapterQuizFillQuestionEntry",
      "ComponentCourseComponentsCourseChapterQuizFillQuestionEntrySegment",
      "ComponentCourseComponentsCourseChapterQuizQuestion",
      "ComponentCourseComponentsCourseChapterQuizQuestionAnswer",
      "ComponentCourseComponentsCourseChapterResult",
      "ComponentCourseComponentsCourseChapterText",
      "ComponentCourseComponentsCourseChapterTextContent",
      "ComponentCourseComponentsCourseChapterVideo",
      "ComponentCourseComponentsCourseKey",
      "ComponentCourseComponentsCourseResult",
      "ComponentPostComponentsPostDescription",
      "ComponentPostComponentsPostThumbnail",
      "ComponentUiTextComponent",
      "ComponentUserComponentsFcmSettings",
      "ComponentUserComponentsUserRole",
      "Country",
      "Course",
      "CourseAuthor",
      "CourseCategory",
      "CourseChapter",
      "CourseStudent",
      "EmailTemplate",
      "Event",
      "I18NLocale",
      "MasterNotificationCustom",
      "Notification",
      "Post",
      "PostCategory",
      "PostComment",
      "PostLike",
      "PrivacyPolicyPage",
      "Program",
      "ProgramCategory",
      "Region",
      "ReviewWorkflowsWorkflow",
      "ReviewWorkflowsWorkflowStage",
      "TermsPage",
      "UploadFile",
      "UserEntry",
      "UsersPermissionsPermission",
      "UsersPermissionsRole",
      "UsersPermissionsUser"
    ]
  }
};
      export default result;
    
export const ActivityLogFragmentDoc = gql`
    fragment ActivityLog on ActivityLog {
  documentId
  model
  action
  target
  user {
    documentId
    firstName
    lastName
    role {
      documentId
      name
    }
  }
  updatedAt
}
    `;
export const PostBaseFragmentDoc = gql`
    fragment PostBase on Post {
  createdAt
  updatedAt
  documentId
  title
  description {
    language
    text
  }
  category {
    documentId
    label
  }
  regions {
    documentId
    name
    abbreviation
  }
  roles {
    role
  }
  launchDate
  timeZone
  comments {
    documentId
    createdAt
    title
    sender {
      user {
        documentId
        firstName
        lastName
      }
    }
  }
  thumbnails {
    image {
      documentId
      url
    }
    video
  }
  author {
    documentId
    firstName
    lastName
    avatar {
      url
    }
  }
  likesByMeId
  likesCount
  likes {
    sender {
      id
      lastName
      firstName
      avatar {
        url
      }
    }
  }
  commentsCount
  currentStatus
}
    `;
export const ProgramFragmentDoc = gql`
    fragment Program on Program {
  documentId
  title
  cover {
    documentId
    url
  }
  category {
    documentId
    label
  }
  type
  description
  lockOrder
  autoAssign
  courses {
    documentId
    title
    description
    autoAssign
    deleted
  }
  students {
    documentId
    user {
      firstName
      lastName
    }
  }
  active
  createdAt
  deleted
}
    `;
export const ProgramSummaryFragmentDoc = gql`
    fragment ProgramSummary on MyProgramsPrograms {
  documentId
  title
  cover {
    documentId
    url
  }
  category {
    documentId
    label
  }
  type
  description
  lockOrder
  autoAssign
  courses {
    documentId
    title
    description
    autoAssign
    deleted
  }
  students {
    documentId
    user {
      firstName
      lastName
    }
  }
  active
  createdAt
  deleted
  doneCourses
}
    `;
export const AllowEmailDocument = gql`
    mutation allowEmail($id: ID!, $isEmailRecipient: Boolean!) {
  updateUsersPermissionsUser(id: $id, data: {isEmailRecipient: $isEmailRecipient}) {
    data {
      isEmailRecipient
    }
  }
}
    `;
export type AllowEmailMutationFn = Apollo.MutationFunction<AllowEmailMutation, AllowEmailMutationVariables>;
export function useAllowEmailMutation(baseOptions?: Apollo.MutationHookOptions<AllowEmailMutation, AllowEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AllowEmailMutation, AllowEmailMutationVariables>(AllowEmailDocument, options);
      }
export type AllowEmailMutationHookResult = ReturnType<typeof useAllowEmailMutation>;
export type AllowEmailMutationResult = Apollo.MutationResult<AllowEmailMutation>;
export const AllowSmsDocument = gql`
    mutation allowSms($id: ID!, $isSmsRecipient: Boolean!) {
  updateUsersPermissionsUser(id: $id, data: {isSmsRecipient: $isSmsRecipient}) {
    data {
      isSmsRecipient
    }
  }
}
    `;
export type AllowSmsMutationFn = Apollo.MutationFunction<AllowSmsMutation, AllowSmsMutationVariables>;
export function useAllowSmsMutation(baseOptions?: Apollo.MutationHookOptions<AllowSmsMutation, AllowSmsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AllowSmsMutation, AllowSmsMutationVariables>(AllowSmsDocument, options);
      }
export type AllowSmsMutationHookResult = ReturnType<typeof useAllowSmsMutation>;
export type AllowSmsMutationResult = Apollo.MutationResult<AllowSmsMutation>;
export const AssignStudentsDocument = gql`
    mutation assignStudents($studentsId: [String!]!, $courseId: String!) {
  assignStudents(input: {courseId: $courseId, studentsId: $studentsId}) {
    success
  }
}
    `;
export type AssignStudentsMutationFn = Apollo.MutationFunction<AssignStudentsMutation, AssignStudentsMutationVariables>;
export function useAssignStudentsMutation(baseOptions?: Apollo.MutationHookOptions<AssignStudentsMutation, AssignStudentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignStudentsMutation, AssignStudentsMutationVariables>(AssignStudentsDocument, options);
      }
export type AssignStudentsMutationHookResult = ReturnType<typeof useAssignStudentsMutation>;
export type AssignStudentsMutationResult = Apollo.MutationResult<AssignStudentsMutation>;
export const CreateCourseDocument = gql`
    mutation createCourse($input: CreateCourseInput!) {
  createCourse(input: $input) {
    id
    success
  }
}
    `;
export type CreateCourseMutationFn = Apollo.MutationFunction<CreateCourseMutation, CreateCourseMutationVariables>;
export function useCreateCourseMutation(baseOptions?: Apollo.MutationHookOptions<CreateCourseMutation, CreateCourseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCourseMutation, CreateCourseMutationVariables>(CreateCourseDocument, options);
      }
export type CreateCourseMutationHookResult = ReturnType<typeof useCreateCourseMutation>;
export type CreateCourseMutationResult = Apollo.MutationResult<CreateCourseMutation>;
export const CreateCourseCategoryDocument = gql`
    mutation createCourseCategory($input: CourseCategoryInput!) {
  createCourseCategory(data: $input) {
    documentId
  }
}
    `;
export type CreateCourseCategoryMutationFn = Apollo.MutationFunction<CreateCourseCategoryMutation, CreateCourseCategoryMutationVariables>;
export function useCreateCourseCategoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateCourseCategoryMutation, CreateCourseCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCourseCategoryMutation, CreateCourseCategoryMutationVariables>(CreateCourseCategoryDocument, options);
      }
export type CreateCourseCategoryMutationHookResult = ReturnType<typeof useCreateCourseCategoryMutation>;
export type CreateCourseCategoryMutationResult = Apollo.MutationResult<CreateCourseCategoryMutation>;
export const CreateMasterNotificationCustomDocument = gql`
    mutation CreateMasterNotificationCustom($data: MasterNotificationCustomInput!) {
  createMasterNotificationCustom(data: $data) {
    documentId
  }
}
    `;
export type CreateMasterNotificationCustomMutationFn = Apollo.MutationFunction<CreateMasterNotificationCustomMutation, CreateMasterNotificationCustomMutationVariables>;
export function useCreateMasterNotificationCustomMutation(baseOptions?: Apollo.MutationHookOptions<CreateMasterNotificationCustomMutation, CreateMasterNotificationCustomMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMasterNotificationCustomMutation, CreateMasterNotificationCustomMutationVariables>(CreateMasterNotificationCustomDocument, options);
      }
export type CreateMasterNotificationCustomMutationHookResult = ReturnType<typeof useCreateMasterNotificationCustomMutation>;
export type CreateMasterNotificationCustomMutationResult = Apollo.MutationResult<CreateMasterNotificationCustomMutation>;
export const CreatePostDocument = gql`
    mutation createPost($input: PostInput!) {
  createPost(data: $input) {
    documentId
  }
}
    `;
export type CreatePostMutationFn = Apollo.MutationFunction<CreatePostMutation, CreatePostMutationVariables>;
export function useCreatePostMutation(baseOptions?: Apollo.MutationHookOptions<CreatePostMutation, CreatePostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePostMutation, CreatePostMutationVariables>(CreatePostDocument, options);
      }
export type CreatePostMutationHookResult = ReturnType<typeof useCreatePostMutation>;
export type CreatePostMutationResult = Apollo.MutationResult<CreatePostMutation>;
export const CreatePostCategoryDocument = gql`
    mutation createPostCategory($input: PostCategoryInput!) {
  createPostCategory(data: $input) {
    documentId
  }
}
    `;
export type CreatePostCategoryMutationFn = Apollo.MutationFunction<CreatePostCategoryMutation, CreatePostCategoryMutationVariables>;
export function useCreatePostCategoryMutation(baseOptions?: Apollo.MutationHookOptions<CreatePostCategoryMutation, CreatePostCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePostCategoryMutation, CreatePostCategoryMutationVariables>(CreatePostCategoryDocument, options);
      }
export type CreatePostCategoryMutationHookResult = ReturnType<typeof useCreatePostCategoryMutation>;
export type CreatePostCategoryMutationResult = Apollo.MutationResult<CreatePostCategoryMutation>;
export const CreatePostCommentDocument = gql`
    mutation CreatePostComment($data: PostCommentInput!) {
  createPostComment(data: $data) {
    title
  }
}
    `;
export type CreatePostCommentMutationFn = Apollo.MutationFunction<CreatePostCommentMutation, CreatePostCommentMutationVariables>;
export function useCreatePostCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreatePostCommentMutation, CreatePostCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePostCommentMutation, CreatePostCommentMutationVariables>(CreatePostCommentDocument, options);
      }
export type CreatePostCommentMutationHookResult = ReturnType<typeof useCreatePostCommentMutation>;
export type CreatePostCommentMutationResult = Apollo.MutationResult<CreatePostCommentMutation>;
export const DeleteCommentDocument = gql`
    mutation deleteComment($documentId: ID!) {
  deletePostComment(documentId: $documentId) {
    documentId
  }
}
    `;
export type DeleteCommentMutationFn = Apollo.MutationFunction<DeleteCommentMutation, DeleteCommentMutationVariables>;
export function useDeleteCommentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCommentMutation, DeleteCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCommentMutation, DeleteCommentMutationVariables>(DeleteCommentDocument, options);
      }
export type DeleteCommentMutationHookResult = ReturnType<typeof useDeleteCommentMutation>;
export type DeleteCommentMutationResult = Apollo.MutationResult<DeleteCommentMutation>;
export const DeleteCourseCategoryDocument = gql`
    mutation deleteCourseCategory($id: ID!) {
  deleteCourseCategory(documentId: $id) {
    documentId
  }
}
    `;
export type DeleteCourseCategoryMutationFn = Apollo.MutationFunction<DeleteCourseCategoryMutation, DeleteCourseCategoryMutationVariables>;
export function useDeleteCourseCategoryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCourseCategoryMutation, DeleteCourseCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCourseCategoryMutation, DeleteCourseCategoryMutationVariables>(DeleteCourseCategoryDocument, options);
      }
export type DeleteCourseCategoryMutationHookResult = ReturnType<typeof useDeleteCourseCategoryMutation>;
export type DeleteCourseCategoryMutationResult = Apollo.MutationResult<DeleteCourseCategoryMutation>;
export const DeletePostDocument = gql`
    mutation deletePost($documentId: ID!) {
  deletePost(documentId: $documentId) {
    documentId
  }
}
    `;
export type DeletePostMutationFn = Apollo.MutationFunction<DeletePostMutation, DeletePostMutationVariables>;
export function useDeletePostMutation(baseOptions?: Apollo.MutationHookOptions<DeletePostMutation, DeletePostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePostMutation, DeletePostMutationVariables>(DeletePostDocument, options);
      }
export type DeletePostMutationHookResult = ReturnType<typeof useDeletePostMutation>;
export type DeletePostMutationResult = Apollo.MutationResult<DeletePostMutation>;
export const DeletePostCategoryDocument = gql`
    mutation deletePostCategory($id: ID!) {
  deletePostCategory(documentId: $id) {
    documentId
  }
}
    `;
export type DeletePostCategoryMutationFn = Apollo.MutationFunction<DeletePostCategoryMutation, DeletePostCategoryMutationVariables>;
export function useDeletePostCategoryMutation(baseOptions?: Apollo.MutationHookOptions<DeletePostCategoryMutation, DeletePostCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePostCategoryMutation, DeletePostCategoryMutationVariables>(DeletePostCategoryDocument, options);
      }
export type DeletePostCategoryMutationHookResult = ReturnType<typeof useDeletePostCategoryMutation>;
export type DeletePostCategoryMutationResult = Apollo.MutationResult<DeletePostCategoryMutation>;
export const DeletePostsDocument = gql`
    mutation deletePosts($posts: DeletePostsInput!) {
  deletePosts(input: $posts) {
    success
  }
}
    `;
export type DeletePostsMutationFn = Apollo.MutationFunction<DeletePostsMutation, DeletePostsMutationVariables>;
export function useDeletePostsMutation(baseOptions?: Apollo.MutationHookOptions<DeletePostsMutation, DeletePostsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePostsMutation, DeletePostsMutationVariables>(DeletePostsDocument, options);
      }
export type DeletePostsMutationHookResult = ReturnType<typeof useDeletePostsMutation>;
export type DeletePostsMutationResult = Apollo.MutationResult<DeletePostsMutation>;
export const DeleteUserAccountDocument = gql`
    mutation deleteUserAccount($input: DeleteUserAccountInput!) {
  deleteUserAccount(input: $input) {
    success
  }
}
    `;
export type DeleteUserAccountMutationFn = Apollo.MutationFunction<DeleteUserAccountMutation, DeleteUserAccountMutationVariables>;
export function useDeleteUserAccountMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserAccountMutation, DeleteUserAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserAccountMutation, DeleteUserAccountMutationVariables>(DeleteUserAccountDocument, options);
      }
export type DeleteUserAccountMutationHookResult = ReturnType<typeof useDeleteUserAccountMutation>;
export type DeleteUserAccountMutationResult = Apollo.MutationResult<DeleteUserAccountMutation>;
export const EditCourseDocument = gql`
    mutation editCourse($input: EditCourseInput!) {
  editCourse(input: $input) {
    id
    success
  }
}
    `;
export type EditCourseMutationFn = Apollo.MutationFunction<EditCourseMutation, EditCourseMutationVariables>;
export function useEditCourseMutation(baseOptions?: Apollo.MutationHookOptions<EditCourseMutation, EditCourseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditCourseMutation, EditCourseMutationVariables>(EditCourseDocument, options);
      }
export type EditCourseMutationHookResult = ReturnType<typeof useEditCourseMutation>;
export type EditCourseMutationResult = Apollo.MutationResult<EditCourseMutation>;
export const EditPostDocument = gql`
    mutation editPost($documentId: ID!, $data: PostInput!) {
  updatePost(documentId: $documentId, data: $data) {
    documentId
  }
}
    `;
export type EditPostMutationFn = Apollo.MutationFunction<EditPostMutation, EditPostMutationVariables>;
export function useEditPostMutation(baseOptions?: Apollo.MutationHookOptions<EditPostMutation, EditPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditPostMutation, EditPostMutationVariables>(EditPostDocument, options);
      }
export type EditPostMutationHookResult = ReturnType<typeof useEditPostMutation>;
export type EditPostMutationResult = Apollo.MutationResult<EditPostMutation>;
export const EditUserDocument = gql`
    mutation editUser($input: EditUserInput!) {
  editUser(input: $input) {
    id
    success
  }
}
    `;
export type EditUserMutationFn = Apollo.MutationFunction<EditUserMutation, EditUserMutationVariables>;
export function useEditUserMutation(baseOptions?: Apollo.MutationHookOptions<EditUserMutation, EditUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditUserMutation, EditUserMutationVariables>(EditUserDocument, options);
      }
export type EditUserMutationHookResult = ReturnType<typeof useEditUserMutation>;
export type EditUserMutationResult = Apollo.MutationResult<EditUserMutation>;
export const CreateLikeToPostDocument = gql`
    mutation createLikeToPost($postId: String!) {
  createLikeToPost(input: {postId: $postId}) {
    __typename
    id
    success
  }
}
    `;
export type CreateLikeToPostMutationFn = Apollo.MutationFunction<CreateLikeToPostMutation, CreateLikeToPostMutationVariables>;
export function useCreateLikeToPostMutation(baseOptions?: Apollo.MutationHookOptions<CreateLikeToPostMutation, CreateLikeToPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLikeToPostMutation, CreateLikeToPostMutationVariables>(CreateLikeToPostDocument, options);
      }
export type CreateLikeToPostMutationHookResult = ReturnType<typeof useCreateLikeToPostMutation>;
export type CreateLikeToPostMutationResult = Apollo.MutationResult<CreateLikeToPostMutation>;
export const AssignStudentsToProgramDocument = gql`
    mutation assignStudentsToProgram($input: AssignStudentsToProgramInput!) {
  assignStudentsToProgram(input: $input) {
    success
  }
}
    `;
export type AssignStudentsToProgramMutationFn = Apollo.MutationFunction<AssignStudentsToProgramMutation, AssignStudentsToProgramMutationVariables>;
export function useAssignStudentsToProgramMutation(baseOptions?: Apollo.MutationHookOptions<AssignStudentsToProgramMutation, AssignStudentsToProgramMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignStudentsToProgramMutation, AssignStudentsToProgramMutationVariables>(AssignStudentsToProgramDocument, options);
      }
export type AssignStudentsToProgramMutationHookResult = ReturnType<typeof useAssignStudentsToProgramMutation>;
export type AssignStudentsToProgramMutationResult = Apollo.MutationResult<AssignStudentsToProgramMutation>;
export const CreateProgramDocument = gql`
    mutation createProgram($input: CreateProgramInput!) {
  createProgram(input: $input) {
    id
    success
  }
}
    `;
export type CreateProgramMutationFn = Apollo.MutationFunction<CreateProgramMutation, CreateProgramMutationVariables>;
export function useCreateProgramMutation(baseOptions?: Apollo.MutationHookOptions<CreateProgramMutation, CreateProgramMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProgramMutation, CreateProgramMutationVariables>(CreateProgramDocument, options);
      }
export type CreateProgramMutationHookResult = ReturnType<typeof useCreateProgramMutation>;
export type CreateProgramMutationResult = Apollo.MutationResult<CreateProgramMutation>;
export const CreateProgramCategoryDocument = gql`
    mutation createProgramCategory($input: ProgramCategoryInput!) {
  createProgramCategory(data: $input) {
    documentId
  }
}
    `;
export type CreateProgramCategoryMutationFn = Apollo.MutationFunction<CreateProgramCategoryMutation, CreateProgramCategoryMutationVariables>;
export function useCreateProgramCategoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateProgramCategoryMutation, CreateProgramCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProgramCategoryMutation, CreateProgramCategoryMutationVariables>(CreateProgramCategoryDocument, options);
      }
export type CreateProgramCategoryMutationHookResult = ReturnType<typeof useCreateProgramCategoryMutation>;
export type CreateProgramCategoryMutationResult = Apollo.MutationResult<CreateProgramCategoryMutation>;
export const DeleteProgramDocument = gql`
    mutation deleteProgram($id: ID!) {
  deleteProgram(documentId: $id) {
    documentId
  }
}
    `;
export type DeleteProgramMutationFn = Apollo.MutationFunction<DeleteProgramMutation, DeleteProgramMutationVariables>;
export function useDeleteProgramMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProgramMutation, DeleteProgramMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProgramMutation, DeleteProgramMutationVariables>(DeleteProgramDocument, options);
      }
export type DeleteProgramMutationHookResult = ReturnType<typeof useDeleteProgramMutation>;
export type DeleteProgramMutationResult = Apollo.MutationResult<DeleteProgramMutation>;
export const DeleteProgramCategoryDocument = gql`
    mutation deleteProgramCategory($id: ID!) {
  deleteProgramCategory(documentId: $id) {
    documentId
  }
}
    `;
export type DeleteProgramCategoryMutationFn = Apollo.MutationFunction<DeleteProgramCategoryMutation, DeleteProgramCategoryMutationVariables>;
export function useDeleteProgramCategoryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProgramCategoryMutation, DeleteProgramCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProgramCategoryMutation, DeleteProgramCategoryMutationVariables>(DeleteProgramCategoryDocument, options);
      }
export type DeleteProgramCategoryMutationHookResult = ReturnType<typeof useDeleteProgramCategoryMutation>;
export type DeleteProgramCategoryMutationResult = Apollo.MutationResult<DeleteProgramCategoryMutation>;
export const UnassignStudentsFromProgramDocument = gql`
    mutation unassignStudentsFromProgram($input: UnassignStudentsFromProgramInput!) {
  unassignStudentsFromProgram(input: $input) {
    success
  }
}
    `;
export type UnassignStudentsFromProgramMutationFn = Apollo.MutationFunction<UnassignStudentsFromProgramMutation, UnassignStudentsFromProgramMutationVariables>;
export function useUnassignStudentsFromProgramMutation(baseOptions?: Apollo.MutationHookOptions<UnassignStudentsFromProgramMutation, UnassignStudentsFromProgramMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnassignStudentsFromProgramMutation, UnassignStudentsFromProgramMutationVariables>(UnassignStudentsFromProgramDocument, options);
      }
export type UnassignStudentsFromProgramMutationHookResult = ReturnType<typeof useUnassignStudentsFromProgramMutation>;
export type UnassignStudentsFromProgramMutationResult = Apollo.MutationResult<UnassignStudentsFromProgramMutation>;
export const UpdateManyProgramsDocument = gql`
    mutation updateManyPrograms($input: UpdateManyProgramsInput!) {
  updateManyPrograms(input: $input) {
    success
  }
}
    `;
export type UpdateManyProgramsMutationFn = Apollo.MutationFunction<UpdateManyProgramsMutation, UpdateManyProgramsMutationVariables>;
export function useUpdateManyProgramsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateManyProgramsMutation, UpdateManyProgramsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateManyProgramsMutation, UpdateManyProgramsMutationVariables>(UpdateManyProgramsDocument, options);
      }
export type UpdateManyProgramsMutationHookResult = ReturnType<typeof useUpdateManyProgramsMutation>;
export type UpdateManyProgramsMutationResult = Apollo.MutationResult<UpdateManyProgramsMutation>;
export const UpdateProgramDocument = gql`
    mutation updateProgram($input: UpdateProgramInput!) {
  updateProgram(input: $input) {
    id
    success
  }
}
    `;
export type UpdateProgramMutationFn = Apollo.MutationFunction<UpdateProgramMutation, UpdateProgramMutationVariables>;
export function useUpdateProgramMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProgramMutation, UpdateProgramMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProgramMutation, UpdateProgramMutationVariables>(UpdateProgramDocument, options);
      }
export type UpdateProgramMutationHookResult = ReturnType<typeof useUpdateProgramMutation>;
export type UpdateProgramMutationResult = Apollo.MutationResult<UpdateProgramMutation>;
export const UpdateProgramCoursesDocument = gql`
    mutation UpdateProgramCourses($input: UpdateProgramCoursesInput!) {
  updateProgramCourses(input: $input) {
    success
  }
}
    `;
export type UpdateProgramCoursesMutationFn = Apollo.MutationFunction<UpdateProgramCoursesMutation, UpdateProgramCoursesMutationVariables>;
export function useUpdateProgramCoursesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProgramCoursesMutation, UpdateProgramCoursesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProgramCoursesMutation, UpdateProgramCoursesMutationVariables>(UpdateProgramCoursesDocument, options);
      }
export type UpdateProgramCoursesMutationHookResult = ReturnType<typeof useUpdateProgramCoursesMutation>;
export type UpdateProgramCoursesMutationResult = Apollo.MutationResult<UpdateProgramCoursesMutation>;
export const TranslateTextDocument = gql`
    mutation translateText($input: TranslateTextInput!) {
  translateText(input: $input) {
    blocks {
      text
      language
    }
  }
}
    `;
export type TranslateTextMutationFn = Apollo.MutationFunction<TranslateTextMutation, TranslateTextMutationVariables>;
export function useTranslateTextMutation(baseOptions?: Apollo.MutationHookOptions<TranslateTextMutation, TranslateTextMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TranslateTextMutation, TranslateTextMutationVariables>(TranslateTextDocument, options);
      }
export type TranslateTextMutationHookResult = ReturnType<typeof useTranslateTextMutation>;
export type TranslateTextMutationResult = Apollo.MutationResult<TranslateTextMutation>;
export const UnassignStudentsDocument = gql`
    mutation unassignStudents($input: UnassignStudentsInput!) {
  unassignStudents(input: $input) {
    success
  }
}
    `;
export type UnassignStudentsMutationFn = Apollo.MutationFunction<UnassignStudentsMutation, UnassignStudentsMutationVariables>;
export function useUnassignStudentsMutation(baseOptions?: Apollo.MutationHookOptions<UnassignStudentsMutation, UnassignStudentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnassignStudentsMutation, UnassignStudentsMutationVariables>(UnassignStudentsDocument, options);
      }
export type UnassignStudentsMutationHookResult = ReturnType<typeof useUnassignStudentsMutation>;
export type UnassignStudentsMutationResult = Apollo.MutationResult<UnassignStudentsMutation>;
export const UnlikeDocument = gql`
    mutation unlike($id: ID!) {
  deletePostLike(documentId: $id) {
    __typename
    documentId
  }
}
    `;
export type UnlikeMutationFn = Apollo.MutationFunction<UnlikeMutation, UnlikeMutationVariables>;
export function useUnlikeMutation(baseOptions?: Apollo.MutationHookOptions<UnlikeMutation, UnlikeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlikeMutation, UnlikeMutationVariables>(UnlikeDocument, options);
      }
export type UnlikeMutationHookResult = ReturnType<typeof useUnlikeMutation>;
export type UnlikeMutationResult = Apollo.MutationResult<UnlikeMutation>;
export const UpdateNotificationDocument = gql`
    mutation updateNotification($documentId: ID!, $data: NotificationInput!) {
  updateNotification(documentId: $documentId, data: $data) {
    documentId
  }
}
    `;
export type UpdateNotificationMutationFn = Apollo.MutationFunction<UpdateNotificationMutation, UpdateNotificationMutationVariables>;
export function useUpdateNotificationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNotificationMutation, UpdateNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNotificationMutation, UpdateNotificationMutationVariables>(UpdateNotificationDocument, options);
      }
export type UpdateNotificationMutationHookResult = ReturnType<typeof useUpdateNotificationMutation>;
export type UpdateNotificationMutationResult = Apollo.MutationResult<UpdateNotificationMutation>;
export const UpdateUserDocument = gql`
    mutation updateUser($id: ID!, $input: UsersPermissionsUserInput!) {
  updateUsersPermissionsUser(id: $id, data: $input) {
    data {
      id
      blocked
    }
  }
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export const UserBulkBlockDocument = gql`
    mutation userBulkBlock($input: BulkBlockUsersInput!) {
  bulkBlockUsers(input: $input) {
    success
  }
}
    `;
export type UserBulkBlockMutationFn = Apollo.MutationFunction<UserBulkBlockMutation, UserBulkBlockMutationVariables>;
export function useUserBulkBlockMutation(baseOptions?: Apollo.MutationHookOptions<UserBulkBlockMutation, UserBulkBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserBulkBlockMutation, UserBulkBlockMutationVariables>(UserBulkBlockDocument, options);
      }
export type UserBulkBlockMutationHookResult = ReturnType<typeof useUserBulkBlockMutation>;
export type UserBulkBlockMutationResult = Apollo.MutationResult<UserBulkBlockMutation>;
export const CourseFilterOptionsDocument = gql`
    query CourseFilterOptions($input: CourseFilterOptionsInput) {
  courseFilterOptions(input: $input) {
    names {
      documentId
      title
    }
    categories {
      documentId
      label
    }
    authors {
      documentId
      firstName
      lastName
    }
  }
}
    `;
export function useCourseFilterOptionsQuery(baseOptions?: Apollo.QueryHookOptions<CourseFilterOptionsQuery, CourseFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CourseFilterOptionsQuery, CourseFilterOptionsQueryVariables>(CourseFilterOptionsDocument, options);
      }
export function useCourseFilterOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CourseFilterOptionsQuery, CourseFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CourseFilterOptionsQuery, CourseFilterOptionsQueryVariables>(CourseFilterOptionsDocument, options);
        }
export function useCourseFilterOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CourseFilterOptionsQuery, CourseFilterOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CourseFilterOptionsQuery, CourseFilterOptionsQueryVariables>(CourseFilterOptionsDocument, options);
        }
export type CourseFilterOptionsQueryHookResult = ReturnType<typeof useCourseFilterOptionsQuery>;
export type CourseFilterOptionsLazyQueryHookResult = ReturnType<typeof useCourseFilterOptionsLazyQuery>;
export type CourseFilterOptionsSuspenseQueryHookResult = ReturnType<typeof useCourseFilterOptionsSuspenseQuery>;
export type CourseFilterOptionsQueryResult = Apollo.QueryResult<CourseFilterOptionsQuery, CourseFilterOptionsQueryVariables>;
export const PostFilterOptionsDocument = gql`
    query PostFilterOptions {
  postFilterOptions {
    names {
      documentId
      title
    }
    categories {
      documentId
      label
    }
  }
}
    `;
export function usePostFilterOptionsQuery(baseOptions?: Apollo.QueryHookOptions<PostFilterOptionsQuery, PostFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PostFilterOptionsQuery, PostFilterOptionsQueryVariables>(PostFilterOptionsDocument, options);
      }
export function usePostFilterOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PostFilterOptionsQuery, PostFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PostFilterOptionsQuery, PostFilterOptionsQueryVariables>(PostFilterOptionsDocument, options);
        }
export function usePostFilterOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PostFilterOptionsQuery, PostFilterOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PostFilterOptionsQuery, PostFilterOptionsQueryVariables>(PostFilterOptionsDocument, options);
        }
export type PostFilterOptionsQueryHookResult = ReturnType<typeof usePostFilterOptionsQuery>;
export type PostFilterOptionsLazyQueryHookResult = ReturnType<typeof usePostFilterOptionsLazyQuery>;
export type PostFilterOptionsSuspenseQueryHookResult = ReturnType<typeof usePostFilterOptionsSuspenseQuery>;
export type PostFilterOptionsQueryResult = Apollo.QueryResult<PostFilterOptionsQuery, PostFilterOptionsQueryVariables>;
export const ProgramFilterOptionsDocument = gql`
    query ProgramFilterOptions($input: ProgramFilterOptionsInput) {
  programFilterOptions(input: $input) {
    names {
      documentId
      title
    }
    categories {
      documentId
      label
    }
  }
}
    `;
export function useProgramFilterOptionsQuery(baseOptions?: Apollo.QueryHookOptions<ProgramFilterOptionsQuery, ProgramFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProgramFilterOptionsQuery, ProgramFilterOptionsQueryVariables>(ProgramFilterOptionsDocument, options);
      }
export function useProgramFilterOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProgramFilterOptionsQuery, ProgramFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProgramFilterOptionsQuery, ProgramFilterOptionsQueryVariables>(ProgramFilterOptionsDocument, options);
        }
export function useProgramFilterOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProgramFilterOptionsQuery, ProgramFilterOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProgramFilterOptionsQuery, ProgramFilterOptionsQueryVariables>(ProgramFilterOptionsDocument, options);
        }
export type ProgramFilterOptionsQueryHookResult = ReturnType<typeof useProgramFilterOptionsQuery>;
export type ProgramFilterOptionsLazyQueryHookResult = ReturnType<typeof useProgramFilterOptionsLazyQuery>;
export type ProgramFilterOptionsSuspenseQueryHookResult = ReturnType<typeof useProgramFilterOptionsSuspenseQuery>;
export type ProgramFilterOptionsQueryResult = Apollo.QueryResult<ProgramFilterOptionsQuery, ProgramFilterOptionsQueryVariables>;
export const UserFilterOptionsDocument = gql`
    query UserFilterOptions($input: UserFilterOptionsInput) {
  userFilterOptions(input: $input) {
    users {
      documentId
      firstName
      lastName
      email
    }
  }
}
    `;
export function useUserFilterOptionsQuery(baseOptions?: Apollo.QueryHookOptions<UserFilterOptionsQuery, UserFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserFilterOptionsQuery, UserFilterOptionsQueryVariables>(UserFilterOptionsDocument, options);
      }
export function useUserFilterOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserFilterOptionsQuery, UserFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserFilterOptionsQuery, UserFilterOptionsQueryVariables>(UserFilterOptionsDocument, options);
        }
export function useUserFilterOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserFilterOptionsQuery, UserFilterOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserFilterOptionsQuery, UserFilterOptionsQueryVariables>(UserFilterOptionsDocument, options);
        }
export type UserFilterOptionsQueryHookResult = ReturnType<typeof useUserFilterOptionsQuery>;
export type UserFilterOptionsLazyQueryHookResult = ReturnType<typeof useUserFilterOptionsLazyQuery>;
export type UserFilterOptionsSuspenseQueryHookResult = ReturnType<typeof useUserFilterOptionsSuspenseQuery>;
export type UserFilterOptionsQueryResult = Apollo.QueryResult<UserFilterOptionsQuery, UserFilterOptionsQueryVariables>;
export const ActivityLogFilterOptionsDocument = gql`
    query ActivityLogFilterOptions($input: ActivityLogFilterOptionsInput) {
  activityLogFilterOptions(input: $input) {
    users {
      documentId
      firstName
      lastName
    }
    targets
  }
}
    `;
export function useActivityLogFilterOptionsQuery(baseOptions?: Apollo.QueryHookOptions<ActivityLogFilterOptionsQuery, ActivityLogFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivityLogFilterOptionsQuery, ActivityLogFilterOptionsQueryVariables>(ActivityLogFilterOptionsDocument, options);
      }
export function useActivityLogFilterOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivityLogFilterOptionsQuery, ActivityLogFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivityLogFilterOptionsQuery, ActivityLogFilterOptionsQueryVariables>(ActivityLogFilterOptionsDocument, options);
        }
export function useActivityLogFilterOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActivityLogFilterOptionsQuery, ActivityLogFilterOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ActivityLogFilterOptionsQuery, ActivityLogFilterOptionsQueryVariables>(ActivityLogFilterOptionsDocument, options);
        }
export type ActivityLogFilterOptionsQueryHookResult = ReturnType<typeof useActivityLogFilterOptionsQuery>;
export type ActivityLogFilterOptionsLazyQueryHookResult = ReturnType<typeof useActivityLogFilterOptionsLazyQuery>;
export type ActivityLogFilterOptionsSuspenseQueryHookResult = ReturnType<typeof useActivityLogFilterOptionsSuspenseQuery>;
export type ActivityLogFilterOptionsQueryResult = Apollo.QueryResult<ActivityLogFilterOptionsQuery, ActivityLogFilterOptionsQueryVariables>;
export const ActivityLogsDocument = gql`
    query activityLogs($pagination: PaginationArg, $filters: ActivityLogFiltersInput, $sort: [String]) {
  activityLogs(pagination: $pagination, filters: $filters, sort: $sort) {
    ...ActivityLog
  }
  activityLogs_connection(pagination: $pagination, filters: $filters, sort: $sort) {
    nodes {
      ...ActivityLog
    }
    pageInfo {
      total
      page
      pageSize
      pageCount
    }
  }
}
    ${ActivityLogFragmentDoc}`;
export function useActivityLogsQuery(baseOptions?: Apollo.QueryHookOptions<ActivityLogsQuery, ActivityLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivityLogsQuery, ActivityLogsQueryVariables>(ActivityLogsDocument, options);
      }
export function useActivityLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivityLogsQuery, ActivityLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivityLogsQuery, ActivityLogsQueryVariables>(ActivityLogsDocument, options);
        }
export function useActivityLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActivityLogsQuery, ActivityLogsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ActivityLogsQuery, ActivityLogsQueryVariables>(ActivityLogsDocument, options);
        }
export type ActivityLogsQueryHookResult = ReturnType<typeof useActivityLogsQuery>;
export type ActivityLogsLazyQueryHookResult = ReturnType<typeof useActivityLogsLazyQuery>;
export type ActivityLogsSuspenseQueryHookResult = ReturnType<typeof useActivityLogsSuspenseQuery>;
export type ActivityLogsQueryResult = Apollo.QueryResult<ActivityLogsQuery, ActivityLogsQueryVariables>;
export const BulkChangeCoruseActivityDocument = gql`
    mutation bulkChangeCoruseActivity($input: BulkChangeCourseActivityInput!) {
  bulkChangeCourseActivity(input: $input) {
    success
  }
}
    `;
export type BulkChangeCoruseActivityMutationFn = Apollo.MutationFunction<BulkChangeCoruseActivityMutation, BulkChangeCoruseActivityMutationVariables>;
export function useBulkChangeCoruseActivityMutation(baseOptions?: Apollo.MutationHookOptions<BulkChangeCoruseActivityMutation, BulkChangeCoruseActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkChangeCoruseActivityMutation, BulkChangeCoruseActivityMutationVariables>(BulkChangeCoruseActivityDocument, options);
      }
export type BulkChangeCoruseActivityMutationHookResult = ReturnType<typeof useBulkChangeCoruseActivityMutation>;
export type BulkChangeCoruseActivityMutationResult = Apollo.MutationResult<BulkChangeCoruseActivityMutation>;
export const BulkChangeCoruseStatusDocument = gql`
    mutation bulkChangeCoruseStatus($input: BulkChangeCourseStatusInput!) {
  bulkChangeCourseStatus(input: $input) {
    success
  }
}
    `;
export type BulkChangeCoruseStatusMutationFn = Apollo.MutationFunction<BulkChangeCoruseStatusMutation, BulkChangeCoruseStatusMutationVariables>;
export function useBulkChangeCoruseStatusMutation(baseOptions?: Apollo.MutationHookOptions<BulkChangeCoruseStatusMutation, BulkChangeCoruseStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkChangeCoruseStatusMutation, BulkChangeCoruseStatusMutationVariables>(BulkChangeCoruseStatusDocument, options);
      }
export type BulkChangeCoruseStatusMutationHookResult = ReturnType<typeof useBulkChangeCoruseStatusMutation>;
export type BulkChangeCoruseStatusMutationResult = Apollo.MutationResult<BulkChangeCoruseStatusMutation>;
export const BulkRemoveCoursesDocument = gql`
    mutation bulkRemoveCourses($input: BulkRemoveCourseInput!) {
  bulkRemoveCourses(input: $input) {
    success
  }
}
    `;
export type BulkRemoveCoursesMutationFn = Apollo.MutationFunction<BulkRemoveCoursesMutation, BulkRemoveCoursesMutationVariables>;
export function useBulkRemoveCoursesMutation(baseOptions?: Apollo.MutationHookOptions<BulkRemoveCoursesMutation, BulkRemoveCoursesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkRemoveCoursesMutation, BulkRemoveCoursesMutationVariables>(BulkRemoveCoursesDocument, options);
      }
export type BulkRemoveCoursesMutationHookResult = ReturnType<typeof useBulkRemoveCoursesMutation>;
export type BulkRemoveCoursesMutationResult = Apollo.MutationResult<BulkRemoveCoursesMutation>;
export const CategoriesDocument = gql`
    query categories($filters: CourseCategoryFiltersInput, $pagination: PaginationArg, $sort: [String]) {
  courseCategories(filters: $filters, pagination: $pagination, sort: $sort) {
    documentId
    label
    courses(pagination: {limit: 1}) {
      documentId
    }
  }
}
    `;
export function useCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<CategoriesQuery, CategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategoriesQuery, CategoriesQueryVariables>(CategoriesDocument, options);
      }
export function useCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategoriesQuery, CategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategoriesQuery, CategoriesQueryVariables>(CategoriesDocument, options);
        }
export function useCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CategoriesQuery, CategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CategoriesQuery, CategoriesQueryVariables>(CategoriesDocument, options);
        }
export type CategoriesQueryHookResult = ReturnType<typeof useCategoriesQuery>;
export type CategoriesLazyQueryHookResult = ReturnType<typeof useCategoriesLazyQuery>;
export type CategoriesSuspenseQueryHookResult = ReturnType<typeof useCategoriesSuspenseQuery>;
export type CategoriesQueryResult = Apollo.QueryResult<CategoriesQuery, CategoriesQueryVariables>;
export const CategoryNamesDocument = gql`
    query CategoryNames($filters: CourseFiltersInput, $pagination: PaginationArg, $sort: [String]) {
  me {
    student {
      courses(filters: $filters, pagination: $pagination, sort: $sort) {
        category {
          label
          documentId
        }
      }
    }
  }
}
    `;
export function useCategoryNamesQuery(baseOptions?: Apollo.QueryHookOptions<CategoryNamesQuery, CategoryNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategoryNamesQuery, CategoryNamesQueryVariables>(CategoryNamesDocument, options);
      }
export function useCategoryNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategoryNamesQuery, CategoryNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategoryNamesQuery, CategoryNamesQueryVariables>(CategoryNamesDocument, options);
        }
export function useCategoryNamesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CategoryNamesQuery, CategoryNamesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CategoryNamesQuery, CategoryNamesQueryVariables>(CategoryNamesDocument, options);
        }
export type CategoryNamesQueryHookResult = ReturnType<typeof useCategoryNamesQuery>;
export type CategoryNamesLazyQueryHookResult = ReturnType<typeof useCategoryNamesLazyQuery>;
export type CategoryNamesSuspenseQueryHookResult = ReturnType<typeof useCategoryNamesSuspenseQuery>;
export type CategoryNamesQueryResult = Apollo.QueryResult<CategoryNamesQuery, CategoryNamesQueryVariables>;
export const ChangeCourseActivityDocument = gql`
    mutation changeCourseActivity($courseDocumentId: ID!, $isActive: Boolean) {
  updateCourse(documentId: $courseDocumentId, data: {isActive: $isActive}) {
    documentId
  }
}
    `;
export type ChangeCourseActivityMutationFn = Apollo.MutationFunction<ChangeCourseActivityMutation, ChangeCourseActivityMutationVariables>;
export function useChangeCourseActivityMutation(baseOptions?: Apollo.MutationHookOptions<ChangeCourseActivityMutation, ChangeCourseActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeCourseActivityMutation, ChangeCourseActivityMutationVariables>(ChangeCourseActivityDocument, options);
      }
export type ChangeCourseActivityMutationHookResult = ReturnType<typeof useChangeCourseActivityMutation>;
export type ChangeCourseActivityMutationResult = Apollo.MutationResult<ChangeCourseActivityMutation>;
export const ChangeCourseStatusDocument = gql`
    mutation changeCourseStatus($courseDocumentId: ID!, $status: ENUM_COURSE_COURSESTATUS) {
  updateCourse(documentId: $courseDocumentId, data: {courseStatus: $status}) {
    documentId
  }
}
    `;
export type ChangeCourseStatusMutationFn = Apollo.MutationFunction<ChangeCourseStatusMutation, ChangeCourseStatusMutationVariables>;
export function useChangeCourseStatusMutation(baseOptions?: Apollo.MutationHookOptions<ChangeCourseStatusMutation, ChangeCourseStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeCourseStatusMutation, ChangeCourseStatusMutationVariables>(ChangeCourseStatusDocument, options);
      }
export type ChangeCourseStatusMutationHookResult = ReturnType<typeof useChangeCourseStatusMutation>;
export type ChangeCourseStatusMutationResult = Apollo.MutationResult<ChangeCourseStatusMutation>;
export const SingleChapterDocument = gql`
    query singleChapter($id: ID!) {
  courseChapter(documentId: $id) {
    title
    course {
      documentId
      lockOrder
      chapters {
        documentId
        order
      }
    }
    texts {
      id
      order
      text
    }
    videos {
      id
      order
      url
    }
    images {
      id
      type
      image {
        url
        width
        height
      }
      order
      items {
        id
        title
        xcoord
        ycoord
        description
        showTitle
      }
      twoColumns {
        firstColumn {
          type
          image {
            documentId
            url
          }
          text {
            language
            content
          }
        }
        secondColumn {
          type
          image {
            documentId
            url
          }
          text {
            language
            content
          }
        }
      }
    }
    podcasts {
      id
      order
      url
    }
    quizzes {
      id
      order
      required
      questions {
        id
        body
        answers {
          id
          body
          correct
        }
        type
      }
      fillQuestions {
        blanks {
          value
        }
        entries {
          id
          order
          segments {
            id
            type
            value
            customId
          }
        }
        blanks {
          value
        }
      }
    }
    files {
      id
      order
      title
      thumbnail {
        documentId
        url
        name
      }
      file {
        documentId
        url
        ext
        name
      }
    }
    order
  }
}
    `;
export function useSingleChapterQuery(baseOptions: Apollo.QueryHookOptions<SingleChapterQuery, SingleChapterQueryVariables> & ({ variables: SingleChapterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleChapterQuery, SingleChapterQueryVariables>(SingleChapterDocument, options);
      }
export function useSingleChapterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleChapterQuery, SingleChapterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleChapterQuery, SingleChapterQueryVariables>(SingleChapterDocument, options);
        }
export function useSingleChapterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SingleChapterQuery, SingleChapterQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SingleChapterQuery, SingleChapterQueryVariables>(SingleChapterDocument, options);
        }
export type SingleChapterQueryHookResult = ReturnType<typeof useSingleChapterQuery>;
export type SingleChapterLazyQueryHookResult = ReturnType<typeof useSingleChapterLazyQuery>;
export type SingleChapterSuspenseQueryHookResult = ReturnType<typeof useSingleChapterSuspenseQuery>;
export type SingleChapterQueryResult = Apollo.QueryResult<SingleChapterQuery, SingleChapterQueryVariables>;
export const CommentsDocument = gql`
    query comments($filters: PostCommentFiltersInput, $sort: [String], $pagination: PaginationArg) {
  postComments_connection(filters: $filters, sort: $sort, pagination: $pagination) {
    nodes {
      documentId
      createdAt
      title
      sender {
        user {
          firstName
          lastName
        }
      }
    }
    pageInfo {
      total
    }
  }
}
    `;
export function useCommentsQuery(baseOptions?: Apollo.QueryHookOptions<CommentsQuery, CommentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommentsQuery, CommentsQueryVariables>(CommentsDocument, options);
      }
export function useCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommentsQuery, CommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommentsQuery, CommentsQueryVariables>(CommentsDocument, options);
        }
export function useCommentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CommentsQuery, CommentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CommentsQuery, CommentsQueryVariables>(CommentsDocument, options);
        }
export type CommentsQueryHookResult = ReturnType<typeof useCommentsQuery>;
export type CommentsLazyQueryHookResult = ReturnType<typeof useCommentsLazyQuery>;
export type CommentsSuspenseQueryHookResult = ReturnType<typeof useCommentsSuspenseQuery>;
export type CommentsQueryResult = Apollo.QueryResult<CommentsQuery, CommentsQueryVariables>;
export const CountriesDocument = gql`
    query countries($filters: CountryFiltersInput, $pagination: PaginationArg, $sort: [String]) {
  countries(filters: $filters, pagination: $pagination, sort: $sort) {
    documentId
    name
    code
    region {
      documentId
      name
    }
  }
}
    `;
export function useCountriesQuery(baseOptions?: Apollo.QueryHookOptions<CountriesQuery, CountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountriesQuery, CountriesQueryVariables>(CountriesDocument, options);
      }
export function useCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountriesQuery, CountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountriesQuery, CountriesQueryVariables>(CountriesDocument, options);
        }
export function useCountriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CountriesQuery, CountriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountriesQuery, CountriesQueryVariables>(CountriesDocument, options);
        }
export type CountriesQueryHookResult = ReturnType<typeof useCountriesQuery>;
export type CountriesLazyQueryHookResult = ReturnType<typeof useCountriesLazyQuery>;
export type CountriesSuspenseQueryHookResult = ReturnType<typeof useCountriesSuspenseQuery>;
export type CountriesQueryResult = Apollo.QueryResult<CountriesQuery, CountriesQueryVariables>;
export const CourseDocument = gql`
    query course($id: ID!) {
  course(documentId: $id) {
    documentId
    title
    description
    type
    courseStatus
    template
    isActive
    lockOrder
    autoAssign
    students {
      documentId
    }
    templateParent {
      documentId
    }
    templateChildren {
      documentId
    }
    category {
      documentId
    }
    keys {
      key
    }
    cover {
      documentId
      url
    }
    chapters {
      documentId
      order
      title
      images {
        id
        order
        type
        image {
          documentId
          url
        }
        items {
          title
          description
          showTitle
          xcoord
          ycoord
        }
        twoColumns {
          firstColumn {
            type
            image {
              documentId
              url
            }
            text {
              language
              content
            }
          }
          secondColumn {
            type
            image {
              documentId
              url
            }
            text {
              language
              content
            }
          }
        }
      }
      files {
        id
        order
        title
        thumbnail {
          documentId
          url
          name
        }
        file {
          documentId
          url
          ext
          name
        }
      }
      videos {
        id
        order
        url
      }
      podcasts {
        id
        order
        url
      }
      quizzes {
        id
        order
        required
        questions {
          id
          body
          answers {
            id
            body
            correct
          }
          type
        }
        fillQuestions {
          id
          entries {
            id
            order
            segments {
              id
              type
              value
              customId
            }
          }
          blanks {
            value
          }
        }
      }
      texts {
        order
        text
      }
    }
  }
}
    `;
export function useCourseQuery(baseOptions: Apollo.QueryHookOptions<CourseQuery, CourseQueryVariables> & ({ variables: CourseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CourseQuery, CourseQueryVariables>(CourseDocument, options);
      }
export function useCourseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CourseQuery, CourseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CourseQuery, CourseQueryVariables>(CourseDocument, options);
        }
export function useCourseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CourseQuery, CourseQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CourseQuery, CourseQueryVariables>(CourseDocument, options);
        }
export type CourseQueryHookResult = ReturnType<typeof useCourseQuery>;
export type CourseLazyQueryHookResult = ReturnType<typeof useCourseLazyQuery>;
export type CourseSuspenseQueryHookResult = ReturnType<typeof useCourseSuspenseQuery>;
export type CourseQueryResult = Apollo.QueryResult<CourseQuery, CourseQueryVariables>;
export const CourseProgramsDocument = gql`
    query coursePrograms($documentId: ID!, $pagination: PaginationArg, $filters: ProgramFiltersInput, $sort: [String]) {
  programs_connection(pagination: $pagination, filters: $filters, sort: $sort) {
    nodes {
      documentId
      title
      category {
        documentId
        label
      }
      events(
        filters: {course: {documentId: {eq: $documentId}}, type: {in: ["course_assigned_to_program"]}}
      ) {
        createdAt
        type
        course {
          documentId
        }
      }
    }
    pageInfo {
      total
      page
      pageSize
      pageCount
    }
  }
}
    `;
export function useCourseProgramsQuery(baseOptions: Apollo.QueryHookOptions<CourseProgramsQuery, CourseProgramsQueryVariables> & ({ variables: CourseProgramsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CourseProgramsQuery, CourseProgramsQueryVariables>(CourseProgramsDocument, options);
      }
export function useCourseProgramsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CourseProgramsQuery, CourseProgramsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CourseProgramsQuery, CourseProgramsQueryVariables>(CourseProgramsDocument, options);
        }
export function useCourseProgramsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CourseProgramsQuery, CourseProgramsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CourseProgramsQuery, CourseProgramsQueryVariables>(CourseProgramsDocument, options);
        }
export type CourseProgramsQueryHookResult = ReturnType<typeof useCourseProgramsQuery>;
export type CourseProgramsLazyQueryHookResult = ReturnType<typeof useCourseProgramsLazyQuery>;
export type CourseProgramsSuspenseQueryHookResult = ReturnType<typeof useCourseProgramsSuspenseQuery>;
export type CourseProgramsQueryResult = Apollo.QueryResult<CourseProgramsQuery, CourseProgramsQueryVariables>;
export const CourseProgramsConnectionDocument = gql`
    query courseProgramsConnection($documentId: ID!) {
  course(documentId: $documentId) {
    programs {
      title
      documentId
    }
  }
}
    `;
export function useCourseProgramsConnectionQuery(baseOptions: Apollo.QueryHookOptions<CourseProgramsConnectionQuery, CourseProgramsConnectionQueryVariables> & ({ variables: CourseProgramsConnectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CourseProgramsConnectionQuery, CourseProgramsConnectionQueryVariables>(CourseProgramsConnectionDocument, options);
      }
export function useCourseProgramsConnectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CourseProgramsConnectionQuery, CourseProgramsConnectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CourseProgramsConnectionQuery, CourseProgramsConnectionQueryVariables>(CourseProgramsConnectionDocument, options);
        }
export function useCourseProgramsConnectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CourseProgramsConnectionQuery, CourseProgramsConnectionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CourseProgramsConnectionQuery, CourseProgramsConnectionQueryVariables>(CourseProgramsConnectionDocument, options);
        }
export type CourseProgramsConnectionQueryHookResult = ReturnType<typeof useCourseProgramsConnectionQuery>;
export type CourseProgramsConnectionLazyQueryHookResult = ReturnType<typeof useCourseProgramsConnectionLazyQuery>;
export type CourseProgramsConnectionSuspenseQueryHookResult = ReturnType<typeof useCourseProgramsConnectionSuspenseQuery>;
export type CourseProgramsConnectionQueryResult = Apollo.QueryResult<CourseProgramsConnectionQuery, CourseProgramsConnectionQueryVariables>;
export const CourseResultsDocument = gql`
    query courseResults($input: CourseResultsInput!) {
  courseResults(input: $input) {
    chapters
    quizzes {
      done
      total
    }
    score
  }
}
    `;
export function useCourseResultsQuery(baseOptions: Apollo.QueryHookOptions<CourseResultsQuery, CourseResultsQueryVariables> & ({ variables: CourseResultsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CourseResultsQuery, CourseResultsQueryVariables>(CourseResultsDocument, options);
      }
export function useCourseResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CourseResultsQuery, CourseResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CourseResultsQuery, CourseResultsQueryVariables>(CourseResultsDocument, options);
        }
export function useCourseResultsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CourseResultsQuery, CourseResultsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CourseResultsQuery, CourseResultsQueryVariables>(CourseResultsDocument, options);
        }
export type CourseResultsQueryHookResult = ReturnType<typeof useCourseResultsQuery>;
export type CourseResultsLazyQueryHookResult = ReturnType<typeof useCourseResultsLazyQuery>;
export type CourseResultsSuspenseQueryHookResult = ReturnType<typeof useCourseResultsSuspenseQuery>;
export type CourseResultsQueryResult = Apollo.QueryResult<CourseResultsQuery, CourseResultsQueryVariables>;
export const CourseStatsDocument = gql`
    query courseStats($documentId: String!) {
  courseStats(input: {documentId: $documentId}) {
    info {
      status
      title
      isActive
    }
    stats {
      count
      title
    }
  }
}
    `;
export function useCourseStatsQuery(baseOptions: Apollo.QueryHookOptions<CourseStatsQuery, CourseStatsQueryVariables> & ({ variables: CourseStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CourseStatsQuery, CourseStatsQueryVariables>(CourseStatsDocument, options);
      }
export function useCourseStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CourseStatsQuery, CourseStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CourseStatsQuery, CourseStatsQueryVariables>(CourseStatsDocument, options);
        }
export function useCourseStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CourseStatsQuery, CourseStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CourseStatsQuery, CourseStatsQueryVariables>(CourseStatsDocument, options);
        }
export type CourseStatsQueryHookResult = ReturnType<typeof useCourseStatsQuery>;
export type CourseStatsLazyQueryHookResult = ReturnType<typeof useCourseStatsLazyQuery>;
export type CourseStatsSuspenseQueryHookResult = ReturnType<typeof useCourseStatsSuspenseQuery>;
export type CourseStatsQueryResult = Apollo.QueryResult<CourseStatsQuery, CourseStatsQueryVariables>;
export const CourseStudentsDocument = gql`
    query courseStudents($documentId: ID!, $pagination: PaginationArg, $filters: CourseStudentFiltersInput, $sort: [String]) {
  course(documentId: $documentId) {
    chapters {
      quizzes {
        id
      }
    }
  }
  courseStudents_connection(
    pagination: $pagination
    filters: $filters
    sort: $sort
  ) {
    nodes {
      documentId
      user {
        id
        documentId
        role {
          name
        }
        lastName
        firstName
      }
      events(
        filters: {course: {documentId: {eq: $documentId}}, type: {in: ["course_completed", "course_assigned"]}}
      ) {
        createdAt
        type
      }
      completedChapters(filters: {course: {documentId: {eq: $documentId}}}) {
        documentId
      }
      chapterResults(
        filters: {courseChapter: {course: {documentId: {eq: $documentId}}}, quizResults: {notNull: true}}
      ) {
        id
        quizId
      }
    }
    pageInfo {
      total
      page
      pageSize
      pageCount
    }
  }
}
    `;
export function useCourseStudentsQuery(baseOptions: Apollo.QueryHookOptions<CourseStudentsQuery, CourseStudentsQueryVariables> & ({ variables: CourseStudentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CourseStudentsQuery, CourseStudentsQueryVariables>(CourseStudentsDocument, options);
      }
export function useCourseStudentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CourseStudentsQuery, CourseStudentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CourseStudentsQuery, CourseStudentsQueryVariables>(CourseStudentsDocument, options);
        }
export function useCourseStudentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CourseStudentsQuery, CourseStudentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CourseStudentsQuery, CourseStudentsQueryVariables>(CourseStudentsDocument, options);
        }
export type CourseStudentsQueryHookResult = ReturnType<typeof useCourseStudentsQuery>;
export type CourseStudentsLazyQueryHookResult = ReturnType<typeof useCourseStudentsLazyQuery>;
export type CourseStudentsSuspenseQueryHookResult = ReturnType<typeof useCourseStudentsSuspenseQuery>;
export type CourseStudentsQueryResult = Apollo.QueryResult<CourseStudentsQuery, CourseStudentsQueryVariables>;
export const CourseStudentsWithProgressDocument = gql`
    query courseStudentsWithProgress($input: CourseStudentsWithProgressInput!) {
  courseStudentsWithProgress(input: $input) {
    data {
      documentId
      user {
        documentId
        firstName
        lastName
        role {
          type
          name
        }
      }
      dateAssigned
      dateCompleted
      chaptersDone
      quizProgress
      totalChapters
      totalQuizzes
    }
    meta {
      pagination {
        total
        page
        pageSize
      }
    }
  }
}
    `;
export function useCourseStudentsWithProgressQuery(baseOptions: Apollo.QueryHookOptions<CourseStudentsWithProgressQuery, CourseStudentsWithProgressQueryVariables> & ({ variables: CourseStudentsWithProgressQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CourseStudentsWithProgressQuery, CourseStudentsWithProgressQueryVariables>(CourseStudentsWithProgressDocument, options);
      }
export function useCourseStudentsWithProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CourseStudentsWithProgressQuery, CourseStudentsWithProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CourseStudentsWithProgressQuery, CourseStudentsWithProgressQueryVariables>(CourseStudentsWithProgressDocument, options);
        }
export function useCourseStudentsWithProgressSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CourseStudentsWithProgressQuery, CourseStudentsWithProgressQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CourseStudentsWithProgressQuery, CourseStudentsWithProgressQueryVariables>(CourseStudentsWithProgressDocument, options);
        }
export type CourseStudentsWithProgressQueryHookResult = ReturnType<typeof useCourseStudentsWithProgressQuery>;
export type CourseStudentsWithProgressLazyQueryHookResult = ReturnType<typeof useCourseStudentsWithProgressLazyQuery>;
export type CourseStudentsWithProgressSuspenseQueryHookResult = ReturnType<typeof useCourseStudentsWithProgressSuspenseQuery>;
export type CourseStudentsWithProgressQueryResult = Apollo.QueryResult<CourseStudentsWithProgressQuery, CourseStudentsWithProgressQueryVariables>;
export const CoursesDocument = gql`
    query courses($filters: CourseFiltersInput, $pagination: PaginationArg, $sort: [String]) {
  courses_connection(filters: $filters, pagination: $pagination, sort: $sort) {
    nodes {
      documentId
      title
      type
      courseStatus
      isActive
      category {
        label
        documentId
      }
      author {
        user {
          documentId
          firstName
          lastName
        }
      }
      dateAdded
    }
    pageInfo {
      total
    }
  }
}
    `;
export function useCoursesQuery(baseOptions?: Apollo.QueryHookOptions<CoursesQuery, CoursesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CoursesQuery, CoursesQueryVariables>(CoursesDocument, options);
      }
export function useCoursesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CoursesQuery, CoursesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CoursesQuery, CoursesQueryVariables>(CoursesDocument, options);
        }
export function useCoursesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CoursesQuery, CoursesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CoursesQuery, CoursesQueryVariables>(CoursesDocument, options);
        }
export type CoursesQueryHookResult = ReturnType<typeof useCoursesQuery>;
export type CoursesLazyQueryHookResult = ReturnType<typeof useCoursesLazyQuery>;
export type CoursesSuspenseQueryHookResult = ReturnType<typeof useCoursesSuspenseQuery>;
export type CoursesQueryResult = Apollo.QueryResult<CoursesQuery, CoursesQueryVariables>;
export const CourseCategoriesForMyLearningDocument = gql`
    query CourseCategoriesForMyLearning {
  courseCategoriesForMyLearning {
    allCategories {
      documentId
      label
    }
    completedCategories {
      documentId
      label
    }
    inProgressCategories {
      documentId
      label
    }
  }
}
    `;
export function useCourseCategoriesForMyLearningQuery(baseOptions?: Apollo.QueryHookOptions<CourseCategoriesForMyLearningQuery, CourseCategoriesForMyLearningQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CourseCategoriesForMyLearningQuery, CourseCategoriesForMyLearningQueryVariables>(CourseCategoriesForMyLearningDocument, options);
      }
export function useCourseCategoriesForMyLearningLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CourseCategoriesForMyLearningQuery, CourseCategoriesForMyLearningQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CourseCategoriesForMyLearningQuery, CourseCategoriesForMyLearningQueryVariables>(CourseCategoriesForMyLearningDocument, options);
        }
export function useCourseCategoriesForMyLearningSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CourseCategoriesForMyLearningQuery, CourseCategoriesForMyLearningQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CourseCategoriesForMyLearningQuery, CourseCategoriesForMyLearningQueryVariables>(CourseCategoriesForMyLearningDocument, options);
        }
export type CourseCategoriesForMyLearningQueryHookResult = ReturnType<typeof useCourseCategoriesForMyLearningQuery>;
export type CourseCategoriesForMyLearningLazyQueryHookResult = ReturnType<typeof useCourseCategoriesForMyLearningLazyQuery>;
export type CourseCategoriesForMyLearningSuspenseQueryHookResult = ReturnType<typeof useCourseCategoriesForMyLearningSuspenseQuery>;
export type CourseCategoriesForMyLearningQueryResult = Apollo.QueryResult<CourseCategoriesForMyLearningQuery, CourseCategoriesForMyLearningQueryVariables>;
export const CourseCertificateDocument = gql`
    query CourseCertificate($input: CourseCertificateInput!) {
  courseCertificate(input: $input) {
    id
    courseId
  }
}
    `;
export function useCourseCertificateQuery(baseOptions: Apollo.QueryHookOptions<CourseCertificateQuery, CourseCertificateQueryVariables> & ({ variables: CourseCertificateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CourseCertificateQuery, CourseCertificateQueryVariables>(CourseCertificateDocument, options);
      }
export function useCourseCertificateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CourseCertificateQuery, CourseCertificateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CourseCertificateQuery, CourseCertificateQueryVariables>(CourseCertificateDocument, options);
        }
export function useCourseCertificateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CourseCertificateQuery, CourseCertificateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CourseCertificateQuery, CourseCertificateQueryVariables>(CourseCertificateDocument, options);
        }
export type CourseCertificateQueryHookResult = ReturnType<typeof useCourseCertificateQuery>;
export type CourseCertificateLazyQueryHookResult = ReturnType<typeof useCourseCertificateLazyQuery>;
export type CourseCertificateSuspenseQueryHookResult = ReturnType<typeof useCourseCertificateSuspenseQuery>;
export type CourseCertificateQueryResult = Apollo.QueryResult<CourseCertificateQuery, CourseCertificateQueryVariables>;
export const CourseStudentsFilterOptionsDocument = gql`
    query courseStudentsFilterOptions($filters: CourseStudentFiltersInput) {
  courseStudents_connection(
    pagination: {page: 1, pageSize: 3000000}
    filters: $filters
  ) {
    nodes {
      documentId
      user {
        documentId
        firstName
        lastName
      }
    }
  }
}
    `;
export function useCourseStudentsFilterOptionsQuery(baseOptions?: Apollo.QueryHookOptions<CourseStudentsFilterOptionsQuery, CourseStudentsFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CourseStudentsFilterOptionsQuery, CourseStudentsFilterOptionsQueryVariables>(CourseStudentsFilterOptionsDocument, options);
      }
export function useCourseStudentsFilterOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CourseStudentsFilterOptionsQuery, CourseStudentsFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CourseStudentsFilterOptionsQuery, CourseStudentsFilterOptionsQueryVariables>(CourseStudentsFilterOptionsDocument, options);
        }
export function useCourseStudentsFilterOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CourseStudentsFilterOptionsQuery, CourseStudentsFilterOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CourseStudentsFilterOptionsQuery, CourseStudentsFilterOptionsQueryVariables>(CourseStudentsFilterOptionsDocument, options);
        }
export type CourseStudentsFilterOptionsQueryHookResult = ReturnType<typeof useCourseStudentsFilterOptionsQuery>;
export type CourseStudentsFilterOptionsLazyQueryHookResult = ReturnType<typeof useCourseStudentsFilterOptionsLazyQuery>;
export type CourseStudentsFilterOptionsSuspenseQueryHookResult = ReturnType<typeof useCourseStudentsFilterOptionsSuspenseQuery>;
export type CourseStudentsFilterOptionsQueryResult = Apollo.QueryResult<CourseStudentsFilterOptionsQuery, CourseStudentsFilterOptionsQueryVariables>;
export const DownloadCourseProgramsCsvDocument = gql`
    query downloadCourseProgramsCsv($input: DownloadCourseProgramsCsvInput!) {
  downloadCourseProgramsCsv(input: $input) {
    buffer
    filename
    success
  }
}
    `;
export function useDownloadCourseProgramsCsvQuery(baseOptions: Apollo.QueryHookOptions<DownloadCourseProgramsCsvQuery, DownloadCourseProgramsCsvQueryVariables> & ({ variables: DownloadCourseProgramsCsvQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadCourseProgramsCsvQuery, DownloadCourseProgramsCsvQueryVariables>(DownloadCourseProgramsCsvDocument, options);
      }
export function useDownloadCourseProgramsCsvLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadCourseProgramsCsvQuery, DownloadCourseProgramsCsvQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadCourseProgramsCsvQuery, DownloadCourseProgramsCsvQueryVariables>(DownloadCourseProgramsCsvDocument, options);
        }
export function useDownloadCourseProgramsCsvSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DownloadCourseProgramsCsvQuery, DownloadCourseProgramsCsvQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DownloadCourseProgramsCsvQuery, DownloadCourseProgramsCsvQueryVariables>(DownloadCourseProgramsCsvDocument, options);
        }
export type DownloadCourseProgramsCsvQueryHookResult = ReturnType<typeof useDownloadCourseProgramsCsvQuery>;
export type DownloadCourseProgramsCsvLazyQueryHookResult = ReturnType<typeof useDownloadCourseProgramsCsvLazyQuery>;
export type DownloadCourseProgramsCsvSuspenseQueryHookResult = ReturnType<typeof useDownloadCourseProgramsCsvSuspenseQuery>;
export type DownloadCourseProgramsCsvQueryResult = Apollo.QueryResult<DownloadCourseProgramsCsvQuery, DownloadCourseProgramsCsvQueryVariables>;
export const CoursesTotalDocument = gql`
    query coursesTotal($documentId: [ID!], $type: JSONFilterInput, $category: CourseCategoryFiltersInput, $author: CourseAuthorFiltersInput) {
  all: courses_connection(
    filters: {documentId: {in: $documentId}, type: $type, category: $category, author: $author, deleted: {eq: false}}
    pagination: {page: 1, pageSize: 3000000}
  ) {
    pageInfo {
      total
    }
  }
  active: courses_connection(
    filters: {isActive: {eq: true}, documentId: {in: $documentId}, type: $type, category: $category, author: $author, deleted: {eq: false}}
    pagination: {page: 1, pageSize: 3000000}
  ) {
    pageInfo {
      total
    }
  }
  inactive: courses_connection(
    filters: {isActive: {eq: false}, documentId: {in: $documentId}, type: $type, category: $category, author: $author, deleted: {eq: false}}
    pagination: {page: 1, pageSize: 3000000}
  ) {
    pageInfo {
      total
    }
  }
  drafts: courses_connection(
    filters: {courseStatus: {eq: "draft"}, documentId: {in: $documentId}, type: $type, category: $category, author: $author, deleted: {eq: false}}
    pagination: {page: 1, pageSize: 3000000}
  ) {
    pageInfo {
      total
    }
  }
  templates: courses_connection(
    filters: {template: {eq: true}, documentId: {in: $documentId}, type: $type, category: $category, author: $author, deleted: {eq: false}}
    pagination: {page: 1, pageSize: 3000000}
  ) {
    pageInfo {
      total
    }
  }
}
    `;
export function useCoursesTotalQuery(baseOptions?: Apollo.QueryHookOptions<CoursesTotalQuery, CoursesTotalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CoursesTotalQuery, CoursesTotalQueryVariables>(CoursesTotalDocument, options);
      }
export function useCoursesTotalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CoursesTotalQuery, CoursesTotalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CoursesTotalQuery, CoursesTotalQueryVariables>(CoursesTotalDocument, options);
        }
export function useCoursesTotalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CoursesTotalQuery, CoursesTotalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CoursesTotalQuery, CoursesTotalQueryVariables>(CoursesTotalDocument, options);
        }
export type CoursesTotalQueryHookResult = ReturnType<typeof useCoursesTotalQuery>;
export type CoursesTotalLazyQueryHookResult = ReturnType<typeof useCoursesTotalLazyQuery>;
export type CoursesTotalSuspenseQueryHookResult = ReturnType<typeof useCoursesTotalSuspenseQuery>;
export type CoursesTotalQueryResult = Apollo.QueryResult<CoursesTotalQuery, CoursesTotalQueryVariables>;
export const DeleteCourseDocument = gql`
    mutation deleteCourse($courseDocumentId: ID!) {
  updateCourse(documentId: $courseDocumentId, data: {deleted: true}) {
    documentId
  }
}
    `;
export type DeleteCourseMutationFn = Apollo.MutationFunction<DeleteCourseMutation, DeleteCourseMutationVariables>;
export function useDeleteCourseMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCourseMutation, DeleteCourseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCourseMutation, DeleteCourseMutationVariables>(DeleteCourseDocument, options);
      }
export type DeleteCourseMutationHookResult = ReturnType<typeof useDeleteCourseMutation>;
export type DeleteCourseMutationResult = Apollo.MutationResult<DeleteCourseMutation>;
export const DownloadActivityLogsCsvDocument = gql`
    query downloadActivityLogsCsv($input: DownloadActivityLogsCsvInput!) {
  downloadActivityLogsCsv(input: $input) {
    buffer
    success
    filename
  }
}
    `;
export function useDownloadActivityLogsCsvQuery(baseOptions: Apollo.QueryHookOptions<DownloadActivityLogsCsvQuery, DownloadActivityLogsCsvQueryVariables> & ({ variables: DownloadActivityLogsCsvQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadActivityLogsCsvQuery, DownloadActivityLogsCsvQueryVariables>(DownloadActivityLogsCsvDocument, options);
      }
export function useDownloadActivityLogsCsvLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadActivityLogsCsvQuery, DownloadActivityLogsCsvQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadActivityLogsCsvQuery, DownloadActivityLogsCsvQueryVariables>(DownloadActivityLogsCsvDocument, options);
        }
export function useDownloadActivityLogsCsvSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DownloadActivityLogsCsvQuery, DownloadActivityLogsCsvQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DownloadActivityLogsCsvQuery, DownloadActivityLogsCsvQueryVariables>(DownloadActivityLogsCsvDocument, options);
        }
export type DownloadActivityLogsCsvQueryHookResult = ReturnType<typeof useDownloadActivityLogsCsvQuery>;
export type DownloadActivityLogsCsvLazyQueryHookResult = ReturnType<typeof useDownloadActivityLogsCsvLazyQuery>;
export type DownloadActivityLogsCsvSuspenseQueryHookResult = ReturnType<typeof useDownloadActivityLogsCsvSuspenseQuery>;
export type DownloadActivityLogsCsvQueryResult = Apollo.QueryResult<DownloadActivityLogsCsvQuery, DownloadActivityLogsCsvQueryVariables>;
export const DonwloadStudentsCsvDocument = gql`
    query donwloadStudentsCsv($input: DownloadStudentsCsvInput!) {
  downloadStudentsCsv(input: $input) {
    buffer
    filename
    success
  }
}
    `;
export function useDonwloadStudentsCsvQuery(baseOptions: Apollo.QueryHookOptions<DonwloadStudentsCsvQuery, DonwloadStudentsCsvQueryVariables> & ({ variables: DonwloadStudentsCsvQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DonwloadStudentsCsvQuery, DonwloadStudentsCsvQueryVariables>(DonwloadStudentsCsvDocument, options);
      }
export function useDonwloadStudentsCsvLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DonwloadStudentsCsvQuery, DonwloadStudentsCsvQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DonwloadStudentsCsvQuery, DonwloadStudentsCsvQueryVariables>(DonwloadStudentsCsvDocument, options);
        }
export function useDonwloadStudentsCsvSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DonwloadStudentsCsvQuery, DonwloadStudentsCsvQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DonwloadStudentsCsvQuery, DonwloadStudentsCsvQueryVariables>(DonwloadStudentsCsvDocument, options);
        }
export type DonwloadStudentsCsvQueryHookResult = ReturnType<typeof useDonwloadStudentsCsvQuery>;
export type DonwloadStudentsCsvLazyQueryHookResult = ReturnType<typeof useDonwloadStudentsCsvLazyQuery>;
export type DonwloadStudentsCsvSuspenseQueryHookResult = ReturnType<typeof useDonwloadStudentsCsvSuspenseQuery>;
export type DonwloadStudentsCsvQueryResult = Apollo.QueryResult<DonwloadStudentsCsvQuery, DonwloadStudentsCsvQueryVariables>;
export const EditCustomMasterNotificationDocument = gql`
    mutation EditCustomMasterNotification($id: ID!, $input: MasterNotificationCustomInput!) {
  updateMasterNotificationCustom(documentId: $id, data: $input) {
    documentId
  }
}
    `;
export type EditCustomMasterNotificationMutationFn = Apollo.MutationFunction<EditCustomMasterNotificationMutation, EditCustomMasterNotificationMutationVariables>;
export function useEditCustomMasterNotificationMutation(baseOptions?: Apollo.MutationHookOptions<EditCustomMasterNotificationMutation, EditCustomMasterNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditCustomMasterNotificationMutation, EditCustomMasterNotificationMutationVariables>(EditCustomMasterNotificationDocument, options);
      }
export type EditCustomMasterNotificationMutationHookResult = ReturnType<typeof useEditCustomMasterNotificationMutation>;
export type EditCustomMasterNotificationMutationResult = Apollo.MutationResult<EditCustomMasterNotificationMutation>;
export const GetCustomMasterNotificationDocument = gql`
    query GetCustomMasterNotification($documentId: ID!) {
  masterNotificationCustom(documentId: $documentId) {
    roles
    title
    type
    pushDate
    pushTime
    groups
    timeZone
    description
    documentId
    variables
    type
    sentAt
  }
}
    `;
export function useGetCustomMasterNotificationQuery(baseOptions: Apollo.QueryHookOptions<GetCustomMasterNotificationQuery, GetCustomMasterNotificationQueryVariables> & ({ variables: GetCustomMasterNotificationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomMasterNotificationQuery, GetCustomMasterNotificationQueryVariables>(GetCustomMasterNotificationDocument, options);
      }
export function useGetCustomMasterNotificationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomMasterNotificationQuery, GetCustomMasterNotificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomMasterNotificationQuery, GetCustomMasterNotificationQueryVariables>(GetCustomMasterNotificationDocument, options);
        }
export function useGetCustomMasterNotificationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomMasterNotificationQuery, GetCustomMasterNotificationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomMasterNotificationQuery, GetCustomMasterNotificationQueryVariables>(GetCustomMasterNotificationDocument, options);
        }
export type GetCustomMasterNotificationQueryHookResult = ReturnType<typeof useGetCustomMasterNotificationQuery>;
export type GetCustomMasterNotificationLazyQueryHookResult = ReturnType<typeof useGetCustomMasterNotificationLazyQuery>;
export type GetCustomMasterNotificationSuspenseQueryHookResult = ReturnType<typeof useGetCustomMasterNotificationSuspenseQuery>;
export type GetCustomMasterNotificationQueryResult = Apollo.QueryResult<GetCustomMasterNotificationQuery, GetCustomMasterNotificationQueryVariables>;
export const GetMasterNotificationsCustomDocument = gql`
    query getMasterNotificationsCustom($pagination: PaginationArg, $sort: [String], $filters: MasterNotificationCustomFiltersInput) {
  masterNotificationCustoms_connection(
    filters: $filters
    pagination: $pagination
    sort: $sort
  ) {
    nodes {
      documentId
      createdAt
      type
      updatedAt
      sentAt
      timeZone
      title
      description
      pushDate
      pushTime
      roles
      groups
    }
    pageInfo {
      page
      pageCount
      pageSize
      total
    }
  }
}
    `;
export function useGetMasterNotificationsCustomQuery(baseOptions?: Apollo.QueryHookOptions<GetMasterNotificationsCustomQuery, GetMasterNotificationsCustomQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMasterNotificationsCustomQuery, GetMasterNotificationsCustomQueryVariables>(GetMasterNotificationsCustomDocument, options);
      }
export function useGetMasterNotificationsCustomLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMasterNotificationsCustomQuery, GetMasterNotificationsCustomQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMasterNotificationsCustomQuery, GetMasterNotificationsCustomQueryVariables>(GetMasterNotificationsCustomDocument, options);
        }
export function useGetMasterNotificationsCustomSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMasterNotificationsCustomQuery, GetMasterNotificationsCustomQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMasterNotificationsCustomQuery, GetMasterNotificationsCustomQueryVariables>(GetMasterNotificationsCustomDocument, options);
        }
export type GetMasterNotificationsCustomQueryHookResult = ReturnType<typeof useGetMasterNotificationsCustomQuery>;
export type GetMasterNotificationsCustomLazyQueryHookResult = ReturnType<typeof useGetMasterNotificationsCustomLazyQuery>;
export type GetMasterNotificationsCustomSuspenseQueryHookResult = ReturnType<typeof useGetMasterNotificationsCustomSuspenseQuery>;
export type GetMasterNotificationsCustomQueryResult = Apollo.QueryResult<GetMasterNotificationsCustomQuery, GetMasterNotificationsCustomQueryVariables>;
export const IsAssignedOnCourseDocument = gql`
    query isAssignedOnCourse($userId: ID!) {
  me {
    student {
      inprogressCourses {
        students(filters: {user: {documentId: {eq: $userId}}}) {
          documentId
        }
      }
      completedCourses {
        students(filters: {user: {documentId: {eq: $userId}}}) {
          documentId
        }
      }
    }
  }
}
    `;
export function useIsAssignedOnCourseQuery(baseOptions: Apollo.QueryHookOptions<IsAssignedOnCourseQuery, IsAssignedOnCourseQueryVariables> & ({ variables: IsAssignedOnCourseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsAssignedOnCourseQuery, IsAssignedOnCourseQueryVariables>(IsAssignedOnCourseDocument, options);
      }
export function useIsAssignedOnCourseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsAssignedOnCourseQuery, IsAssignedOnCourseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsAssignedOnCourseQuery, IsAssignedOnCourseQueryVariables>(IsAssignedOnCourseDocument, options);
        }
export function useIsAssignedOnCourseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IsAssignedOnCourseQuery, IsAssignedOnCourseQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IsAssignedOnCourseQuery, IsAssignedOnCourseQueryVariables>(IsAssignedOnCourseDocument, options);
        }
export type IsAssignedOnCourseQueryHookResult = ReturnType<typeof useIsAssignedOnCourseQuery>;
export type IsAssignedOnCourseLazyQueryHookResult = ReturnType<typeof useIsAssignedOnCourseLazyQuery>;
export type IsAssignedOnCourseSuspenseQueryHookResult = ReturnType<typeof useIsAssignedOnCourseSuspenseQuery>;
export type IsAssignedOnCourseQueryResult = Apollo.QueryResult<IsAssignedOnCourseQuery, IsAssignedOnCourseQueryVariables>;
export const LanguagesDocument = gql`
    query languages {
  i18NLocales {
    documentId
    name
    code
  }
}
    `;
export function useLanguagesQuery(baseOptions?: Apollo.QueryHookOptions<LanguagesQuery, LanguagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LanguagesQuery, LanguagesQueryVariables>(LanguagesDocument, options);
      }
export function useLanguagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LanguagesQuery, LanguagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LanguagesQuery, LanguagesQueryVariables>(LanguagesDocument, options);
        }
export function useLanguagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LanguagesQuery, LanguagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LanguagesQuery, LanguagesQueryVariables>(LanguagesDocument, options);
        }
export type LanguagesQueryHookResult = ReturnType<typeof useLanguagesQuery>;
export type LanguagesLazyQueryHookResult = ReturnType<typeof useLanguagesLazyQuery>;
export type LanguagesSuspenseQueryHookResult = ReturnType<typeof useLanguagesSuspenseQuery>;
export type LanguagesQueryResult = Apollo.QueryResult<LanguagesQuery, LanguagesQueryVariables>;
export const LikeCommentDocument = gql`
    mutation likeComment($commentId: String!) {
  createLikeToComment(input: {commentId: $commentId}) {
    id
    success
  }
}
    `;
export type LikeCommentMutationFn = Apollo.MutationFunction<LikeCommentMutation, LikeCommentMutationVariables>;
export function useLikeCommentMutation(baseOptions?: Apollo.MutationHookOptions<LikeCommentMutation, LikeCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LikeCommentMutation, LikeCommentMutationVariables>(LikeCommentDocument, options);
      }
export type LikeCommentMutationHookResult = ReturnType<typeof useLikeCommentMutation>;
export type LikeCommentMutationResult = Apollo.MutationResult<LikeCommentMutation>;
export const MyCoursesDocument = gql`
    query myCourses($input: MyCoursesInput!) {
  myCourses(input: $input) {
    totalCompleted
    totalInprogress
    totalCourses
    courses {
      documentId
      title
    }
    completedCourses {
      documentId
      template
      title
      completedChaptersCount
      chapters
      cover {
        url
        formats
      }
      category {
        label
        documentId
      }
    }
    inprogressCourses {
      completedChaptersCount
      documentId
      template
      title
      chapters
      cover {
        url
        formats
      }
      category {
        label
        documentId
      }
    }
  }
}
    `;
export function useMyCoursesQuery(baseOptions: Apollo.QueryHookOptions<MyCoursesQuery, MyCoursesQueryVariables> & ({ variables: MyCoursesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyCoursesQuery, MyCoursesQueryVariables>(MyCoursesDocument, options);
      }
export function useMyCoursesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyCoursesQuery, MyCoursesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyCoursesQuery, MyCoursesQueryVariables>(MyCoursesDocument, options);
        }
export function useMyCoursesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyCoursesQuery, MyCoursesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyCoursesQuery, MyCoursesQueryVariables>(MyCoursesDocument, options);
        }
export type MyCoursesQueryHookResult = ReturnType<typeof useMyCoursesQuery>;
export type MyCoursesLazyQueryHookResult = ReturnType<typeof useMyCoursesLazyQuery>;
export type MyCoursesSuspenseQueryHookResult = ReturnType<typeof useMyCoursesSuspenseQuery>;
export type MyCoursesQueryResult = Apollo.QueryResult<MyCoursesQuery, MyCoursesQueryVariables>;
export const MyCoursesTotalDocument = gql`
    query myCoursesTotal {
  myCoursesTotal {
    completedTotal
    inprogressTotal
  }
}
    `;
export function useMyCoursesTotalQuery(baseOptions?: Apollo.QueryHookOptions<MyCoursesTotalQuery, MyCoursesTotalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyCoursesTotalQuery, MyCoursesTotalQueryVariables>(MyCoursesTotalDocument, options);
      }
export function useMyCoursesTotalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyCoursesTotalQuery, MyCoursesTotalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyCoursesTotalQuery, MyCoursesTotalQueryVariables>(MyCoursesTotalDocument, options);
        }
export function useMyCoursesTotalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyCoursesTotalQuery, MyCoursesTotalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyCoursesTotalQuery, MyCoursesTotalQueryVariables>(MyCoursesTotalDocument, options);
        }
export type MyCoursesTotalQueryHookResult = ReturnType<typeof useMyCoursesTotalQuery>;
export type MyCoursesTotalLazyQueryHookResult = ReturnType<typeof useMyCoursesTotalLazyQuery>;
export type MyCoursesTotalSuspenseQueryHookResult = ReturnType<typeof useMyCoursesTotalSuspenseQuery>;
export type MyCoursesTotalQueryResult = Apollo.QueryResult<MyCoursesTotalQuery, MyCoursesTotalQueryVariables>;
export const MyLikesDocument = gql`
    query myLikes($postsId: [ID!]!, $sender: ID) {
  postLikes_connection(
    filters: {post: {documentId: {in: $postsId}}, sender: {documentId: {eq: $sender}}}
  ) {
    nodes {
      documentId
      post {
        documentId
      }
    }
  }
}
    `;
export function useMyLikesQuery(baseOptions: Apollo.QueryHookOptions<MyLikesQuery, MyLikesQueryVariables> & ({ variables: MyLikesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyLikesQuery, MyLikesQueryVariables>(MyLikesDocument, options);
      }
export function useMyLikesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyLikesQuery, MyLikesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyLikesQuery, MyLikesQueryVariables>(MyLikesDocument, options);
        }
export function useMyLikesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyLikesQuery, MyLikesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyLikesQuery, MyLikesQueryVariables>(MyLikesDocument, options);
        }
export type MyLikesQueryHookResult = ReturnType<typeof useMyLikesQuery>;
export type MyLikesLazyQueryHookResult = ReturnType<typeof useMyLikesLazyQuery>;
export type MyLikesSuspenseQueryHookResult = ReturnType<typeof useMyLikesSuspenseQuery>;
export type MyLikesQueryResult = Apollo.QueryResult<MyLikesQuery, MyLikesQueryVariables>;
export const MyProgramsDocument = gql`
    query myPrograms($input: MyProgramsInput!) {
  myPrograms(input: $input) {
    programs {
      ...ProgramSummary
    }
    completedPrograms {
      ...ProgramSummary
    }
    inprogressPrograms {
      ...ProgramSummary
    }
    totalPrograms
    totalInprogressPrograms
    totalCompletedPrograms
  }
}
    ${ProgramSummaryFragmentDoc}`;
export function useMyProgramsQuery(baseOptions: Apollo.QueryHookOptions<MyProgramsQuery, MyProgramsQueryVariables> & ({ variables: MyProgramsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyProgramsQuery, MyProgramsQueryVariables>(MyProgramsDocument, options);
      }
export function useMyProgramsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyProgramsQuery, MyProgramsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyProgramsQuery, MyProgramsQueryVariables>(MyProgramsDocument, options);
        }
export function useMyProgramsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyProgramsQuery, MyProgramsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyProgramsQuery, MyProgramsQueryVariables>(MyProgramsDocument, options);
        }
export type MyProgramsQueryHookResult = ReturnType<typeof useMyProgramsQuery>;
export type MyProgramsLazyQueryHookResult = ReturnType<typeof useMyProgramsLazyQuery>;
export type MyProgramsSuspenseQueryHookResult = ReturnType<typeof useMyProgramsSuspenseQuery>;
export type MyProgramsQueryResult = Apollo.QueryResult<MyProgramsQuery, MyProgramsQueryVariables>;
export const NotAssignedStudentsDocument = gql`
    query notAssignedStudents($input: NotAssignedStudentsInput!) {
  notAssignedStudents(input: $input) {
    data {
      documentId
      createdAt
      firstName
      lastName
      role
      status
    }
    total
  }
}
    `;
export function useNotAssignedStudentsQuery(baseOptions: Apollo.QueryHookOptions<NotAssignedStudentsQuery, NotAssignedStudentsQueryVariables> & ({ variables: NotAssignedStudentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotAssignedStudentsQuery, NotAssignedStudentsQueryVariables>(NotAssignedStudentsDocument, options);
      }
export function useNotAssignedStudentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotAssignedStudentsQuery, NotAssignedStudentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotAssignedStudentsQuery, NotAssignedStudentsQueryVariables>(NotAssignedStudentsDocument, options);
        }
export function useNotAssignedStudentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NotAssignedStudentsQuery, NotAssignedStudentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NotAssignedStudentsQuery, NotAssignedStudentsQueryVariables>(NotAssignedStudentsDocument, options);
        }
export type NotAssignedStudentsQueryHookResult = ReturnType<typeof useNotAssignedStudentsQuery>;
export type NotAssignedStudentsLazyQueryHookResult = ReturnType<typeof useNotAssignedStudentsLazyQuery>;
export type NotAssignedStudentsSuspenseQueryHookResult = ReturnType<typeof useNotAssignedStudentsSuspenseQuery>;
export type NotAssignedStudentsQueryResult = Apollo.QueryResult<NotAssignedStudentsQuery, NotAssignedStudentsQueryVariables>;
export const NotificationSettingsDocument = gql`
    query notificationSettings {
  me {
    id
    isEmailRecipient
    coursesNotificationsEnabled
    programsNotificationsEnabled
    postsNotificationsEnabled
    customNotificationsEnabled
  }
}
    `;
export function useNotificationSettingsQuery(baseOptions?: Apollo.QueryHookOptions<NotificationSettingsQuery, NotificationSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationSettingsQuery, NotificationSettingsQueryVariables>(NotificationSettingsDocument, options);
      }
export function useNotificationSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationSettingsQuery, NotificationSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationSettingsQuery, NotificationSettingsQueryVariables>(NotificationSettingsDocument, options);
        }
export function useNotificationSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NotificationSettingsQuery, NotificationSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NotificationSettingsQuery, NotificationSettingsQueryVariables>(NotificationSettingsDocument, options);
        }
export type NotificationSettingsQueryHookResult = ReturnType<typeof useNotificationSettingsQuery>;
export type NotificationSettingsLazyQueryHookResult = ReturnType<typeof useNotificationSettingsLazyQuery>;
export type NotificationSettingsSuspenseQueryHookResult = ReturnType<typeof useNotificationSettingsSuspenseQuery>;
export type NotificationSettingsQueryResult = Apollo.QueryResult<NotificationSettingsQuery, NotificationSettingsQueryVariables>;
export const AuthPageDocument = gql`
    query authPage($locale: I18NLocaleCode) {
  authorisationPage(locale: $locale) {
    documentId
    image {
      name
      url
      alternativeText
      documentId
    }
    locale
  }
}
    `;
export function useAuthPageQuery(baseOptions?: Apollo.QueryHookOptions<AuthPageQuery, AuthPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuthPageQuery, AuthPageQueryVariables>(AuthPageDocument, options);
      }
export function useAuthPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuthPageQuery, AuthPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuthPageQuery, AuthPageQueryVariables>(AuthPageDocument, options);
        }
export function useAuthPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuthPageQuery, AuthPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AuthPageQuery, AuthPageQueryVariables>(AuthPageDocument, options);
        }
export type AuthPageQueryHookResult = ReturnType<typeof useAuthPageQuery>;
export type AuthPageLazyQueryHookResult = ReturnType<typeof useAuthPageLazyQuery>;
export type AuthPageSuspenseQueryHookResult = ReturnType<typeof useAuthPageSuspenseQuery>;
export type AuthPageQueryResult = Apollo.QueryResult<AuthPageQuery, AuthPageQueryVariables>;
export const PrivacyPolicyPageDocument = gql`
    query privacyPolicyPage {
  privacyPolicyPage {
    documentId
    content
  }
}
    `;
export function usePrivacyPolicyPageQuery(baseOptions?: Apollo.QueryHookOptions<PrivacyPolicyPageQuery, PrivacyPolicyPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PrivacyPolicyPageQuery, PrivacyPolicyPageQueryVariables>(PrivacyPolicyPageDocument, options);
      }
export function usePrivacyPolicyPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PrivacyPolicyPageQuery, PrivacyPolicyPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PrivacyPolicyPageQuery, PrivacyPolicyPageQueryVariables>(PrivacyPolicyPageDocument, options);
        }
export function usePrivacyPolicyPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PrivacyPolicyPageQuery, PrivacyPolicyPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PrivacyPolicyPageQuery, PrivacyPolicyPageQueryVariables>(PrivacyPolicyPageDocument, options);
        }
export type PrivacyPolicyPageQueryHookResult = ReturnType<typeof usePrivacyPolicyPageQuery>;
export type PrivacyPolicyPageLazyQueryHookResult = ReturnType<typeof usePrivacyPolicyPageLazyQuery>;
export type PrivacyPolicyPageSuspenseQueryHookResult = ReturnType<typeof usePrivacyPolicyPageSuspenseQuery>;
export type PrivacyPolicyPageQueryResult = Apollo.QueryResult<PrivacyPolicyPageQuery, PrivacyPolicyPageQueryVariables>;
export const TermsPageDocument = gql`
    query termsPage {
  termsPage {
    documentId
    content
  }
}
    `;
export function useTermsPageQuery(baseOptions?: Apollo.QueryHookOptions<TermsPageQuery, TermsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TermsPageQuery, TermsPageQueryVariables>(TermsPageDocument, options);
      }
export function useTermsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TermsPageQuery, TermsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TermsPageQuery, TermsPageQueryVariables>(TermsPageDocument, options);
        }
export function useTermsPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TermsPageQuery, TermsPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TermsPageQuery, TermsPageQueryVariables>(TermsPageDocument, options);
        }
export type TermsPageQueryHookResult = ReturnType<typeof useTermsPageQuery>;
export type TermsPageLazyQueryHookResult = ReturnType<typeof useTermsPageLazyQuery>;
export type TermsPageSuspenseQueryHookResult = ReturnType<typeof useTermsPageSuspenseQuery>;
export type TermsPageQueryResult = Apollo.QueryResult<TermsPageQuery, TermsPageQueryVariables>;
export const PostDocument = gql`
    query post($documentId: ID!, $myId: ID) {
  post(documentId: $documentId) {
    ...PostBase
    comments {
      documentId
      createdAt
      title
      comment_likes(filters: {sender: {documentId: {eq: $myId}}}) {
        documentId
        sender {
          id
          lastName
          firstName
          avatar {
            url
          }
        }
      }
      likesCount
      sender {
        user {
          firstName
          lastName
          avatar {
            formats
            url
          }
        }
      }
    }
  }
}
    ${PostBaseFragmentDoc}`;
export function usePostQuery(baseOptions: Apollo.QueryHookOptions<PostQuery, PostQueryVariables> & ({ variables: PostQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PostQuery, PostQueryVariables>(PostDocument, options);
      }
export function usePostLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PostQuery, PostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PostQuery, PostQueryVariables>(PostDocument, options);
        }
export function usePostSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PostQuery, PostQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PostQuery, PostQueryVariables>(PostDocument, options);
        }
export type PostQueryHookResult = ReturnType<typeof usePostQuery>;
export type PostLazyQueryHookResult = ReturnType<typeof usePostLazyQuery>;
export type PostSuspenseQueryHookResult = ReturnType<typeof usePostSuspenseQuery>;
export type PostQueryResult = Apollo.QueryResult<PostQuery, PostQueryVariables>;
export const PostCategoriesDocument = gql`
    query postCategories($filters: PostCategoryFiltersInput, $pagination: PaginationArg, $sort: [String]) {
  postCategories(filters: $filters, pagination: $pagination, sort: $sort) {
    documentId
    label
    posts(pagination: {limit: 1}) {
      documentId
    }
  }
}
    `;
export function usePostCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<PostCategoriesQuery, PostCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PostCategoriesQuery, PostCategoriesQueryVariables>(PostCategoriesDocument, options);
      }
export function usePostCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PostCategoriesQuery, PostCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PostCategoriesQuery, PostCategoriesQueryVariables>(PostCategoriesDocument, options);
        }
export function usePostCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PostCategoriesQuery, PostCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PostCategoriesQuery, PostCategoriesQueryVariables>(PostCategoriesDocument, options);
        }
export type PostCategoriesQueryHookResult = ReturnType<typeof usePostCategoriesQuery>;
export type PostCategoriesLazyQueryHookResult = ReturnType<typeof usePostCategoriesLazyQuery>;
export type PostCategoriesSuspenseQueryHookResult = ReturnType<typeof usePostCategoriesSuspenseQuery>;
export type PostCategoriesQueryResult = Apollo.QueryResult<PostCategoriesQuery, PostCategoriesQueryVariables>;
export const PostLikesDocument = gql`
    query postLikes($filters: PostLikeFiltersInput) {
  postLikes(filters: $filters) {
    sender {
      id
      lastName
      firstName
      avatar {
        url
      }
    }
  }
}
    `;
export function usePostLikesQuery(baseOptions?: Apollo.QueryHookOptions<PostLikesQuery, PostLikesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PostLikesQuery, PostLikesQueryVariables>(PostLikesDocument, options);
      }
export function usePostLikesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PostLikesQuery, PostLikesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PostLikesQuery, PostLikesQueryVariables>(PostLikesDocument, options);
        }
export function usePostLikesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PostLikesQuery, PostLikesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PostLikesQuery, PostLikesQueryVariables>(PostLikesDocument, options);
        }
export type PostLikesQueryHookResult = ReturnType<typeof usePostLikesQuery>;
export type PostLikesLazyQueryHookResult = ReturnType<typeof usePostLikesLazyQuery>;
export type PostLikesSuspenseQueryHookResult = ReturnType<typeof usePostLikesSuspenseQuery>;
export type PostLikesQueryResult = Apollo.QueryResult<PostLikesQuery, PostLikesQueryVariables>;
export const PostWithCommentsDocument = gql`
    query postWithComments($documentId: ID!, $myId: ID!, $page: Int!, $pageSize: Int!) {
  post(documentId: $documentId) {
    documentId
    title
  }
  postComments_connection(
    filters: {post: {documentId: {eq: $documentId}}}
    pagination: {page: $page, pageSize: $pageSize}
    sort: "createdAt:desc"
  ) {
    nodes {
      documentId
      createdAt
      title
      comment_likes(filters: {sender: {documentId: {eq: $myId}}}) {
        documentId
        sender {
          id
          lastName
          firstName
          avatar {
            url
          }
        }
      }
      likesCount
      sender {
        user {
          firstName
          lastName
          avatar {
            formats
            url
          }
        }
      }
    }
    pageInfo {
      total
      page
      pageSize
      pageCount
    }
  }
}
    `;
export function usePostWithCommentsQuery(baseOptions: Apollo.QueryHookOptions<PostWithCommentsQuery, PostWithCommentsQueryVariables> & ({ variables: PostWithCommentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PostWithCommentsQuery, PostWithCommentsQueryVariables>(PostWithCommentsDocument, options);
      }
export function usePostWithCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PostWithCommentsQuery, PostWithCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PostWithCommentsQuery, PostWithCommentsQueryVariables>(PostWithCommentsDocument, options);
        }
export function usePostWithCommentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PostWithCommentsQuery, PostWithCommentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PostWithCommentsQuery, PostWithCommentsQueryVariables>(PostWithCommentsDocument, options);
        }
export type PostWithCommentsQueryHookResult = ReturnType<typeof usePostWithCommentsQuery>;
export type PostWithCommentsLazyQueryHookResult = ReturnType<typeof usePostWithCommentsLazyQuery>;
export type PostWithCommentsSuspenseQueryHookResult = ReturnType<typeof usePostWithCommentsSuspenseQuery>;
export type PostWithCommentsQueryResult = Apollo.QueryResult<PostWithCommentsQuery, PostWithCommentsQueryVariables>;
export const PostsDocument = gql`
    query posts($filters: PostFiltersInput, $pagination: PaginationArg, $sort: [String]) {
  posts_connection(filters: $filters, pagination: $pagination, sort: $sort) {
    nodes {
      ...PostBase
    }
    pageInfo {
      total
    }
  }
}
    ${PostBaseFragmentDoc}`;
export function usePostsQuery(baseOptions?: Apollo.QueryHookOptions<PostsQuery, PostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PostsQuery, PostsQueryVariables>(PostsDocument, options);
      }
export function usePostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PostsQuery, PostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PostsQuery, PostsQueryVariables>(PostsDocument, options);
        }
export function usePostsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PostsQuery, PostsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PostsQuery, PostsQueryVariables>(PostsDocument, options);
        }
export type PostsQueryHookResult = ReturnType<typeof usePostsQuery>;
export type PostsLazyQueryHookResult = ReturnType<typeof usePostsLazyQuery>;
export type PostsSuspenseQueryHookResult = ReturnType<typeof usePostsSuspenseQuery>;
export type PostsQueryResult = Apollo.QueryResult<PostsQuery, PostsQueryVariables>;
export const PostsCategoriesDocument = gql`
    query postsCategories($filters: PostFiltersInput, $pagination: PaginationArg, $sort: [String]) {
  posts(filters: $filters, pagination: $pagination, sort: $sort) {
    category {
      documentId
      label
    }
  }
}
    `;
export function usePostsCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<PostsCategoriesQuery, PostsCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PostsCategoriesQuery, PostsCategoriesQueryVariables>(PostsCategoriesDocument, options);
      }
export function usePostsCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PostsCategoriesQuery, PostsCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PostsCategoriesQuery, PostsCategoriesQueryVariables>(PostsCategoriesDocument, options);
        }
export function usePostsCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PostsCategoriesQuery, PostsCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PostsCategoriesQuery, PostsCategoriesQueryVariables>(PostsCategoriesDocument, options);
        }
export type PostsCategoriesQueryHookResult = ReturnType<typeof usePostsCategoriesQuery>;
export type PostsCategoriesLazyQueryHookResult = ReturnType<typeof usePostsCategoriesLazyQuery>;
export type PostsCategoriesSuspenseQueryHookResult = ReturnType<typeof usePostsCategoriesSuspenseQuery>;
export type PostsCategoriesQueryResult = Apollo.QueryResult<PostsCategoriesQuery, PostsCategoriesQueryVariables>;
export const DownloadProgramCoursesCsvDocument = gql`
    query downloadProgramCoursesCsv($input: DownloadProgramCoursesCsvInput!) {
  downloadProgramCoursesCsv(input: $input) {
    buffer
    filename
    success
  }
}
    `;
export function useDownloadProgramCoursesCsvQuery(baseOptions: Apollo.QueryHookOptions<DownloadProgramCoursesCsvQuery, DownloadProgramCoursesCsvQueryVariables> & ({ variables: DownloadProgramCoursesCsvQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadProgramCoursesCsvQuery, DownloadProgramCoursesCsvQueryVariables>(DownloadProgramCoursesCsvDocument, options);
      }
export function useDownloadProgramCoursesCsvLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadProgramCoursesCsvQuery, DownloadProgramCoursesCsvQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadProgramCoursesCsvQuery, DownloadProgramCoursesCsvQueryVariables>(DownloadProgramCoursesCsvDocument, options);
        }
export function useDownloadProgramCoursesCsvSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DownloadProgramCoursesCsvQuery, DownloadProgramCoursesCsvQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DownloadProgramCoursesCsvQuery, DownloadProgramCoursesCsvQueryVariables>(DownloadProgramCoursesCsvDocument, options);
        }
export type DownloadProgramCoursesCsvQueryHookResult = ReturnType<typeof useDownloadProgramCoursesCsvQuery>;
export type DownloadProgramCoursesCsvLazyQueryHookResult = ReturnType<typeof useDownloadProgramCoursesCsvLazyQuery>;
export type DownloadProgramCoursesCsvSuspenseQueryHookResult = ReturnType<typeof useDownloadProgramCoursesCsvSuspenseQuery>;
export type DownloadProgramCoursesCsvQueryResult = Apollo.QueryResult<DownloadProgramCoursesCsvQuery, DownloadProgramCoursesCsvQueryVariables>;
export const DownloadProgramStudentsCsvDocument = gql`
    query downloadProgramStudentsCsv($input: DownloadProgramStudentsCsvInput!) {
  downloadProgramStudentsCsv(input: $input) {
    buffer
    filename
    success
  }
}
    `;
export function useDownloadProgramStudentsCsvQuery(baseOptions: Apollo.QueryHookOptions<DownloadProgramStudentsCsvQuery, DownloadProgramStudentsCsvQueryVariables> & ({ variables: DownloadProgramStudentsCsvQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadProgramStudentsCsvQuery, DownloadProgramStudentsCsvQueryVariables>(DownloadProgramStudentsCsvDocument, options);
      }
export function useDownloadProgramStudentsCsvLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadProgramStudentsCsvQuery, DownloadProgramStudentsCsvQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadProgramStudentsCsvQuery, DownloadProgramStudentsCsvQueryVariables>(DownloadProgramStudentsCsvDocument, options);
        }
export function useDownloadProgramStudentsCsvSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DownloadProgramStudentsCsvQuery, DownloadProgramStudentsCsvQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DownloadProgramStudentsCsvQuery, DownloadProgramStudentsCsvQueryVariables>(DownloadProgramStudentsCsvDocument, options);
        }
export type DownloadProgramStudentsCsvQueryHookResult = ReturnType<typeof useDownloadProgramStudentsCsvQuery>;
export type DownloadProgramStudentsCsvLazyQueryHookResult = ReturnType<typeof useDownloadProgramStudentsCsvLazyQuery>;
export type DownloadProgramStudentsCsvSuspenseQueryHookResult = ReturnType<typeof useDownloadProgramStudentsCsvSuspenseQuery>;
export type DownloadProgramStudentsCsvQueryResult = Apollo.QueryResult<DownloadProgramStudentsCsvQuery, DownloadProgramStudentsCsvQueryVariables>;
export const ProgramDocument = gql`
    query program($id: ID!) {
  program(documentId: $id) {
    ...Program
  }
}
    ${ProgramFragmentDoc}`;
export function useProgramQuery(baseOptions: Apollo.QueryHookOptions<ProgramQuery, ProgramQueryVariables> & ({ variables: ProgramQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProgramQuery, ProgramQueryVariables>(ProgramDocument, options);
      }
export function useProgramLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProgramQuery, ProgramQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProgramQuery, ProgramQueryVariables>(ProgramDocument, options);
        }
export function useProgramSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProgramQuery, ProgramQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProgramQuery, ProgramQueryVariables>(ProgramDocument, options);
        }
export type ProgramQueryHookResult = ReturnType<typeof useProgramQuery>;
export type ProgramLazyQueryHookResult = ReturnType<typeof useProgramLazyQuery>;
export type ProgramSuspenseQueryHookResult = ReturnType<typeof useProgramSuspenseQuery>;
export type ProgramQueryResult = Apollo.QueryResult<ProgramQuery, ProgramQueryVariables>;
export const ProgramCategoriesForMyLearningDocument = gql`
    query ProgramCategoriesForMyLearning {
  programCategoriesForMyLearning {
    allCategories {
      documentId
      label
    }
    completedCategories {
      documentId
      label
    }
    inProgressCategories {
      documentId
      label
    }
  }
}
    `;
export function useProgramCategoriesForMyLearningQuery(baseOptions?: Apollo.QueryHookOptions<ProgramCategoriesForMyLearningQuery, ProgramCategoriesForMyLearningQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProgramCategoriesForMyLearningQuery, ProgramCategoriesForMyLearningQueryVariables>(ProgramCategoriesForMyLearningDocument, options);
      }
export function useProgramCategoriesForMyLearningLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProgramCategoriesForMyLearningQuery, ProgramCategoriesForMyLearningQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProgramCategoriesForMyLearningQuery, ProgramCategoriesForMyLearningQueryVariables>(ProgramCategoriesForMyLearningDocument, options);
        }
export function useProgramCategoriesForMyLearningSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProgramCategoriesForMyLearningQuery, ProgramCategoriesForMyLearningQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProgramCategoriesForMyLearningQuery, ProgramCategoriesForMyLearningQueryVariables>(ProgramCategoriesForMyLearningDocument, options);
        }
export type ProgramCategoriesForMyLearningQueryHookResult = ReturnType<typeof useProgramCategoriesForMyLearningQuery>;
export type ProgramCategoriesForMyLearningLazyQueryHookResult = ReturnType<typeof useProgramCategoriesForMyLearningLazyQuery>;
export type ProgramCategoriesForMyLearningSuspenseQueryHookResult = ReturnType<typeof useProgramCategoriesForMyLearningSuspenseQuery>;
export type ProgramCategoriesForMyLearningQueryResult = Apollo.QueryResult<ProgramCategoriesForMyLearningQuery, ProgramCategoriesForMyLearningQueryVariables>;
export const ProgramCertificateDocument = gql`
    query ProgramCertificate($input: ProgramResultsInput) {
  programCertificate(input: $input) {
    id
    programId
  }
}
    `;
export function useProgramCertificateQuery(baseOptions?: Apollo.QueryHookOptions<ProgramCertificateQuery, ProgramCertificateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProgramCertificateQuery, ProgramCertificateQueryVariables>(ProgramCertificateDocument, options);
      }
export function useProgramCertificateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProgramCertificateQuery, ProgramCertificateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProgramCertificateQuery, ProgramCertificateQueryVariables>(ProgramCertificateDocument, options);
        }
export function useProgramCertificateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProgramCertificateQuery, ProgramCertificateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProgramCertificateQuery, ProgramCertificateQueryVariables>(ProgramCertificateDocument, options);
        }
export type ProgramCertificateQueryHookResult = ReturnType<typeof useProgramCertificateQuery>;
export type ProgramCertificateLazyQueryHookResult = ReturnType<typeof useProgramCertificateLazyQuery>;
export type ProgramCertificateSuspenseQueryHookResult = ReturnType<typeof useProgramCertificateSuspenseQuery>;
export type ProgramCertificateQueryResult = Apollo.QueryResult<ProgramCertificateQuery, ProgramCertificateQueryVariables>;
export const ProgramCoursesDocument = gql`
    query programCourses($input: ProgramCoursesInput!) {
  programCourses(input: $input) {
    data {
      id
      documentId
      title
      dateAssigned
      category {
        documentId
        label
      }
      totalUsersCompleted
      totalUsers
      order
      status
    }
    meta {
      pagination {
        page
        pageSize
        pageCount
        total
      }
    }
  }
}
    `;
export function useProgramCoursesQuery(baseOptions: Apollo.QueryHookOptions<ProgramCoursesQuery, ProgramCoursesQueryVariables> & ({ variables: ProgramCoursesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProgramCoursesQuery, ProgramCoursesQueryVariables>(ProgramCoursesDocument, options);
      }
export function useProgramCoursesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProgramCoursesQuery, ProgramCoursesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProgramCoursesQuery, ProgramCoursesQueryVariables>(ProgramCoursesDocument, options);
        }
export function useProgramCoursesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProgramCoursesQuery, ProgramCoursesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProgramCoursesQuery, ProgramCoursesQueryVariables>(ProgramCoursesDocument, options);
        }
export type ProgramCoursesQueryHookResult = ReturnType<typeof useProgramCoursesQuery>;
export type ProgramCoursesLazyQueryHookResult = ReturnType<typeof useProgramCoursesLazyQuery>;
export type ProgramCoursesSuspenseQueryHookResult = ReturnType<typeof useProgramCoursesSuspenseQuery>;
export type ProgramCoursesQueryResult = Apollo.QueryResult<ProgramCoursesQuery, ProgramCoursesQueryVariables>;
export const ProgramResultsDocument = gql`
    query ProgramResults($input: ProgramResultsInput!) {
  programResults(input: $input) {
    chapters
    quizzes {
      done
      total
    }
    score
  }
}
    `;
export function useProgramResultsQuery(baseOptions: Apollo.QueryHookOptions<ProgramResultsQuery, ProgramResultsQueryVariables> & ({ variables: ProgramResultsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProgramResultsQuery, ProgramResultsQueryVariables>(ProgramResultsDocument, options);
      }
export function useProgramResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProgramResultsQuery, ProgramResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProgramResultsQuery, ProgramResultsQueryVariables>(ProgramResultsDocument, options);
        }
export function useProgramResultsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProgramResultsQuery, ProgramResultsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProgramResultsQuery, ProgramResultsQueryVariables>(ProgramResultsDocument, options);
        }
export type ProgramResultsQueryHookResult = ReturnType<typeof useProgramResultsQuery>;
export type ProgramResultsLazyQueryHookResult = ReturnType<typeof useProgramResultsLazyQuery>;
export type ProgramResultsSuspenseQueryHookResult = ReturnType<typeof useProgramResultsSuspenseQuery>;
export type ProgramResultsQueryResult = Apollo.QueryResult<ProgramResultsQuery, ProgramResultsQueryVariables>;
export const ProgramStatsDocument = gql`
    query programStats($input: ProgramStatsInput!) {
  programStats(input: $input) {
    info {
      title
      status
    }
    stats {
      title
      count
    }
  }
}
    `;
export function useProgramStatsQuery(baseOptions: Apollo.QueryHookOptions<ProgramStatsQuery, ProgramStatsQueryVariables> & ({ variables: ProgramStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProgramStatsQuery, ProgramStatsQueryVariables>(ProgramStatsDocument, options);
      }
export function useProgramStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProgramStatsQuery, ProgramStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProgramStatsQuery, ProgramStatsQueryVariables>(ProgramStatsDocument, options);
        }
export function useProgramStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProgramStatsQuery, ProgramStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProgramStatsQuery, ProgramStatsQueryVariables>(ProgramStatsDocument, options);
        }
export type ProgramStatsQueryHookResult = ReturnType<typeof useProgramStatsQuery>;
export type ProgramStatsLazyQueryHookResult = ReturnType<typeof useProgramStatsLazyQuery>;
export type ProgramStatsSuspenseQueryHookResult = ReturnType<typeof useProgramStatsSuspenseQuery>;
export type ProgramStatsQueryResult = Apollo.QueryResult<ProgramStatsQuery, ProgramStatsQueryVariables>;
export const ProgramStudentsDocument = gql`
    query programStudents($documentId: ID!, $pagination: PaginationArg, $filters: CourseStudentFiltersInput, $sort: [String]) {
  program(documentId: $documentId) {
    courses(
      filters: {deleted: {eq: false}, isActive: {eq: true}, courseStatus: {eq: "published"}, template: {eq: false}}
    ) {
      documentId
    }
  }
  courseStudents_connection(
    pagination: $pagination
    filters: $filters
    sort: $sort
  ) {
    nodes {
      documentId
      user {
        id
        documentId
        role {
          name
        }
        lastName
        firstName
      }
      events(
        filters: {program: {documentId: {eq: $documentId}}, type: {in: ["program_completed", "program_assigned"]}}
      ) {
        createdAt
        type
      }
      completedCourses(filters: {programs: {documentId: {eq: $documentId}}}) {
        documentId
      }
    }
    pageInfo {
      total
      page
      pageSize
      pageCount
    }
  }
}
    `;
export function useProgramStudentsQuery(baseOptions: Apollo.QueryHookOptions<ProgramStudentsQuery, ProgramStudentsQueryVariables> & ({ variables: ProgramStudentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProgramStudentsQuery, ProgramStudentsQueryVariables>(ProgramStudentsDocument, options);
      }
export function useProgramStudentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProgramStudentsQuery, ProgramStudentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProgramStudentsQuery, ProgramStudentsQueryVariables>(ProgramStudentsDocument, options);
        }
export function useProgramStudentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProgramStudentsQuery, ProgramStudentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProgramStudentsQuery, ProgramStudentsQueryVariables>(ProgramStudentsDocument, options);
        }
export type ProgramStudentsQueryHookResult = ReturnType<typeof useProgramStudentsQuery>;
export type ProgramStudentsLazyQueryHookResult = ReturnType<typeof useProgramStudentsLazyQuery>;
export type ProgramStudentsSuspenseQueryHookResult = ReturnType<typeof useProgramStudentsSuspenseQuery>;
export type ProgramStudentsQueryResult = Apollo.QueryResult<ProgramStudentsQuery, ProgramStudentsQueryVariables>;
export const ProgramStudentsFilterOptionsDocument = gql`
    query programStudentsFilterOptions($filters: CourseStudentFiltersInput) {
  courseStudents_connection(
    pagination: {page: 1, pageSize: 3000000}
    filters: $filters
  ) {
    nodes {
      documentId
      user {
        documentId
        firstName
        lastName
      }
    }
  }
}
    `;
export function useProgramStudentsFilterOptionsQuery(baseOptions?: Apollo.QueryHookOptions<ProgramStudentsFilterOptionsQuery, ProgramStudentsFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProgramStudentsFilterOptionsQuery, ProgramStudentsFilterOptionsQueryVariables>(ProgramStudentsFilterOptionsDocument, options);
      }
export function useProgramStudentsFilterOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProgramStudentsFilterOptionsQuery, ProgramStudentsFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProgramStudentsFilterOptionsQuery, ProgramStudentsFilterOptionsQueryVariables>(ProgramStudentsFilterOptionsDocument, options);
        }
export function useProgramStudentsFilterOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProgramStudentsFilterOptionsQuery, ProgramStudentsFilterOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProgramStudentsFilterOptionsQuery, ProgramStudentsFilterOptionsQueryVariables>(ProgramStudentsFilterOptionsDocument, options);
        }
export type ProgramStudentsFilterOptionsQueryHookResult = ReturnType<typeof useProgramStudentsFilterOptionsQuery>;
export type ProgramStudentsFilterOptionsLazyQueryHookResult = ReturnType<typeof useProgramStudentsFilterOptionsLazyQuery>;
export type ProgramStudentsFilterOptionsSuspenseQueryHookResult = ReturnType<typeof useProgramStudentsFilterOptionsSuspenseQuery>;
export type ProgramStudentsFilterOptionsQueryResult = Apollo.QueryResult<ProgramStudentsFilterOptionsQuery, ProgramStudentsFilterOptionsQueryVariables>;
export const ProgramStudentsListDocument = gql`
    query programStudentsList($input: ProgramStudentsListInput, $programId: ID!) {
  program(documentId: $programId) {
    courses(
      filters: {deleted: {eq: false}, isActive: {eq: true}, courseStatus: {eq: "published"}, template: {eq: false}}
    ) {
      documentId
    }
  }
  programStudentsList(input: $input) {
    data {
      documentId
      dateAssigned
      dateCompleted
      coursesProgress
      user {
        documentId
        firstName
        lastName
        role {
          name
        }
      }
    }
    meta {
      pagination {
        total
        page
        pageSize
      }
    }
  }
}
    `;
export function useProgramStudentsListQuery(baseOptions: Apollo.QueryHookOptions<ProgramStudentsListQuery, ProgramStudentsListQueryVariables> & ({ variables: ProgramStudentsListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProgramStudentsListQuery, ProgramStudentsListQueryVariables>(ProgramStudentsListDocument, options);
      }
export function useProgramStudentsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProgramStudentsListQuery, ProgramStudentsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProgramStudentsListQuery, ProgramStudentsListQueryVariables>(ProgramStudentsListDocument, options);
        }
export function useProgramStudentsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProgramStudentsListQuery, ProgramStudentsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProgramStudentsListQuery, ProgramStudentsListQueryVariables>(ProgramStudentsListDocument, options);
        }
export type ProgramStudentsListQueryHookResult = ReturnType<typeof useProgramStudentsListQuery>;
export type ProgramStudentsListLazyQueryHookResult = ReturnType<typeof useProgramStudentsListLazyQuery>;
export type ProgramStudentsListSuspenseQueryHookResult = ReturnType<typeof useProgramStudentsListSuspenseQuery>;
export type ProgramStudentsListQueryResult = Apollo.QueryResult<ProgramStudentsListQuery, ProgramStudentsListQueryVariables>;
export const ProgramsDocument = gql`
    query programs($filters: ProgramFiltersInput, $pagination: PaginationArg, $sort: [String]) {
  programs_connection(filters: $filters, pagination: $pagination, sort: $sort) {
    nodes {
      ...Program
    }
    pageInfo {
      total
    }
  }
}
    ${ProgramFragmentDoc}`;
export function useProgramsQuery(baseOptions?: Apollo.QueryHookOptions<ProgramsQuery, ProgramsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProgramsQuery, ProgramsQueryVariables>(ProgramsDocument, options);
      }
export function useProgramsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProgramsQuery, ProgramsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProgramsQuery, ProgramsQueryVariables>(ProgramsDocument, options);
        }
export function useProgramsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProgramsQuery, ProgramsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProgramsQuery, ProgramsQueryVariables>(ProgramsDocument, options);
        }
export type ProgramsQueryHookResult = ReturnType<typeof useProgramsQuery>;
export type ProgramsLazyQueryHookResult = ReturnType<typeof useProgramsLazyQuery>;
export type ProgramsSuspenseQueryHookResult = ReturnType<typeof useProgramsSuspenseQuery>;
export type ProgramsQueryResult = Apollo.QueryResult<ProgramsQuery, ProgramsQueryVariables>;
export const ProgramsCategoriesDocument = gql`
    query programsCategories($filters: ProgramCategoryFiltersInput, $pagination: PaginationArg, $sort: [String]) {
  programCategories(filters: $filters, pagination: $pagination, sort: $sort) {
    documentId
    label
    programs(pagination: {limit: 1}) {
      documentId
    }
  }
}
    `;
export function useProgramsCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<ProgramsCategoriesQuery, ProgramsCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProgramsCategoriesQuery, ProgramsCategoriesQueryVariables>(ProgramsCategoriesDocument, options);
      }
export function useProgramsCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProgramsCategoriesQuery, ProgramsCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProgramsCategoriesQuery, ProgramsCategoriesQueryVariables>(ProgramsCategoriesDocument, options);
        }
export function useProgramsCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProgramsCategoriesQuery, ProgramsCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProgramsCategoriesQuery, ProgramsCategoriesQueryVariables>(ProgramsCategoriesDocument, options);
        }
export type ProgramsCategoriesQueryHookResult = ReturnType<typeof useProgramsCategoriesQuery>;
export type ProgramsCategoriesLazyQueryHookResult = ReturnType<typeof useProgramsCategoriesLazyQuery>;
export type ProgramsCategoriesSuspenseQueryHookResult = ReturnType<typeof useProgramsCategoriesSuspenseQuery>;
export type ProgramsCategoriesQueryResult = Apollo.QueryResult<ProgramsCategoriesQuery, ProgramsCategoriesQueryVariables>;
export const ProgramsTotalDocument = gql`
    query programsTotal($documentId: [ID!], $type: JSONFilterInput, $category: ProgramCategoryFiltersInput) {
  all: programs_connection(
    filters: {documentId: {in: $documentId}, type: $type, deleted: {eq: false}, category: $category}
    pagination: {page: 1, pageSize: 3000000}
  ) {
    pageInfo {
      total
    }
  }
  active: programs_connection(
    filters: {documentId: {in: $documentId}, type: $type, active: {eq: true}, category: $category, deleted: {eq: false}}
    pagination: {page: 1, pageSize: 3000000}
  ) {
    pageInfo {
      total
    }
  }
  inactive: programs_connection(
    filters: {documentId: {in: $documentId}, type: $type, active: {eq: false}, category: $category, deleted: {eq: false}}
    pagination: {page: 1, pageSize: 3000000}
  ) {
    pageInfo {
      total
    }
  }
}
    `;
export function useProgramsTotalQuery(baseOptions?: Apollo.QueryHookOptions<ProgramsTotalQuery, ProgramsTotalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProgramsTotalQuery, ProgramsTotalQueryVariables>(ProgramsTotalDocument, options);
      }
export function useProgramsTotalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProgramsTotalQuery, ProgramsTotalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProgramsTotalQuery, ProgramsTotalQueryVariables>(ProgramsTotalDocument, options);
        }
export function useProgramsTotalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProgramsTotalQuery, ProgramsTotalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProgramsTotalQuery, ProgramsTotalQueryVariables>(ProgramsTotalDocument, options);
        }
export type ProgramsTotalQueryHookResult = ReturnType<typeof useProgramsTotalQuery>;
export type ProgramsTotalLazyQueryHookResult = ReturnType<typeof useProgramsTotalLazyQuery>;
export type ProgramsTotalSuspenseQueryHookResult = ReturnType<typeof useProgramsTotalSuspenseQuery>;
export type ProgramsTotalQueryResult = Apollo.QueryResult<ProgramsTotalQuery, ProgramsTotalQueryVariables>;
export const QuizResultsDocument = gql`
    query quizResults($chapterId: ID!) {
  me {
    student {
      chapterResults(filters: {courseChapter: {documentId: {eq: $chapterId}}}) {
        quizResults
        quizId
      }
    }
  }
}
    `;
export function useQuizResultsQuery(baseOptions: Apollo.QueryHookOptions<QuizResultsQuery, QuizResultsQueryVariables> & ({ variables: QuizResultsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuizResultsQuery, QuizResultsQueryVariables>(QuizResultsDocument, options);
      }
export function useQuizResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuizResultsQuery, QuizResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuizResultsQuery, QuizResultsQueryVariables>(QuizResultsDocument, options);
        }
export function useQuizResultsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<QuizResultsQuery, QuizResultsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QuizResultsQuery, QuizResultsQueryVariables>(QuizResultsDocument, options);
        }
export type QuizResultsQueryHookResult = ReturnType<typeof useQuizResultsQuery>;
export type QuizResultsLazyQueryHookResult = ReturnType<typeof useQuizResultsLazyQuery>;
export type QuizResultsSuspenseQueryHookResult = ReturnType<typeof useQuizResultsSuspenseQuery>;
export type QuizResultsQueryResult = Apollo.QueryResult<QuizResultsQuery, QuizResultsQueryVariables>;
export const RegionsDocument = gql`
    query regions($filters: RegionFiltersInput, $pagination: PaginationArg, $sort: [String]) {
  regions(filters: $filters, pagination: $pagination, sort: $sort) {
    documentId
    name
    abbreviation
  }
}
    `;
export function useRegionsQuery(baseOptions?: Apollo.QueryHookOptions<RegionsQuery, RegionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RegionsQuery, RegionsQueryVariables>(RegionsDocument, options);
      }
export function useRegionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RegionsQuery, RegionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RegionsQuery, RegionsQueryVariables>(RegionsDocument, options);
        }
export function useRegionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RegionsQuery, RegionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RegionsQuery, RegionsQueryVariables>(RegionsDocument, options);
        }
export type RegionsQueryHookResult = ReturnType<typeof useRegionsQuery>;
export type RegionsLazyQueryHookResult = ReturnType<typeof useRegionsLazyQuery>;
export type RegionsSuspenseQueryHookResult = ReturnType<typeof useRegionsSuspenseQuery>;
export type RegionsQueryResult = Apollo.QueryResult<RegionsQuery, RegionsQueryVariables>;
export const DownloadReportCourseXlsxDocument = gql`
    query downloadReportCourseXlsx($input: DownloadReportCourseXlsxInput!) {
  downloadReportCourseXlsx(input: $input) {
    buffer
    filename
    success
  }
}
    `;
export function useDownloadReportCourseXlsxQuery(baseOptions: Apollo.QueryHookOptions<DownloadReportCourseXlsxQuery, DownloadReportCourseXlsxQueryVariables> & ({ variables: DownloadReportCourseXlsxQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadReportCourseXlsxQuery, DownloadReportCourseXlsxQueryVariables>(DownloadReportCourseXlsxDocument, options);
      }
export function useDownloadReportCourseXlsxLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadReportCourseXlsxQuery, DownloadReportCourseXlsxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadReportCourseXlsxQuery, DownloadReportCourseXlsxQueryVariables>(DownloadReportCourseXlsxDocument, options);
        }
export function useDownloadReportCourseXlsxSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DownloadReportCourseXlsxQuery, DownloadReportCourseXlsxQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DownloadReportCourseXlsxQuery, DownloadReportCourseXlsxQueryVariables>(DownloadReportCourseXlsxDocument, options);
        }
export type DownloadReportCourseXlsxQueryHookResult = ReturnType<typeof useDownloadReportCourseXlsxQuery>;
export type DownloadReportCourseXlsxLazyQueryHookResult = ReturnType<typeof useDownloadReportCourseXlsxLazyQuery>;
export type DownloadReportCourseXlsxSuspenseQueryHookResult = ReturnType<typeof useDownloadReportCourseXlsxSuspenseQuery>;
export type DownloadReportCourseXlsxQueryResult = Apollo.QueryResult<DownloadReportCourseXlsxQuery, DownloadReportCourseXlsxQueryVariables>;
export const DownloadReportCoursesCsvDocument = gql`
    query downloadReportCoursesCsv($input: DownloadReportCoursesCsvInput!) {
  downloadReportCoursesCsv(input: $input) {
    buffer
    filename
    success
  }
}
    `;
export function useDownloadReportCoursesCsvQuery(baseOptions: Apollo.QueryHookOptions<DownloadReportCoursesCsvQuery, DownloadReportCoursesCsvQueryVariables> & ({ variables: DownloadReportCoursesCsvQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadReportCoursesCsvQuery, DownloadReportCoursesCsvQueryVariables>(DownloadReportCoursesCsvDocument, options);
      }
export function useDownloadReportCoursesCsvLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadReportCoursesCsvQuery, DownloadReportCoursesCsvQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadReportCoursesCsvQuery, DownloadReportCoursesCsvQueryVariables>(DownloadReportCoursesCsvDocument, options);
        }
export function useDownloadReportCoursesCsvSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DownloadReportCoursesCsvQuery, DownloadReportCoursesCsvQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DownloadReportCoursesCsvQuery, DownloadReportCoursesCsvQueryVariables>(DownloadReportCoursesCsvDocument, options);
        }
export type DownloadReportCoursesCsvQueryHookResult = ReturnType<typeof useDownloadReportCoursesCsvQuery>;
export type DownloadReportCoursesCsvLazyQueryHookResult = ReturnType<typeof useDownloadReportCoursesCsvLazyQuery>;
export type DownloadReportCoursesCsvSuspenseQueryHookResult = ReturnType<typeof useDownloadReportCoursesCsvSuspenseQuery>;
export type DownloadReportCoursesCsvQueryResult = Apollo.QueryResult<DownloadReportCoursesCsvQuery, DownloadReportCoursesCsvQueryVariables>;
export const DownloadReportCoursesZipDocument = gql`
    query downloadReportCoursesZip($input: DownloadReportCoursesZipInput!) {
  downloadReportCoursesZip(input: $input) {
    buffer
    filename
    success
  }
}
    `;
export function useDownloadReportCoursesZipQuery(baseOptions: Apollo.QueryHookOptions<DownloadReportCoursesZipQuery, DownloadReportCoursesZipQueryVariables> & ({ variables: DownloadReportCoursesZipQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadReportCoursesZipQuery, DownloadReportCoursesZipQueryVariables>(DownloadReportCoursesZipDocument, options);
      }
export function useDownloadReportCoursesZipLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadReportCoursesZipQuery, DownloadReportCoursesZipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadReportCoursesZipQuery, DownloadReportCoursesZipQueryVariables>(DownloadReportCoursesZipDocument, options);
        }
export function useDownloadReportCoursesZipSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DownloadReportCoursesZipQuery, DownloadReportCoursesZipQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DownloadReportCoursesZipQuery, DownloadReportCoursesZipQueryVariables>(DownloadReportCoursesZipDocument, options);
        }
export type DownloadReportCoursesZipQueryHookResult = ReturnType<typeof useDownloadReportCoursesZipQuery>;
export type DownloadReportCoursesZipLazyQueryHookResult = ReturnType<typeof useDownloadReportCoursesZipLazyQuery>;
export type DownloadReportCoursesZipSuspenseQueryHookResult = ReturnType<typeof useDownloadReportCoursesZipSuspenseQuery>;
export type DownloadReportCoursesZipQueryResult = Apollo.QueryResult<DownloadReportCoursesZipQuery, DownloadReportCoursesZipQueryVariables>;
export const ReportCourseDocument = gql`
    query reportCourse($input: ReportCourseInput!) {
  reportCourse(input: $input) {
    title
    createdOn
    author
    type
    category
    stats {
      totalUsers
      totalCompletions
      completionRate
      usersInProgress
    }
    regionalDistribution {
      region
      users
      percentage
    }
    averageQuizScores {
      chapter
      quizzes {
        type
        averageScore
        required
        completionRate
      }
    }
  }
}
    `;
export function useReportCourseQuery(baseOptions: Apollo.QueryHookOptions<ReportCourseQuery, ReportCourseQueryVariables> & ({ variables: ReportCourseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportCourseQuery, ReportCourseQueryVariables>(ReportCourseDocument, options);
      }
export function useReportCourseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportCourseQuery, ReportCourseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportCourseQuery, ReportCourseQueryVariables>(ReportCourseDocument, options);
        }
export function useReportCourseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportCourseQuery, ReportCourseQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportCourseQuery, ReportCourseQueryVariables>(ReportCourseDocument, options);
        }
export type ReportCourseQueryHookResult = ReturnType<typeof useReportCourseQuery>;
export type ReportCourseLazyQueryHookResult = ReturnType<typeof useReportCourseLazyQuery>;
export type ReportCourseSuspenseQueryHookResult = ReturnType<typeof useReportCourseSuspenseQuery>;
export type ReportCourseQueryResult = Apollo.QueryResult<ReportCourseQuery, ReportCourseQueryVariables>;
export const ReportCourseChaptersDocument = gql`
    query reportCourseChapters($input: ReportCourseChaptersInput!) {
  reportCourseChapters(input: $input) {
    data {
      chapter
      usersCompleted
      completionRate
    }
    meta {
      pagination {
        page
        pageSize
        pageCount
        total
      }
    }
  }
}
    `;
export function useReportCourseChaptersQuery(baseOptions: Apollo.QueryHookOptions<ReportCourseChaptersQuery, ReportCourseChaptersQueryVariables> & ({ variables: ReportCourseChaptersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportCourseChaptersQuery, ReportCourseChaptersQueryVariables>(ReportCourseChaptersDocument, options);
      }
export function useReportCourseChaptersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportCourseChaptersQuery, ReportCourseChaptersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportCourseChaptersQuery, ReportCourseChaptersQueryVariables>(ReportCourseChaptersDocument, options);
        }
export function useReportCourseChaptersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportCourseChaptersQuery, ReportCourseChaptersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportCourseChaptersQuery, ReportCourseChaptersQueryVariables>(ReportCourseChaptersDocument, options);
        }
export type ReportCourseChaptersQueryHookResult = ReturnType<typeof useReportCourseChaptersQuery>;
export type ReportCourseChaptersLazyQueryHookResult = ReturnType<typeof useReportCourseChaptersLazyQuery>;
export type ReportCourseChaptersSuspenseQueryHookResult = ReturnType<typeof useReportCourseChaptersSuspenseQuery>;
export type ReportCourseChaptersQueryResult = Apollo.QueryResult<ReportCourseChaptersQuery, ReportCourseChaptersQueryVariables>;
export const ReportCourseCompletionDocument = gql`
    query reportCourseCompletion($input: ReportCourseCompletionInput) {
  reportCourseCompletion(input: $input) {
    data {
      completed
      completionDate
      email
      location
      name
      region
      role
    }
    meta {
      pagination {
        page
        pageSize
        pageCount
        total
      }
    }
  }
}
    `;
export function useReportCourseCompletionQuery(baseOptions?: Apollo.QueryHookOptions<ReportCourseCompletionQuery, ReportCourseCompletionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportCourseCompletionQuery, ReportCourseCompletionQueryVariables>(ReportCourseCompletionDocument, options);
      }
export function useReportCourseCompletionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportCourseCompletionQuery, ReportCourseCompletionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportCourseCompletionQuery, ReportCourseCompletionQueryVariables>(ReportCourseCompletionDocument, options);
        }
export function useReportCourseCompletionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportCourseCompletionQuery, ReportCourseCompletionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportCourseCompletionQuery, ReportCourseCompletionQueryVariables>(ReportCourseCompletionDocument, options);
        }
export type ReportCourseCompletionQueryHookResult = ReturnType<typeof useReportCourseCompletionQuery>;
export type ReportCourseCompletionLazyQueryHookResult = ReturnType<typeof useReportCourseCompletionLazyQuery>;
export type ReportCourseCompletionSuspenseQueryHookResult = ReturnType<typeof useReportCourseCompletionSuspenseQuery>;
export type ReportCourseCompletionQueryResult = Apollo.QueryResult<ReportCourseCompletionQuery, ReportCourseCompletionQueryVariables>;
export const ReportCoursesDocument = gql`
    query reportCourses($filters: CourseFiltersInput, $pagination: PaginationArg, $sort: [String]) {
  reportCourses(input: {filters: $filters, pagination: $pagination, sort: $sort}) {
    data {
      title
      completedStudentsCount
      totalUsers
      isActive
      documentId
      category {
        label
        documentId
      }
    }
    meta {
      pagination {
        total
        page
        pageCount
        pageSize
        total
      }
    }
    all
    active
    inactive
  }
}
    `;
export function useReportCoursesQuery(baseOptions?: Apollo.QueryHookOptions<ReportCoursesQuery, ReportCoursesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportCoursesQuery, ReportCoursesQueryVariables>(ReportCoursesDocument, options);
      }
export function useReportCoursesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportCoursesQuery, ReportCoursesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportCoursesQuery, ReportCoursesQueryVariables>(ReportCoursesDocument, options);
        }
export function useReportCoursesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportCoursesQuery, ReportCoursesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportCoursesQuery, ReportCoursesQueryVariables>(ReportCoursesDocument, options);
        }
export type ReportCoursesQueryHookResult = ReturnType<typeof useReportCoursesQuery>;
export type ReportCoursesLazyQueryHookResult = ReturnType<typeof useReportCoursesLazyQuery>;
export type ReportCoursesSuspenseQueryHookResult = ReturnType<typeof useReportCoursesSuspenseQuery>;
export type ReportCoursesQueryResult = Apollo.QueryResult<ReportCoursesQuery, ReportCoursesQueryVariables>;
export const DownloadReportProgramCourseXlsxDocument = gql`
    query downloadReportProgramCourseXlsx($input: DownloadReportProgramCourseXlsxInput!) {
  downloadReportProgramCourseXlsx(input: $input) {
    buffer
    filename
    success
  }
}
    `;
export function useDownloadReportProgramCourseXlsxQuery(baseOptions: Apollo.QueryHookOptions<DownloadReportProgramCourseXlsxQuery, DownloadReportProgramCourseXlsxQueryVariables> & ({ variables: DownloadReportProgramCourseXlsxQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadReportProgramCourseXlsxQuery, DownloadReportProgramCourseXlsxQueryVariables>(DownloadReportProgramCourseXlsxDocument, options);
      }
export function useDownloadReportProgramCourseXlsxLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadReportProgramCourseXlsxQuery, DownloadReportProgramCourseXlsxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadReportProgramCourseXlsxQuery, DownloadReportProgramCourseXlsxQueryVariables>(DownloadReportProgramCourseXlsxDocument, options);
        }
export function useDownloadReportProgramCourseXlsxSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DownloadReportProgramCourseXlsxQuery, DownloadReportProgramCourseXlsxQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DownloadReportProgramCourseXlsxQuery, DownloadReportProgramCourseXlsxQueryVariables>(DownloadReportProgramCourseXlsxDocument, options);
        }
export type DownloadReportProgramCourseXlsxQueryHookResult = ReturnType<typeof useDownloadReportProgramCourseXlsxQuery>;
export type DownloadReportProgramCourseXlsxLazyQueryHookResult = ReturnType<typeof useDownloadReportProgramCourseXlsxLazyQuery>;
export type DownloadReportProgramCourseXlsxSuspenseQueryHookResult = ReturnType<typeof useDownloadReportProgramCourseXlsxSuspenseQuery>;
export type DownloadReportProgramCourseXlsxQueryResult = Apollo.QueryResult<DownloadReportProgramCourseXlsxQuery, DownloadReportProgramCourseXlsxQueryVariables>;
export const DownloadReportProgramCoursesZipDocument = gql`
    query downloadReportProgramCoursesZip($input: DownloadReportProgramCoursesZipInput!) {
  downloadReportProgramCoursesZip(input: $input) {
    buffer
    filename
    success
  }
}
    `;
export function useDownloadReportProgramCoursesZipQuery(baseOptions: Apollo.QueryHookOptions<DownloadReportProgramCoursesZipQuery, DownloadReportProgramCoursesZipQueryVariables> & ({ variables: DownloadReportProgramCoursesZipQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadReportProgramCoursesZipQuery, DownloadReportProgramCoursesZipQueryVariables>(DownloadReportProgramCoursesZipDocument, options);
      }
export function useDownloadReportProgramCoursesZipLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadReportProgramCoursesZipQuery, DownloadReportProgramCoursesZipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadReportProgramCoursesZipQuery, DownloadReportProgramCoursesZipQueryVariables>(DownloadReportProgramCoursesZipDocument, options);
        }
export function useDownloadReportProgramCoursesZipSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DownloadReportProgramCoursesZipQuery, DownloadReportProgramCoursesZipQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DownloadReportProgramCoursesZipQuery, DownloadReportProgramCoursesZipQueryVariables>(DownloadReportProgramCoursesZipDocument, options);
        }
export type DownloadReportProgramCoursesZipQueryHookResult = ReturnType<typeof useDownloadReportProgramCoursesZipQuery>;
export type DownloadReportProgramCoursesZipLazyQueryHookResult = ReturnType<typeof useDownloadReportProgramCoursesZipLazyQuery>;
export type DownloadReportProgramCoursesZipSuspenseQueryHookResult = ReturnType<typeof useDownloadReportProgramCoursesZipSuspenseQuery>;
export type DownloadReportProgramCoursesZipQueryResult = Apollo.QueryResult<DownloadReportProgramCoursesZipQuery, DownloadReportProgramCoursesZipQueryVariables>;
export const DownloadReportProgramXlsxDocument = gql`
    query downloadReportProgramXlsx($input: DownloadReportProgramXlsxInput!) {
  downloadReportProgramXlsx(input: $input) {
    buffer
    filename
    success
  }
}
    `;
export function useDownloadReportProgramXlsxQuery(baseOptions: Apollo.QueryHookOptions<DownloadReportProgramXlsxQuery, DownloadReportProgramXlsxQueryVariables> & ({ variables: DownloadReportProgramXlsxQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadReportProgramXlsxQuery, DownloadReportProgramXlsxQueryVariables>(DownloadReportProgramXlsxDocument, options);
      }
export function useDownloadReportProgramXlsxLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadReportProgramXlsxQuery, DownloadReportProgramXlsxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadReportProgramXlsxQuery, DownloadReportProgramXlsxQueryVariables>(DownloadReportProgramXlsxDocument, options);
        }
export function useDownloadReportProgramXlsxSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DownloadReportProgramXlsxQuery, DownloadReportProgramXlsxQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DownloadReportProgramXlsxQuery, DownloadReportProgramXlsxQueryVariables>(DownloadReportProgramXlsxDocument, options);
        }
export type DownloadReportProgramXlsxQueryHookResult = ReturnType<typeof useDownloadReportProgramXlsxQuery>;
export type DownloadReportProgramXlsxLazyQueryHookResult = ReturnType<typeof useDownloadReportProgramXlsxLazyQuery>;
export type DownloadReportProgramXlsxSuspenseQueryHookResult = ReturnType<typeof useDownloadReportProgramXlsxSuspenseQuery>;
export type DownloadReportProgramXlsxQueryResult = Apollo.QueryResult<DownloadReportProgramXlsxQuery, DownloadReportProgramXlsxQueryVariables>;
export const DownloadReportProgramsCsvDocument = gql`
    query downloadReportProgramsCsv($input: DownloadReportProgramsCsvInput!) {
  downloadReportProgramsCsv(input: $input) {
    buffer
    filename
    success
  }
}
    `;
export function useDownloadReportProgramsCsvQuery(baseOptions: Apollo.QueryHookOptions<DownloadReportProgramsCsvQuery, DownloadReportProgramsCsvQueryVariables> & ({ variables: DownloadReportProgramsCsvQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadReportProgramsCsvQuery, DownloadReportProgramsCsvQueryVariables>(DownloadReportProgramsCsvDocument, options);
      }
export function useDownloadReportProgramsCsvLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadReportProgramsCsvQuery, DownloadReportProgramsCsvQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadReportProgramsCsvQuery, DownloadReportProgramsCsvQueryVariables>(DownloadReportProgramsCsvDocument, options);
        }
export function useDownloadReportProgramsCsvSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DownloadReportProgramsCsvQuery, DownloadReportProgramsCsvQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DownloadReportProgramsCsvQuery, DownloadReportProgramsCsvQueryVariables>(DownloadReportProgramsCsvDocument, options);
        }
export type DownloadReportProgramsCsvQueryHookResult = ReturnType<typeof useDownloadReportProgramsCsvQuery>;
export type DownloadReportProgramsCsvLazyQueryHookResult = ReturnType<typeof useDownloadReportProgramsCsvLazyQuery>;
export type DownloadReportProgramsCsvSuspenseQueryHookResult = ReturnType<typeof useDownloadReportProgramsCsvSuspenseQuery>;
export type DownloadReportProgramsCsvQueryResult = Apollo.QueryResult<DownloadReportProgramsCsvQuery, DownloadReportProgramsCsvQueryVariables>;
export const DownloadReportProgramsZipDocument = gql`
    query downloadReportProgramsZip($input: DownloadReportProgramsZipInput!) {
  downloadReportProgramsZip(input: $input) {
    buffer
    filename
    success
  }
}
    `;
export function useDownloadReportProgramsZipQuery(baseOptions: Apollo.QueryHookOptions<DownloadReportProgramsZipQuery, DownloadReportProgramsZipQueryVariables> & ({ variables: DownloadReportProgramsZipQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadReportProgramsZipQuery, DownloadReportProgramsZipQueryVariables>(DownloadReportProgramsZipDocument, options);
      }
export function useDownloadReportProgramsZipLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadReportProgramsZipQuery, DownloadReportProgramsZipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadReportProgramsZipQuery, DownloadReportProgramsZipQueryVariables>(DownloadReportProgramsZipDocument, options);
        }
export function useDownloadReportProgramsZipSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DownloadReportProgramsZipQuery, DownloadReportProgramsZipQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DownloadReportProgramsZipQuery, DownloadReportProgramsZipQueryVariables>(DownloadReportProgramsZipDocument, options);
        }
export type DownloadReportProgramsZipQueryHookResult = ReturnType<typeof useDownloadReportProgramsZipQuery>;
export type DownloadReportProgramsZipLazyQueryHookResult = ReturnType<typeof useDownloadReportProgramsZipLazyQuery>;
export type DownloadReportProgramsZipSuspenseQueryHookResult = ReturnType<typeof useDownloadReportProgramsZipSuspenseQuery>;
export type DownloadReportProgramsZipQueryResult = Apollo.QueryResult<DownloadReportProgramsZipQuery, DownloadReportProgramsZipQueryVariables>;
export const ReportProgramDocument = gql`
    query reportProgram($input: ReportProgramInput!) {
  reportProgram(input: $input) {
    title
    createdOn
    author
    type
    category
    stats {
      totalCourses
      totalUsers
      completionRate
      averageQuizScore
    }
    regionalDistribution {
      region
      users
      percentage
    }
  }
}
    `;
export function useReportProgramQuery(baseOptions: Apollo.QueryHookOptions<ReportProgramQuery, ReportProgramQueryVariables> & ({ variables: ReportProgramQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportProgramQuery, ReportProgramQueryVariables>(ReportProgramDocument, options);
      }
export function useReportProgramLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportProgramQuery, ReportProgramQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportProgramQuery, ReportProgramQueryVariables>(ReportProgramDocument, options);
        }
export function useReportProgramSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportProgramQuery, ReportProgramQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportProgramQuery, ReportProgramQueryVariables>(ReportProgramDocument, options);
        }
export type ReportProgramQueryHookResult = ReturnType<typeof useReportProgramQuery>;
export type ReportProgramLazyQueryHookResult = ReturnType<typeof useReportProgramLazyQuery>;
export type ReportProgramSuspenseQueryHookResult = ReturnType<typeof useReportProgramSuspenseQuery>;
export type ReportProgramQueryResult = Apollo.QueryResult<ReportProgramQuery, ReportProgramQueryVariables>;
export const ReportProgramCourseDocument = gql`
    query reportProgramCourse($input: ReportProgramCourseInput!) {
  reportProgramCourse(input: $input) {
    title
    createdOn
    author
    type
    category
    stats {
      totalUsers
      totalCompletions
      completionRate
      usersInProgress
    }
    regionalDistribution {
      region
      users
      percentage
    }
    averageQuizScores {
      chapter
      quizzes {
        type
        averageScore
        required
        completionRate
      }
    }
  }
}
    `;
export function useReportProgramCourseQuery(baseOptions: Apollo.QueryHookOptions<ReportProgramCourseQuery, ReportProgramCourseQueryVariables> & ({ variables: ReportProgramCourseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportProgramCourseQuery, ReportProgramCourseQueryVariables>(ReportProgramCourseDocument, options);
      }
export function useReportProgramCourseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportProgramCourseQuery, ReportProgramCourseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportProgramCourseQuery, ReportProgramCourseQueryVariables>(ReportProgramCourseDocument, options);
        }
export function useReportProgramCourseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportProgramCourseQuery, ReportProgramCourseQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportProgramCourseQuery, ReportProgramCourseQueryVariables>(ReportProgramCourseDocument, options);
        }
export type ReportProgramCourseQueryHookResult = ReturnType<typeof useReportProgramCourseQuery>;
export type ReportProgramCourseLazyQueryHookResult = ReturnType<typeof useReportProgramCourseLazyQuery>;
export type ReportProgramCourseSuspenseQueryHookResult = ReturnType<typeof useReportProgramCourseSuspenseQuery>;
export type ReportProgramCourseQueryResult = Apollo.QueryResult<ReportProgramCourseQuery, ReportProgramCourseQueryVariables>;
export const ReportProgramCourseChaptersDocument = gql`
    query reportProgramCourseChapters($input: ReportProgramCourseChaptersInput!) {
  reportProgramCourseChapters(input: $input) {
    data {
      chapter
      usersCompleted
      completionRate
    }
    meta {
      pagination {
        page
        pageSize
        pageCount
        total
      }
    }
  }
}
    `;
export function useReportProgramCourseChaptersQuery(baseOptions: Apollo.QueryHookOptions<ReportProgramCourseChaptersQuery, ReportProgramCourseChaptersQueryVariables> & ({ variables: ReportProgramCourseChaptersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportProgramCourseChaptersQuery, ReportProgramCourseChaptersQueryVariables>(ReportProgramCourseChaptersDocument, options);
      }
export function useReportProgramCourseChaptersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportProgramCourseChaptersQuery, ReportProgramCourseChaptersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportProgramCourseChaptersQuery, ReportProgramCourseChaptersQueryVariables>(ReportProgramCourseChaptersDocument, options);
        }
export function useReportProgramCourseChaptersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportProgramCourseChaptersQuery, ReportProgramCourseChaptersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportProgramCourseChaptersQuery, ReportProgramCourseChaptersQueryVariables>(ReportProgramCourseChaptersDocument, options);
        }
export type ReportProgramCourseChaptersQueryHookResult = ReturnType<typeof useReportProgramCourseChaptersQuery>;
export type ReportProgramCourseChaptersLazyQueryHookResult = ReturnType<typeof useReportProgramCourseChaptersLazyQuery>;
export type ReportProgramCourseChaptersSuspenseQueryHookResult = ReturnType<typeof useReportProgramCourseChaptersSuspenseQuery>;
export type ReportProgramCourseChaptersQueryResult = Apollo.QueryResult<ReportProgramCourseChaptersQuery, ReportProgramCourseChaptersQueryVariables>;
export const ReportProgramCourseCompletionDocument = gql`
    query reportProgramCourseCompletion($input: ReportProgramCourseCompletionInput) {
  reportProgramCourseCompletion(input: $input) {
    data {
      completed
      completionDate
      email
      location
      name
      region
      role
    }
    meta {
      pagination {
        page
        pageSize
        pageCount
        total
      }
    }
  }
}
    `;
export function useReportProgramCourseCompletionQuery(baseOptions?: Apollo.QueryHookOptions<ReportProgramCourseCompletionQuery, ReportProgramCourseCompletionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportProgramCourseCompletionQuery, ReportProgramCourseCompletionQueryVariables>(ReportProgramCourseCompletionDocument, options);
      }
export function useReportProgramCourseCompletionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportProgramCourseCompletionQuery, ReportProgramCourseCompletionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportProgramCourseCompletionQuery, ReportProgramCourseCompletionQueryVariables>(ReportProgramCourseCompletionDocument, options);
        }
export function useReportProgramCourseCompletionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportProgramCourseCompletionQuery, ReportProgramCourseCompletionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportProgramCourseCompletionQuery, ReportProgramCourseCompletionQueryVariables>(ReportProgramCourseCompletionDocument, options);
        }
export type ReportProgramCourseCompletionQueryHookResult = ReturnType<typeof useReportProgramCourseCompletionQuery>;
export type ReportProgramCourseCompletionLazyQueryHookResult = ReturnType<typeof useReportProgramCourseCompletionLazyQuery>;
export type ReportProgramCourseCompletionSuspenseQueryHookResult = ReturnType<typeof useReportProgramCourseCompletionSuspenseQuery>;
export type ReportProgramCourseCompletionQueryResult = Apollo.QueryResult<ReportProgramCourseCompletionQuery, ReportProgramCourseCompletionQueryVariables>;
export const ReportProgramCoursesDocument = gql`
    query reportProgramCourses($input: ReportProgramCoursesInput!) {
  reportProgramCourses(input: $input) {
    data {
      documentId
      name
      dateAssigned
      completionRate
      averageQuizScore
      status
    }
    meta {
      pagination {
        page
        pageSize
        pageCount
        total
      }
    }
  }
}
    `;
export function useReportProgramCoursesQuery(baseOptions: Apollo.QueryHookOptions<ReportProgramCoursesQuery, ReportProgramCoursesQueryVariables> & ({ variables: ReportProgramCoursesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportProgramCoursesQuery, ReportProgramCoursesQueryVariables>(ReportProgramCoursesDocument, options);
      }
export function useReportProgramCoursesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportProgramCoursesQuery, ReportProgramCoursesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportProgramCoursesQuery, ReportProgramCoursesQueryVariables>(ReportProgramCoursesDocument, options);
        }
export function useReportProgramCoursesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportProgramCoursesQuery, ReportProgramCoursesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportProgramCoursesQuery, ReportProgramCoursesQueryVariables>(ReportProgramCoursesDocument, options);
        }
export type ReportProgramCoursesQueryHookResult = ReturnType<typeof useReportProgramCoursesQuery>;
export type ReportProgramCoursesLazyQueryHookResult = ReturnType<typeof useReportProgramCoursesLazyQuery>;
export type ReportProgramCoursesSuspenseQueryHookResult = ReturnType<typeof useReportProgramCoursesSuspenseQuery>;
export type ReportProgramCoursesQueryResult = Apollo.QueryResult<ReportProgramCoursesQuery, ReportProgramCoursesQueryVariables>;
export const ReportProgramsDocument = gql`
    query reportPrograms($input: ReportProgramsInput!) {
  reportPrograms(input: $input) {
    data {
      documentId
      name
      category {
        documentId
        label
      }
      totalUsers
      completionRate
      status
    }
    meta {
      count {
        all
        active
        inactive
      }
      pagination {
        page
        pageSize
        pageCount
        total
      }
    }
  }
}
    `;
export function useReportProgramsQuery(baseOptions: Apollo.QueryHookOptions<ReportProgramsQuery, ReportProgramsQueryVariables> & ({ variables: ReportProgramsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportProgramsQuery, ReportProgramsQueryVariables>(ReportProgramsDocument, options);
      }
export function useReportProgramsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportProgramsQuery, ReportProgramsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportProgramsQuery, ReportProgramsQueryVariables>(ReportProgramsDocument, options);
        }
export function useReportProgramsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportProgramsQuery, ReportProgramsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportProgramsQuery, ReportProgramsQueryVariables>(ReportProgramsDocument, options);
        }
export type ReportProgramsQueryHookResult = ReturnType<typeof useReportProgramsQuery>;
export type ReportProgramsLazyQueryHookResult = ReturnType<typeof useReportProgramsLazyQuery>;
export type ReportProgramsSuspenseQueryHookResult = ReturnType<typeof useReportProgramsSuspenseQuery>;
export type ReportProgramsQueryResult = Apollo.QueryResult<ReportProgramsQuery, ReportProgramsQueryVariables>;
export const DownloadReportUserCourseXlsxDocument = gql`
    query downloadReportUserCourseXlsx($input: DownloadReportUserCourseXlsxInput!) {
  downloadReportUserCourseXlsx(input: $input) {
    buffer
    filename
    success
  }
}
    `;
export function useDownloadReportUserCourseXlsxQuery(baseOptions: Apollo.QueryHookOptions<DownloadReportUserCourseXlsxQuery, DownloadReportUserCourseXlsxQueryVariables> & ({ variables: DownloadReportUserCourseXlsxQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadReportUserCourseXlsxQuery, DownloadReportUserCourseXlsxQueryVariables>(DownloadReportUserCourseXlsxDocument, options);
      }
export function useDownloadReportUserCourseXlsxLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadReportUserCourseXlsxQuery, DownloadReportUserCourseXlsxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadReportUserCourseXlsxQuery, DownloadReportUserCourseXlsxQueryVariables>(DownloadReportUserCourseXlsxDocument, options);
        }
export function useDownloadReportUserCourseXlsxSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DownloadReportUserCourseXlsxQuery, DownloadReportUserCourseXlsxQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DownloadReportUserCourseXlsxQuery, DownloadReportUserCourseXlsxQueryVariables>(DownloadReportUserCourseXlsxDocument, options);
        }
export type DownloadReportUserCourseXlsxQueryHookResult = ReturnType<typeof useDownloadReportUserCourseXlsxQuery>;
export type DownloadReportUserCourseXlsxLazyQueryHookResult = ReturnType<typeof useDownloadReportUserCourseXlsxLazyQuery>;
export type DownloadReportUserCourseXlsxSuspenseQueryHookResult = ReturnType<typeof useDownloadReportUserCourseXlsxSuspenseQuery>;
export type DownloadReportUserCourseXlsxQueryResult = Apollo.QueryResult<DownloadReportUserCourseXlsxQuery, DownloadReportUserCourseXlsxQueryVariables>;
export const DownloadReportUserCoursesZipDocument = gql`
    query downloadReportUserCoursesZip($input: DownloadReportUserCoursesZipInput!) {
  downloadReportUserCoursesZip(input: $input) {
    buffer
    filename
    success
  }
}
    `;
export function useDownloadReportUserCoursesZipQuery(baseOptions: Apollo.QueryHookOptions<DownloadReportUserCoursesZipQuery, DownloadReportUserCoursesZipQueryVariables> & ({ variables: DownloadReportUserCoursesZipQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadReportUserCoursesZipQuery, DownloadReportUserCoursesZipQueryVariables>(DownloadReportUserCoursesZipDocument, options);
      }
export function useDownloadReportUserCoursesZipLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadReportUserCoursesZipQuery, DownloadReportUserCoursesZipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadReportUserCoursesZipQuery, DownloadReportUserCoursesZipQueryVariables>(DownloadReportUserCoursesZipDocument, options);
        }
export function useDownloadReportUserCoursesZipSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DownloadReportUserCoursesZipQuery, DownloadReportUserCoursesZipQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DownloadReportUserCoursesZipQuery, DownloadReportUserCoursesZipQueryVariables>(DownloadReportUserCoursesZipDocument, options);
        }
export type DownloadReportUserCoursesZipQueryHookResult = ReturnType<typeof useDownloadReportUserCoursesZipQuery>;
export type DownloadReportUserCoursesZipLazyQueryHookResult = ReturnType<typeof useDownloadReportUserCoursesZipLazyQuery>;
export type DownloadReportUserCoursesZipSuspenseQueryHookResult = ReturnType<typeof useDownloadReportUserCoursesZipSuspenseQuery>;
export type DownloadReportUserCoursesZipQueryResult = Apollo.QueryResult<DownloadReportUserCoursesZipQuery, DownloadReportUserCoursesZipQueryVariables>;
export const DownloadReportUserProgramCourseXlsxDocument = gql`
    query downloadReportUserProgramCourseXlsx($input: DownloadReportUserProgramCourseXlsxInput!) {
  downloadReportUserProgramCourseXlsx(input: $input) {
    buffer
    filename
    success
  }
}
    `;
export function useDownloadReportUserProgramCourseXlsxQuery(baseOptions: Apollo.QueryHookOptions<DownloadReportUserProgramCourseXlsxQuery, DownloadReportUserProgramCourseXlsxQueryVariables> & ({ variables: DownloadReportUserProgramCourseXlsxQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadReportUserProgramCourseXlsxQuery, DownloadReportUserProgramCourseXlsxQueryVariables>(DownloadReportUserProgramCourseXlsxDocument, options);
      }
export function useDownloadReportUserProgramCourseXlsxLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadReportUserProgramCourseXlsxQuery, DownloadReportUserProgramCourseXlsxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadReportUserProgramCourseXlsxQuery, DownloadReportUserProgramCourseXlsxQueryVariables>(DownloadReportUserProgramCourseXlsxDocument, options);
        }
export function useDownloadReportUserProgramCourseXlsxSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DownloadReportUserProgramCourseXlsxQuery, DownloadReportUserProgramCourseXlsxQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DownloadReportUserProgramCourseXlsxQuery, DownloadReportUserProgramCourseXlsxQueryVariables>(DownloadReportUserProgramCourseXlsxDocument, options);
        }
export type DownloadReportUserProgramCourseXlsxQueryHookResult = ReturnType<typeof useDownloadReportUserProgramCourseXlsxQuery>;
export type DownloadReportUserProgramCourseXlsxLazyQueryHookResult = ReturnType<typeof useDownloadReportUserProgramCourseXlsxLazyQuery>;
export type DownloadReportUserProgramCourseXlsxSuspenseQueryHookResult = ReturnType<typeof useDownloadReportUserProgramCourseXlsxSuspenseQuery>;
export type DownloadReportUserProgramCourseXlsxQueryResult = Apollo.QueryResult<DownloadReportUserProgramCourseXlsxQuery, DownloadReportUserProgramCourseXlsxQueryVariables>;
export const DownloadReportUserProgramCoursesZipDocument = gql`
    query downloadReportUserProgramCoursesZip($input: DownloadReportUserProgramCoursesZipInput!) {
  downloadReportUserProgramCoursesZip(input: $input) {
    buffer
    filename
    success
  }
}
    `;
export function useDownloadReportUserProgramCoursesZipQuery(baseOptions: Apollo.QueryHookOptions<DownloadReportUserProgramCoursesZipQuery, DownloadReportUserProgramCoursesZipQueryVariables> & ({ variables: DownloadReportUserProgramCoursesZipQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadReportUserProgramCoursesZipQuery, DownloadReportUserProgramCoursesZipQueryVariables>(DownloadReportUserProgramCoursesZipDocument, options);
      }
export function useDownloadReportUserProgramCoursesZipLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadReportUserProgramCoursesZipQuery, DownloadReportUserProgramCoursesZipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadReportUserProgramCoursesZipQuery, DownloadReportUserProgramCoursesZipQueryVariables>(DownloadReportUserProgramCoursesZipDocument, options);
        }
export function useDownloadReportUserProgramCoursesZipSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DownloadReportUserProgramCoursesZipQuery, DownloadReportUserProgramCoursesZipQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DownloadReportUserProgramCoursesZipQuery, DownloadReportUserProgramCoursesZipQueryVariables>(DownloadReportUserProgramCoursesZipDocument, options);
        }
export type DownloadReportUserProgramCoursesZipQueryHookResult = ReturnType<typeof useDownloadReportUserProgramCoursesZipQuery>;
export type DownloadReportUserProgramCoursesZipLazyQueryHookResult = ReturnType<typeof useDownloadReportUserProgramCoursesZipLazyQuery>;
export type DownloadReportUserProgramCoursesZipSuspenseQueryHookResult = ReturnType<typeof useDownloadReportUserProgramCoursesZipSuspenseQuery>;
export type DownloadReportUserProgramCoursesZipQueryResult = Apollo.QueryResult<DownloadReportUserProgramCoursesZipQuery, DownloadReportUserProgramCoursesZipQueryVariables>;
export const DownloadReportUserProgramXlsxDocument = gql`
    query downloadReportUserProgramXlsx($input: DownloadReportUserProgramXlsxInput!) {
  downloadReportUserProgramXlsx(input: $input) {
    buffer
    filename
    success
  }
}
    `;
export function useDownloadReportUserProgramXlsxQuery(baseOptions: Apollo.QueryHookOptions<DownloadReportUserProgramXlsxQuery, DownloadReportUserProgramXlsxQueryVariables> & ({ variables: DownloadReportUserProgramXlsxQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadReportUserProgramXlsxQuery, DownloadReportUserProgramXlsxQueryVariables>(DownloadReportUserProgramXlsxDocument, options);
      }
export function useDownloadReportUserProgramXlsxLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadReportUserProgramXlsxQuery, DownloadReportUserProgramXlsxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadReportUserProgramXlsxQuery, DownloadReportUserProgramXlsxQueryVariables>(DownloadReportUserProgramXlsxDocument, options);
        }
export function useDownloadReportUserProgramXlsxSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DownloadReportUserProgramXlsxQuery, DownloadReportUserProgramXlsxQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DownloadReportUserProgramXlsxQuery, DownloadReportUserProgramXlsxQueryVariables>(DownloadReportUserProgramXlsxDocument, options);
        }
export type DownloadReportUserProgramXlsxQueryHookResult = ReturnType<typeof useDownloadReportUserProgramXlsxQuery>;
export type DownloadReportUserProgramXlsxLazyQueryHookResult = ReturnType<typeof useDownloadReportUserProgramXlsxLazyQuery>;
export type DownloadReportUserProgramXlsxSuspenseQueryHookResult = ReturnType<typeof useDownloadReportUserProgramXlsxSuspenseQuery>;
export type DownloadReportUserProgramXlsxQueryResult = Apollo.QueryResult<DownloadReportUserProgramXlsxQuery, DownloadReportUserProgramXlsxQueryVariables>;
export const DownloadReportUserXlsxDocument = gql`
    query downloadReportUserXlsx($input: DownloadReportUserXlsxInput!) {
  downloadReportUserXlsx(input: $input) {
    buffer
    filename
    success
  }
}
    `;
export function useDownloadReportUserXlsxQuery(baseOptions: Apollo.QueryHookOptions<DownloadReportUserXlsxQuery, DownloadReportUserXlsxQueryVariables> & ({ variables: DownloadReportUserXlsxQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadReportUserXlsxQuery, DownloadReportUserXlsxQueryVariables>(DownloadReportUserXlsxDocument, options);
      }
export function useDownloadReportUserXlsxLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadReportUserXlsxQuery, DownloadReportUserXlsxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadReportUserXlsxQuery, DownloadReportUserXlsxQueryVariables>(DownloadReportUserXlsxDocument, options);
        }
export function useDownloadReportUserXlsxSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DownloadReportUserXlsxQuery, DownloadReportUserXlsxQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DownloadReportUserXlsxQuery, DownloadReportUserXlsxQueryVariables>(DownloadReportUserXlsxDocument, options);
        }
export type DownloadReportUserXlsxQueryHookResult = ReturnType<typeof useDownloadReportUserXlsxQuery>;
export type DownloadReportUserXlsxLazyQueryHookResult = ReturnType<typeof useDownloadReportUserXlsxLazyQuery>;
export type DownloadReportUserXlsxSuspenseQueryHookResult = ReturnType<typeof useDownloadReportUserXlsxSuspenseQuery>;
export type DownloadReportUserXlsxQueryResult = Apollo.QueryResult<DownloadReportUserXlsxQuery, DownloadReportUserXlsxQueryVariables>;
export const DownloadReportUsersCsvDocument = gql`
    query downloadReportUsersCsv($input: DownloadReportUsersCsvInput!) {
  downloadReportUsersCsv(input: $input) {
    buffer
    filename
    success
  }
}
    `;
export function useDownloadReportUsersCsvQuery(baseOptions: Apollo.QueryHookOptions<DownloadReportUsersCsvQuery, DownloadReportUsersCsvQueryVariables> & ({ variables: DownloadReportUsersCsvQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadReportUsersCsvQuery, DownloadReportUsersCsvQueryVariables>(DownloadReportUsersCsvDocument, options);
      }
export function useDownloadReportUsersCsvLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadReportUsersCsvQuery, DownloadReportUsersCsvQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadReportUsersCsvQuery, DownloadReportUsersCsvQueryVariables>(DownloadReportUsersCsvDocument, options);
        }
export function useDownloadReportUsersCsvSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DownloadReportUsersCsvQuery, DownloadReportUsersCsvQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DownloadReportUsersCsvQuery, DownloadReportUsersCsvQueryVariables>(DownloadReportUsersCsvDocument, options);
        }
export type DownloadReportUsersCsvQueryHookResult = ReturnType<typeof useDownloadReportUsersCsvQuery>;
export type DownloadReportUsersCsvLazyQueryHookResult = ReturnType<typeof useDownloadReportUsersCsvLazyQuery>;
export type DownloadReportUsersCsvSuspenseQueryHookResult = ReturnType<typeof useDownloadReportUsersCsvSuspenseQuery>;
export type DownloadReportUsersCsvQueryResult = Apollo.QueryResult<DownloadReportUsersCsvQuery, DownloadReportUsersCsvQueryVariables>;
export const DownloadReportUsersZipDocument = gql`
    query downloadReportUsersZip($input: DownloadReportUsersZipInput!) {
  downloadReportUsersZip(input: $input) {
    buffer
    filename
    success
  }
}
    `;
export function useDownloadReportUsersZipQuery(baseOptions: Apollo.QueryHookOptions<DownloadReportUsersZipQuery, DownloadReportUsersZipQueryVariables> & ({ variables: DownloadReportUsersZipQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadReportUsersZipQuery, DownloadReportUsersZipQueryVariables>(DownloadReportUsersZipDocument, options);
      }
export function useDownloadReportUsersZipLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadReportUsersZipQuery, DownloadReportUsersZipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadReportUsersZipQuery, DownloadReportUsersZipQueryVariables>(DownloadReportUsersZipDocument, options);
        }
export function useDownloadReportUsersZipSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DownloadReportUsersZipQuery, DownloadReportUsersZipQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DownloadReportUsersZipQuery, DownloadReportUsersZipQueryVariables>(DownloadReportUsersZipDocument, options);
        }
export type DownloadReportUsersZipQueryHookResult = ReturnType<typeof useDownloadReportUsersZipQuery>;
export type DownloadReportUsersZipLazyQueryHookResult = ReturnType<typeof useDownloadReportUsersZipLazyQuery>;
export type DownloadReportUsersZipSuspenseQueryHookResult = ReturnType<typeof useDownloadReportUsersZipSuspenseQuery>;
export type DownloadReportUsersZipQueryResult = Apollo.QueryResult<DownloadReportUsersZipQuery, DownloadReportUsersZipQueryVariables>;
export const ReportUserCourseDocument = gql`
    query reportUserCourse($input: ReportUserCourseInput!) {
  reportUserCourse(input: $input) {
    name
    assignedAt
    createdAt
    status
    totalChapters
    completedChapters
    totalQuizzes
    completedQuizzes
    averageQuizScore
    dateCompleted
    quizzes {
      chapter
      quizzes {
        type
        score
        required
        completionDate
      }
    }
  }
}
    `;
export function useReportUserCourseQuery(baseOptions: Apollo.QueryHookOptions<ReportUserCourseQuery, ReportUserCourseQueryVariables> & ({ variables: ReportUserCourseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportUserCourseQuery, ReportUserCourseQueryVariables>(ReportUserCourseDocument, options);
      }
export function useReportUserCourseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportUserCourseQuery, ReportUserCourseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportUserCourseQuery, ReportUserCourseQueryVariables>(ReportUserCourseDocument, options);
        }
export function useReportUserCourseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportUserCourseQuery, ReportUserCourseQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportUserCourseQuery, ReportUserCourseQueryVariables>(ReportUserCourseDocument, options);
        }
export type ReportUserCourseQueryHookResult = ReturnType<typeof useReportUserCourseQuery>;
export type ReportUserCourseLazyQueryHookResult = ReturnType<typeof useReportUserCourseLazyQuery>;
export type ReportUserCourseSuspenseQueryHookResult = ReturnType<typeof useReportUserCourseSuspenseQuery>;
export type ReportUserCourseQueryResult = Apollo.QueryResult<ReportUserCourseQuery, ReportUserCourseQueryVariables>;
export const ReportUserCourseChaptersDocument = gql`
    query reportUserCourseChapters($input: ReportUserCourseChaptersInput!) {
  reportUserCourseChapters(input: $input) {
    data {
      documentId
      name
      status
      completionDate
    }
    meta {
      pagination {
        page
        pageSize
        pageCount
        total
      }
    }
  }
}
    `;
export function useReportUserCourseChaptersQuery(baseOptions: Apollo.QueryHookOptions<ReportUserCourseChaptersQuery, ReportUserCourseChaptersQueryVariables> & ({ variables: ReportUserCourseChaptersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportUserCourseChaptersQuery, ReportUserCourseChaptersQueryVariables>(ReportUserCourseChaptersDocument, options);
      }
export function useReportUserCourseChaptersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportUserCourseChaptersQuery, ReportUserCourseChaptersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportUserCourseChaptersQuery, ReportUserCourseChaptersQueryVariables>(ReportUserCourseChaptersDocument, options);
        }
export function useReportUserCourseChaptersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportUserCourseChaptersQuery, ReportUserCourseChaptersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportUserCourseChaptersQuery, ReportUserCourseChaptersQueryVariables>(ReportUserCourseChaptersDocument, options);
        }
export type ReportUserCourseChaptersQueryHookResult = ReturnType<typeof useReportUserCourseChaptersQuery>;
export type ReportUserCourseChaptersLazyQueryHookResult = ReturnType<typeof useReportUserCourseChaptersLazyQuery>;
export type ReportUserCourseChaptersSuspenseQueryHookResult = ReturnType<typeof useReportUserCourseChaptersSuspenseQuery>;
export type ReportUserCourseChaptersQueryResult = Apollo.QueryResult<ReportUserCourseChaptersQuery, ReportUserCourseChaptersQueryVariables>;
export const ReportUserCoursesDocument = gql`
    query reportUserCourses($input: ReportUserCoursesInput!) {
  reportUserCourses(input: $input) {
    data {
      documentId
      name
      dateAssigned
      completionRate
      averageQuizScore
      status
    }
    meta {
      pagination {
        page
        pageSize
        pageCount
        total
      }
    }
  }
}
    `;
export function useReportUserCoursesQuery(baseOptions: Apollo.QueryHookOptions<ReportUserCoursesQuery, ReportUserCoursesQueryVariables> & ({ variables: ReportUserCoursesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportUserCoursesQuery, ReportUserCoursesQueryVariables>(ReportUserCoursesDocument, options);
      }
export function useReportUserCoursesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportUserCoursesQuery, ReportUserCoursesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportUserCoursesQuery, ReportUserCoursesQueryVariables>(ReportUserCoursesDocument, options);
        }
export function useReportUserCoursesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportUserCoursesQuery, ReportUserCoursesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportUserCoursesQuery, ReportUserCoursesQueryVariables>(ReportUserCoursesDocument, options);
        }
export type ReportUserCoursesQueryHookResult = ReturnType<typeof useReportUserCoursesQuery>;
export type ReportUserCoursesLazyQueryHookResult = ReturnType<typeof useReportUserCoursesLazyQuery>;
export type ReportUserCoursesSuspenseQueryHookResult = ReturnType<typeof useReportUserCoursesSuspenseQuery>;
export type ReportUserCoursesQueryResult = Apollo.QueryResult<ReportUserCoursesQuery, ReportUserCoursesQueryVariables>;
export const ReportUserProgramDocument = gql`
    query reportUserProgram($input: ReportUserProgramInput!) {
  reportUserProgram(input: $input) {
    title
    createdOn
    author
    type
    category
    stats {
      completedCourses
      totalCourses
      completedQuizzes
      totalQuizzes
      averageQuizScore
      dateCompleted
    }
  }
}
    `;
export function useReportUserProgramQuery(baseOptions: Apollo.QueryHookOptions<ReportUserProgramQuery, ReportUserProgramQueryVariables> & ({ variables: ReportUserProgramQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportUserProgramQuery, ReportUserProgramQueryVariables>(ReportUserProgramDocument, options);
      }
export function useReportUserProgramLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportUserProgramQuery, ReportUserProgramQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportUserProgramQuery, ReportUserProgramQueryVariables>(ReportUserProgramDocument, options);
        }
export function useReportUserProgramSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportUserProgramQuery, ReportUserProgramQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportUserProgramQuery, ReportUserProgramQueryVariables>(ReportUserProgramDocument, options);
        }
export type ReportUserProgramQueryHookResult = ReturnType<typeof useReportUserProgramQuery>;
export type ReportUserProgramLazyQueryHookResult = ReturnType<typeof useReportUserProgramLazyQuery>;
export type ReportUserProgramSuspenseQueryHookResult = ReturnType<typeof useReportUserProgramSuspenseQuery>;
export type ReportUserProgramQueryResult = Apollo.QueryResult<ReportUserProgramQuery, ReportUserProgramQueryVariables>;
export const ReportUserProgramCoursesDocument = gql`
    query reportUserProgramCourses($input: ReportUserProgramCoursesInput!) {
  reportUserProgramCourses(input: $input) {
    data {
      documentId
      name
      dateAssigned
      completionRate
      averageQuizScore
      status
    }
    meta {
      pagination {
        page
        pageSize
        pageCount
        total
      }
    }
  }
}
    `;
export function useReportUserProgramCoursesQuery(baseOptions: Apollo.QueryHookOptions<ReportUserProgramCoursesQuery, ReportUserProgramCoursesQueryVariables> & ({ variables: ReportUserProgramCoursesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportUserProgramCoursesQuery, ReportUserProgramCoursesQueryVariables>(ReportUserProgramCoursesDocument, options);
      }
export function useReportUserProgramCoursesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportUserProgramCoursesQuery, ReportUserProgramCoursesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportUserProgramCoursesQuery, ReportUserProgramCoursesQueryVariables>(ReportUserProgramCoursesDocument, options);
        }
export function useReportUserProgramCoursesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportUserProgramCoursesQuery, ReportUserProgramCoursesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportUserProgramCoursesQuery, ReportUserProgramCoursesQueryVariables>(ReportUserProgramCoursesDocument, options);
        }
export type ReportUserProgramCoursesQueryHookResult = ReturnType<typeof useReportUserProgramCoursesQuery>;
export type ReportUserProgramCoursesLazyQueryHookResult = ReturnType<typeof useReportUserProgramCoursesLazyQuery>;
export type ReportUserProgramCoursesSuspenseQueryHookResult = ReturnType<typeof useReportUserProgramCoursesSuspenseQuery>;
export type ReportUserProgramCoursesQueryResult = Apollo.QueryResult<ReportUserProgramCoursesQuery, ReportUserProgramCoursesQueryVariables>;
export const ReportUserProgramsDocument = gql`
    query reportUserPrograms($input: ReportUserProgramsInput!) {
  reportUserPrograms(input: $input) {
    data {
      documentId
      name
      dateAssigned
      completionRate
      averageQuizScore
      status
    }
    meta {
      pagination {
        page
        pageSize
        pageCount
        total
      }
    }
  }
}
    `;
export function useReportUserProgramsQuery(baseOptions: Apollo.QueryHookOptions<ReportUserProgramsQuery, ReportUserProgramsQueryVariables> & ({ variables: ReportUserProgramsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportUserProgramsQuery, ReportUserProgramsQueryVariables>(ReportUserProgramsDocument, options);
      }
export function useReportUserProgramsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportUserProgramsQuery, ReportUserProgramsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportUserProgramsQuery, ReportUserProgramsQueryVariables>(ReportUserProgramsDocument, options);
        }
export function useReportUserProgramsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportUserProgramsQuery, ReportUserProgramsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportUserProgramsQuery, ReportUserProgramsQueryVariables>(ReportUserProgramsDocument, options);
        }
export type ReportUserProgramsQueryHookResult = ReturnType<typeof useReportUserProgramsQuery>;
export type ReportUserProgramsLazyQueryHookResult = ReturnType<typeof useReportUserProgramsLazyQuery>;
export type ReportUserProgramsSuspenseQueryHookResult = ReturnType<typeof useReportUserProgramsSuspenseQuery>;
export type ReportUserProgramsQueryResult = Apollo.QueryResult<ReportUserProgramsQuery, ReportUserProgramsQueryVariables>;
export const ReportUsersStatsDocument = gql`
    query reportUsersStats($input: ReportUserStatsInput!) {
  reportUserStats(input: $input) {
    totalCourses
    totalPrograms
    completionRate
    averageQuizScore
  }
}
    `;
export function useReportUsersStatsQuery(baseOptions: Apollo.QueryHookOptions<ReportUsersStatsQuery, ReportUsersStatsQueryVariables> & ({ variables: ReportUsersStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportUsersStatsQuery, ReportUsersStatsQueryVariables>(ReportUsersStatsDocument, options);
      }
export function useReportUsersStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportUsersStatsQuery, ReportUsersStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportUsersStatsQuery, ReportUsersStatsQueryVariables>(ReportUsersStatsDocument, options);
        }
export function useReportUsersStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportUsersStatsQuery, ReportUsersStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportUsersStatsQuery, ReportUsersStatsQueryVariables>(ReportUsersStatsDocument, options);
        }
export type ReportUsersStatsQueryHookResult = ReturnType<typeof useReportUsersStatsQuery>;
export type ReportUsersStatsLazyQueryHookResult = ReturnType<typeof useReportUsersStatsLazyQuery>;
export type ReportUsersStatsSuspenseQueryHookResult = ReturnType<typeof useReportUsersStatsSuspenseQuery>;
export type ReportUsersStatsQueryResult = Apollo.QueryResult<ReportUsersStatsQuery, ReportUsersStatsQueryVariables>;
export const ReportUsersDocument = gql`
    query reportUsers($input: ReportUsersInput!) {
  reportUsers(input: $input) {
    data {
      documentId
      name
      group
      totalCourses
      courseCompleted
      averageQuizScore
      lastActivity
      status
    }
    meta {
      count {
        all
        stylists
        consumers
        internal
        keys
        creators
        admins
      }
      pagination {
        page
        pageSize
        pageCount
        total
      }
    }
  }
}
    `;
export function useReportUsersQuery(baseOptions: Apollo.QueryHookOptions<ReportUsersQuery, ReportUsersQueryVariables> & ({ variables: ReportUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportUsersQuery, ReportUsersQueryVariables>(ReportUsersDocument, options);
      }
export function useReportUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportUsersQuery, ReportUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportUsersQuery, ReportUsersQueryVariables>(ReportUsersDocument, options);
        }
export function useReportUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportUsersQuery, ReportUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportUsersQuery, ReportUsersQueryVariables>(ReportUsersDocument, options);
        }
export type ReportUsersQueryHookResult = ReturnType<typeof useReportUsersQuery>;
export type ReportUsersLazyQueryHookResult = ReturnType<typeof useReportUsersLazyQuery>;
export type ReportUsersSuspenseQueryHookResult = ReturnType<typeof useReportUsersSuspenseQuery>;
export type ReportUsersQueryResult = Apollo.QueryResult<ReportUsersQuery, ReportUsersQueryVariables>;
export const SingleCourseConsumerDocument = gql`
    query singleCourseConsumer($id: ID!) {
  me {
    student {
      courses(filters: {documentId: {eq: $id}}) {
        title
        lockOrder
        description
        chapters(sort: ["order:asc"]) {
          documentId
          title
          order
          videos(pagination: {limit: 1}) {
            id
          }
          quizzes(pagination: {limit: 1}) {
            id
          }
          podcasts(pagination: {limit: 1}) {
            id
          }
        }
        cover {
          url
        }
        keys {
          key
        }
      }
      completedChapters(filters: {course: {documentId: {eq: $id}}}) {
        documentId
      }
    }
  }
}
    `;
export function useSingleCourseConsumerQuery(baseOptions: Apollo.QueryHookOptions<SingleCourseConsumerQuery, SingleCourseConsumerQueryVariables> & ({ variables: SingleCourseConsumerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleCourseConsumerQuery, SingleCourseConsumerQueryVariables>(SingleCourseConsumerDocument, options);
      }
export function useSingleCourseConsumerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleCourseConsumerQuery, SingleCourseConsumerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleCourseConsumerQuery, SingleCourseConsumerQueryVariables>(SingleCourseConsumerDocument, options);
        }
export function useSingleCourseConsumerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SingleCourseConsumerQuery, SingleCourseConsumerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SingleCourseConsumerQuery, SingleCourseConsumerQueryVariables>(SingleCourseConsumerDocument, options);
        }
export type SingleCourseConsumerQueryHookResult = ReturnType<typeof useSingleCourseConsumerQuery>;
export type SingleCourseConsumerLazyQueryHookResult = ReturnType<typeof useSingleCourseConsumerLazyQuery>;
export type SingleCourseConsumerSuspenseQueryHookResult = ReturnType<typeof useSingleCourseConsumerSuspenseQuery>;
export type SingleCourseConsumerQueryResult = Apollo.QueryResult<SingleCourseConsumerQuery, SingleCourseConsumerQueryVariables>;
export const SingleProgramConsumerDocument = gql`
    query singleProgramConsumer($id: ID!) {
  me {
    student {
      programs(filters: {documentId: {eq: $id}}) {
        description
        title
        courses(
          filters: {programs: {documentId: {eq: $id}, deleted: {eq: false}}, isActive: {eq: true}, deleted: {eq: false}, courseStatus: {eq: "published"}, template: {eq: false}}
        ) {
          documentId
          title
          lockOrder
          description
          type
          courseStatus
          isActive
          category {
            label
            documentId
          }
          author {
            user {
              documentId
              firstName
              lastName
            }
          }
          chapters(sort: ["order:asc"]) {
            documentId
            title
            order
            videos(pagination: {limit: 1}) {
              id
            }
            quizzes(pagination: {limit: 1}) {
              id
            }
            podcasts(pagination: {limit: 1}) {
              id
            }
          }
          cover {
            url
            formats
          }
          keys {
            key
          }
          dateAdded
        }
        cover {
          url
          formats
        }
      }
      completedCourses(
        filters: {programs: {documentId: {eq: $id}, deleted: {eq: false}}, isActive: {eq: true}, deleted: {eq: false}, courseStatus: {eq: "published"}, template: {eq: false}}
      ) {
        documentId
      }
      completedChapters(filters: {course: {programs: {documentId: {eq: $id}}}}) {
        documentId
        title
        order
      }
    }
  }
}
    `;
export function useSingleProgramConsumerQuery(baseOptions: Apollo.QueryHookOptions<SingleProgramConsumerQuery, SingleProgramConsumerQueryVariables> & ({ variables: SingleProgramConsumerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleProgramConsumerQuery, SingleProgramConsumerQueryVariables>(SingleProgramConsumerDocument, options);
      }
export function useSingleProgramConsumerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleProgramConsumerQuery, SingleProgramConsumerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleProgramConsumerQuery, SingleProgramConsumerQueryVariables>(SingleProgramConsumerDocument, options);
        }
export function useSingleProgramConsumerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SingleProgramConsumerQuery, SingleProgramConsumerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SingleProgramConsumerQuery, SingleProgramConsumerQueryVariables>(SingleProgramConsumerDocument, options);
        }
export type SingleProgramConsumerQueryHookResult = ReturnType<typeof useSingleProgramConsumerQuery>;
export type SingleProgramConsumerLazyQueryHookResult = ReturnType<typeof useSingleProgramConsumerLazyQuery>;
export type SingleProgramConsumerSuspenseQueryHookResult = ReturnType<typeof useSingleProgramConsumerSuspenseQuery>;
export type SingleProgramConsumerQueryResult = Apollo.QueryResult<SingleProgramConsumerQuery, SingleProgramConsumerQueryVariables>;
export const StudentPassedChaptersDocument = gql`
    query studentPassedChapters($courseId: ID!) {
  me {
    student {
      chapterResults(
        filters: {courseChapter: {course: {documentId: {eq: $courseId}}}}
      ) {
        id
      }
    }
  }
}
    `;
export function useStudentPassedChaptersQuery(baseOptions: Apollo.QueryHookOptions<StudentPassedChaptersQuery, StudentPassedChaptersQueryVariables> & ({ variables: StudentPassedChaptersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StudentPassedChaptersQuery, StudentPassedChaptersQueryVariables>(StudentPassedChaptersDocument, options);
      }
export function useStudentPassedChaptersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentPassedChaptersQuery, StudentPassedChaptersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StudentPassedChaptersQuery, StudentPassedChaptersQueryVariables>(StudentPassedChaptersDocument, options);
        }
export function useStudentPassedChaptersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StudentPassedChaptersQuery, StudentPassedChaptersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StudentPassedChaptersQuery, StudentPassedChaptersQueryVariables>(StudentPassedChaptersDocument, options);
        }
export type StudentPassedChaptersQueryHookResult = ReturnType<typeof useStudentPassedChaptersQuery>;
export type StudentPassedChaptersLazyQueryHookResult = ReturnType<typeof useStudentPassedChaptersLazyQuery>;
export type StudentPassedChaptersSuspenseQueryHookResult = ReturnType<typeof useStudentPassedChaptersSuspenseQuery>;
export type StudentPassedChaptersQueryResult = Apollo.QueryResult<StudentPassedChaptersQuery, StudentPassedChaptersQueryVariables>;
export const UnlikeCommentDocument = gql`
    mutation unlikeComment($likeId: ID!) {
  deleteCommentLike(documentId: $likeId) {
    documentId
  }
}
    `;
export type UnlikeCommentMutationFn = Apollo.MutationFunction<UnlikeCommentMutation, UnlikeCommentMutationVariables>;
export function useUnlikeCommentMutation(baseOptions?: Apollo.MutationHookOptions<UnlikeCommentMutation, UnlikeCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlikeCommentMutation, UnlikeCommentMutationVariables>(UnlikeCommentDocument, options);
      }
export type UnlikeCommentMutationHookResult = ReturnType<typeof useUnlikeCommentMutation>;
export type UnlikeCommentMutationResult = Apollo.MutationResult<UnlikeCommentMutation>;
export const MeDocument = gql`
    query me {
  me {
    id
    email
    firstName
    documentId
    lastName
    student {
      documentId
    }
    avatar {
      url
    }
    confirmed
    country {
      documentId
      name
      code
      region {
        documentId
        name
      }
    }
    role {
      type
      name
    }
    avatar {
      url
      documentId
    }
    notifications {
      documentId
    }
    salonName
  }
}
    `;
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export function useMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeSuspenseQueryHookResult = ReturnType<typeof useMeSuspenseQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const MyCertificatesDocument = gql`
    query MyCertificates($input: MyCertificatesInput) {
  myCertificates(input: $input) {
    courses {
      assignedAt
      certificateId
      completedAt
      documentId
      status
      title
      totalTimeForCompleteCourse
    }
    total
    page
    pageSize
    pageCount
  }
}
    `;
export function useMyCertificatesQuery(baseOptions?: Apollo.QueryHookOptions<MyCertificatesQuery, MyCertificatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyCertificatesQuery, MyCertificatesQueryVariables>(MyCertificatesDocument, options);
      }
export function useMyCertificatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyCertificatesQuery, MyCertificatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyCertificatesQuery, MyCertificatesQueryVariables>(MyCertificatesDocument, options);
        }
export function useMyCertificatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyCertificatesQuery, MyCertificatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyCertificatesQuery, MyCertificatesQueryVariables>(MyCertificatesDocument, options);
        }
export type MyCertificatesQueryHookResult = ReturnType<typeof useMyCertificatesQuery>;
export type MyCertificatesLazyQueryHookResult = ReturnType<typeof useMyCertificatesLazyQuery>;
export type MyCertificatesSuspenseQueryHookResult = ReturnType<typeof useMyCertificatesSuspenseQuery>;
export type MyCertificatesQueryResult = Apollo.QueryResult<MyCertificatesQuery, MyCertificatesQueryVariables>;
export const MyProgramCertificatesDocument = gql`
    query MyProgramCertificates($input: MyCertificatesInput) {
  myProgramCertificates(input: $input) {
    page
    pageCount
    pageSize
    programs {
      assignedAt
      certificateId
      completedAt
      documentId
      status
      title
      totalTimeForCompleteCourse
    }
    total
  }
}
    `;
export function useMyProgramCertificatesQuery(baseOptions?: Apollo.QueryHookOptions<MyProgramCertificatesQuery, MyProgramCertificatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyProgramCertificatesQuery, MyProgramCertificatesQueryVariables>(MyProgramCertificatesDocument, options);
      }
export function useMyProgramCertificatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyProgramCertificatesQuery, MyProgramCertificatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyProgramCertificatesQuery, MyProgramCertificatesQueryVariables>(MyProgramCertificatesDocument, options);
        }
export function useMyProgramCertificatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyProgramCertificatesQuery, MyProgramCertificatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyProgramCertificatesQuery, MyProgramCertificatesQueryVariables>(MyProgramCertificatesDocument, options);
        }
export type MyProgramCertificatesQueryHookResult = ReturnType<typeof useMyProgramCertificatesQuery>;
export type MyProgramCertificatesLazyQueryHookResult = ReturnType<typeof useMyProgramCertificatesLazyQuery>;
export type MyProgramCertificatesSuspenseQueryHookResult = ReturnType<typeof useMyProgramCertificatesSuspenseQuery>;
export type MyProgramCertificatesQueryResult = Apollo.QueryResult<MyProgramCertificatesQuery, MyProgramCertificatesQueryVariables>;
export const MyStatsDocument = gql`
    query myStats($input: MyStatsInput!) {
  myStats(input: $input) {
    assignedCourses
    completedCourses
    totalQuizzes
    correctQuizzes
    completeCoursesPerMonth
  }
}
    `;
export function useMyStatsQuery(baseOptions: Apollo.QueryHookOptions<MyStatsQuery, MyStatsQueryVariables> & ({ variables: MyStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyStatsQuery, MyStatsQueryVariables>(MyStatsDocument, options);
      }
export function useMyStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyStatsQuery, MyStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyStatsQuery, MyStatsQueryVariables>(MyStatsDocument, options);
        }
export function useMyStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyStatsQuery, MyStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyStatsQuery, MyStatsQueryVariables>(MyStatsDocument, options);
        }
export type MyStatsQueryHookResult = ReturnType<typeof useMyStatsQuery>;
export type MyStatsLazyQueryHookResult = ReturnType<typeof useMyStatsLazyQuery>;
export type MyStatsSuspenseQueryHookResult = ReturnType<typeof useMyStatsSuspenseQuery>;
export type MyStatsQueryResult = Apollo.QueryResult<MyStatsQuery, MyStatsQueryVariables>;
export const ResetPasswordDocument = gql`
    mutation resetPassword($code: String!, $password: String!, $passwordConfirmation: String!) {
  resetPassword(
    code: $code
    password: $password
    passwordConfirmation: $passwordConfirmation
  ) {
    user {
      id
    }
  }
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export const UserRegistrationStatusDocument = gql`
    query userRegistrationStatus($email: String!) {
  userRegistrationStatus(input: {email: $email}) {
    confirmed
    blocked
    codeSentAt
    language
    isSelfSignup
  }
}
    `;
export function useUserRegistrationStatusQuery(baseOptions: Apollo.QueryHookOptions<UserRegistrationStatusQuery, UserRegistrationStatusQueryVariables> & ({ variables: UserRegistrationStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserRegistrationStatusQuery, UserRegistrationStatusQueryVariables>(UserRegistrationStatusDocument, options);
      }
export function useUserRegistrationStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserRegistrationStatusQuery, UserRegistrationStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserRegistrationStatusQuery, UserRegistrationStatusQueryVariables>(UserRegistrationStatusDocument, options);
        }
export function useUserRegistrationStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserRegistrationStatusQuery, UserRegistrationStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserRegistrationStatusQuery, UserRegistrationStatusQueryVariables>(UserRegistrationStatusDocument, options);
        }
export type UserRegistrationStatusQueryHookResult = ReturnType<typeof useUserRegistrationStatusQuery>;
export type UserRegistrationStatusLazyQueryHookResult = ReturnType<typeof useUserRegistrationStatusLazyQuery>;
export type UserRegistrationStatusSuspenseQueryHookResult = ReturnType<typeof useUserRegistrationStatusSuspenseQuery>;
export type UserRegistrationStatusQueryResult = Apollo.QueryResult<UserRegistrationStatusQuery, UserRegistrationStatusQueryVariables>;
export const UserDocument = gql`
    query User($documentId: ID!) {
  usersPermissionsUser(documentId: $documentId) {
    id
    email
    firstName
    lastName
    country {
      documentId
      name
      code
      region {
        documentId
        name
        abbreviation
      }
    }
    blocked
    confirmed
    dateAdded
    updatedAt
    role {
      type
      name
    }
    avatar {
      documentId
      url
    }
    entry {
      entryDate
      totalEntries
    }
  }
}
    `;
export function useUserQuery(baseOptions: Apollo.QueryHookOptions<UserQuery, UserQueryVariables> & ({ variables: UserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserQuery, UserQueryVariables>(UserDocument, options);
      }
export function useUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export function useUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserSuspenseQueryHookResult = ReturnType<typeof useUserSuspenseQuery>;
export type UserQueryResult = Apollo.QueryResult<UserQuery, UserQueryVariables>;
export const UsersDocument = gql`
    query users($filters: UsersPermissionsUserFiltersInput, $pagination: PaginationArg, $sort: [String]) {
  usersPermissionsUsers_connection(
    filters: $filters
    pagination: $pagination
    sort: $sort
  ) {
    nodes {
      id
      documentId
      username
      email
      confirmed
      blocked
      firstName
      lastName
      country {
        documentId
        name
        code
        region {
          name
          abbreviation
        }
      }
      role {
        documentId
        name
        type
      }
      language
      dateAdded
    }
    pageInfo {
      pageCount
      page
      pageSize
      total
    }
  }
}
    `;
export function useUsersQuery(baseOptions?: Apollo.QueryHookOptions<UsersQuery, UsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
      }
export function useUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersQuery, UsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
        }
export function useUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UsersQuery, UsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
        }
export type UsersQueryHookResult = ReturnType<typeof useUsersQuery>;
export type UsersLazyQueryHookResult = ReturnType<typeof useUsersLazyQuery>;
export type UsersSuspenseQueryHookResult = ReturnType<typeof useUsersSuspenseQuery>;
export type UsersQueryResult = Apollo.QueryResult<UsersQuery, UsersQueryVariables>;
export const UsersPermissionsUsersDocument = gql`
    query usersPermissionsUsers($filters: UsersPermissionsUserFiltersInput, $pagination: PaginationArg, $sort: [String]) {
  usersPermissionsUsers(filters: $filters, pagination: $pagination, sort: $sort) {
    id
    documentId
    username
    email
    confirmed
    blocked
    firstName
    lastName
    country {
      documentId
      name
      code
      region {
        name
        abbreviation
      }
    }
    language
    createdAt
  }
}
    `;
export function useUsersPermissionsUsersQuery(baseOptions?: Apollo.QueryHookOptions<UsersPermissionsUsersQuery, UsersPermissionsUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersPermissionsUsersQuery, UsersPermissionsUsersQueryVariables>(UsersPermissionsUsersDocument, options);
      }
export function useUsersPermissionsUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersPermissionsUsersQuery, UsersPermissionsUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersPermissionsUsersQuery, UsersPermissionsUsersQueryVariables>(UsersPermissionsUsersDocument, options);
        }
export function useUsersPermissionsUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UsersPermissionsUsersQuery, UsersPermissionsUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UsersPermissionsUsersQuery, UsersPermissionsUsersQueryVariables>(UsersPermissionsUsersDocument, options);
        }
export type UsersPermissionsUsersQueryHookResult = ReturnType<typeof useUsersPermissionsUsersQuery>;
export type UsersPermissionsUsersLazyQueryHookResult = ReturnType<typeof useUsersPermissionsUsersLazyQuery>;
export type UsersPermissionsUsersSuspenseQueryHookResult = ReturnType<typeof useUsersPermissionsUsersSuspenseQuery>;
export type UsersPermissionsUsersQueryResult = Apollo.QueryResult<UsersPermissionsUsersQuery, UsersPermissionsUsersQueryVariables>;
export const ValidateQuizDocument = gql`
    mutation ValidateQuiz($input: ValidateQuizzesInput!) {
  validateQuizzes(input: $input) {
    message
    status
    isLast
  }
}
    `;
export type ValidateQuizMutationFn = Apollo.MutationFunction<ValidateQuizMutation, ValidateQuizMutationVariables>;
export function useValidateQuizMutation(baseOptions?: Apollo.MutationHookOptions<ValidateQuizMutation, ValidateQuizMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateQuizMutation, ValidateQuizMutationVariables>(ValidateQuizDocument, options);
      }
export type ValidateQuizMutationHookResult = ReturnType<typeof useValidateQuizMutation>;
export type ValidateQuizMutationResult = Apollo.MutationResult<ValidateQuizMutation>;